module.exports = {
	"type": "Feature Collection",
	"features": [
		{
			"type": "Feature",
			"id": "ER-PLM0",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9496458,
					38.91950016,
					2803.56
				]
			},
			"properties": {
				"contact": {
					"name": "Tetsu Tokunaga",
					"email": "tktokunaga@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-PLM0",
				"name": "Hillslope auger soil samples",
				"category": "SFA Intensive",
				"instrumentation": "Borehole with Gas Samplers, Water Samplers,Soil Moisture sensors (Matric Potential, TDR), thermistors, piezometer. Click <a href=\"https://drive.google.com/open?id=0B5RSGI83Og11bl9FbTVYT0R4UUE\">here</a> for drilling log. Click <a href=\"https://drive.google.com/open?id=0B5RSGI83Og11T3NuVFZZck1NNDQ\">here</a> for instrumentation depths.",
				"research_theme": "Subsurface water and carbon inventories and fluxes",
				"description": "Information needed to quantify water and gas phase flow and transport in the subsurface is being obtained through measurements of profile physical and biogeochemical characteristics, wetting-drying trends, composition of aqueous and gas phases",
				"variables_measured": "Soil/sediment Temperature; matric potentials; water levels; hydraulic potentials; water content changes; pore water chemical composition; pore gas composition; surface soil CO2 fluxes",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PLM1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9492731,
					38.91977114,
					2787.16
				]
			},
			"properties": {
				"contact": {
					"name": "Tetsu Tokunaga",
					"email": "tktokunaga@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-PLM1",
				"name": "Hillslope Borehole (M1)",
				"category": "SFA Intensive",
				"instrumentation": "Borehole with Gas Samplers, Water Samplers,Soil Moisture sensors (Matric Potential, TDR), thermistors, piezometer. Click <a href=\"https://drive.google.com/open?id=0B5RSGI83Og11bl9FbTVYT0R4UUE\">here</a> for drilling log. Click <a href=\"https://drive.google.com/open?id=0B5RSGI83Og11T3NuVFZZck1NNDQ\">here</a> for instrumentation depths.",
				"research_theme": "Subsurface water and carbon inventories and fluxes",
				"description": "Information needed to quantify water and gas phase flow and transport in the subsurface is being obtained through measurements of profile physical and biogeochemical characteristics, wetting-drying trends, composition of aqueous and gas phases",
				"variables_measured": "Soil/sediment Temperature; matric potentials; water levels; hydraulic potentials; water content changes; pore water chemical composition; pore gas composition; surface soil CO2 fluxes",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-PLM1_1DHl4dNQEK1Jb1bRRq2j2DvLeu9L-gc1q",
						"ER-PLM1_1Ig4tDFrLfYpclSnHsW4YeEoNuNFcwR8r",
						"ER-PLM1_1Df8i_qTutb-lKvBamkcBaeYS7Wlnx4Pr"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PLM2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9487135,
					38.92015681,
					2777.25
				]
			},
			"properties": {
				"contact": {
					"name": "Tetsu Tokunaga",
					"email": "tktokunaga@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-PLM2",
				"name": "Hillslope Borehole (M2)",
				"category": "SFA Intensive",
				"instrumentation": "Borehole with Gas Samplers, Water Samplers,Soil Moisture sensors (Matric Potential, TDR), thermistors. Click <a href=\"https://drive.google.com/open?id=0B5RSGI83Og11SHprMkd0a2ZWUUU\">here</a> for drilling log. Click <a href=\"https://drive.google.com/open?id=0B5RSGI83Og11T3NuVFZZck1NNDQ\">here</a> for instrumentation depths.",
				"research_theme": "Subsurface water and carbon inventories and fluxes",
				"description": "Information needed to quantify water and gas phase flow and transport in the subsurface is being obtained through measurements of profile physical and biogeochemical characteristics, wetting-drying trends, composition of aqueous and gas phases",
				"variables_measured": "Soil/sediment Temperature; matric potentials; hydraulic potentials; water content changes; pore water chemical composition; pore gas composition; surface soil CO2 fluxes",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-PLM2_1z9BUKgabfr1vLS8DQ_6yYTn7UroR0vlT",
						"ER-PLM2_1Rqjtly5iPAoC-O5k-VK7OBRL4Fv_3A3v"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PLM3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9483668,
					38.92078433,
					2759.69
				]
			},
			"properties": {
				"contact": {
					"name": "Tetsu Tokunaga",
					"email": "tktokunaga@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-PLM3",
				"name": "Hillslope Borehole (M3)",
				"category": "SFA Intensive",
				"instrumentation": "Borehole with Gas Samplers, Water Samplers,Soil Moisture sensors (Matric Potential, TDR), thermistors. Click <a href=\"https://drive.google.com/file/d/0B5RSGI83Og11Y3RkM0JQNXJDUmc/view?usp=sharing\">here</a> for drilling log. Click <a href=\"https://drive.google.com/open?id=0B5RSGI83Og11T3NuVFZZck1NNDQ\">here</a> for instrumentation depths.",
				"research_theme": "Subsurface water and carbon inventories and fluxes",
				"description": "Information needed to quantify water and gas phase flow and transport in the subsurface is being obtained through measurements of profile physical and biogeochemical characteristics, wetting-drying trends, composition of aqueous and gas phases",
				"variables_measured": "Soil/sediment Temperature; matric potentials; hydraulic potentials; water content changes; pore water chemical composition; pore gas composition; surface soil CO2 fluxes",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-PLM3_1jk-ZktIfdcILcUL3oJxwveeNNxVCM9oj",
						"ER-PLM3_1Ttsrqq9EptJX65fC73jBzbTfLS5Rwdsu"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PLM4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9479528,
					38.92100596,
					2757.43
				]
			},
			"properties": {
				"contact": {
					"name": "Tetsu Tokunaga",
					"email": "tktokunaga@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-PLM4",
				"name": "Hillslope monitoring site (M4)",
				"category": "SFA Intensive",
				"instrumentation": "Shallow Gas Samplers, Water Samplers,Soil Moisture sensors (Matric Potential, TDR), thermistors individually installed (no borehole). Click <a href=\"hhttps://drive.google.com/file/d/0B5RSGI83Og11TkZlUFM5a1ctQ00/view?usp=sharing\">here</a> for drilling log. Click <a href=\"https://drive.google.com/open?id=0B5RSGI83Og11T3NuVFZZck1NNDQ\">here</a> for instrumentation depths.",
				"research_theme": "Subsurface water and carbon inventories and fluxes",
				"description": "Information needed to quantify water and gas phase flow and transport in the subsurface is being obtained through measurements of profile physical and biogeochemical characteristics, wetting-drying trends, composition of aqueous and gas phases",
				"variables_measured": "Soil/sediment Temperature; matric potentials; hydraulic potentials; water content changes; pore water chemical composition; pore gas composition; surface soil CO2 fluxes",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-PLM4_1JoonMxxHy-lUDl7QZRvJ-ejJofgV4R0G"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PLM5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9490082,
					38.91993899,
					2783.11
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-PLM5",
				"name": "Hillslope well (PLM5)",
				"category": "SFA Intensive",
				"instrumentation": "Deep groundwater monitoring well",
				"research_theme": "Deep shale bedrock hydrology and geochemistry",
				"description": "Hillslope drilling location used to collect continuous core over the 0 to 10-m depth interval and to install a groundwater monitoring well used to measure sesonal variations in groundwater elevation and solute composition. Groundwater sampling depth is 7.6-m below ground surface.",
				"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Dissolved Total Nitrogen (DTN); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PLM6",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9484325,
					38.92079804,
					2759.65
				]
			},
			"properties": {
				"contact": {
					"name": "Tetsu Tokunaga",
					"email": "tktokunaga@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-PLM6",
				"name": "Hillslope well (M6)",
				"category": "SFA Intensive",
				"instrumentation": "Shallow groundwater monitoring well. Click <a href=\"https://drive.google.com/open?id=0B5RSGI83Og11VklCVlRwbnFzZmRXcXlPWWpmWi1PQ2pnSExF\">here</a> for borehole log.",
				"research_theme": "Subsurface water and carbon inventories and fluxes",
				"description": "Hillslope drilling location used to collect continuous core over the 0 to 10-m depth interval and to install a groundwater monitoring well used to measure sesonal variations in groundwater elevation and solute composition. Groundwater sampling depth is 7.6-m below ground surface.",
				"variables_measured": "Water Level; Electrical Conductivity (EC);",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-PLM6_1DCRaVpzbA5cY_Msu2O1p2xANoS29VbPS"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PLM7",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9489495,
					38.91990393,
					2782.86
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-PLM7",
				"name": "Hillslope well (PLM7)",
				"category": "SFA Intensive",
				"instrumentation": "Deep groundwater monitoring well",
				"research_theme": "Deep shale bedrock hydrology and geochemistry",
				"description": "Hillslope drilling location used to install a 70-m, 3\" screened borehole for hydrologic testing and moniotirng and geochemical sampling.",
				"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Dissolved Total Nitrogen (DTN); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-PLM7_1ypKvvJqeBFFKQ0X4WceQi4obtzMxX-BV"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PLM8",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9471077,
					38.92256571,
					2760.84
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-PLM8",
				"name": "Hillslope well (PLM8)",
				"category": "SFA Intensive",
				"instrumentation": "Deep groundwater monitoring well",
				"research_theme": "Deep shale bedrock hydrology and geochemistry",
				"description": "Hillslope drilling location used to collect continuous core over the 3-22m depth interval and installation of a 3\" screened borehole for hydrologic testing and moniotirng and geochemical sampling.",
				"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Dissolved Total Nitrogen (DTN); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-PLM8_1KIxGYic47rh8iFEQFYRV6DOIg_qu1-mp"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PLM9",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9470843,
					38.92255708,
					2760.85
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-PLM9",
				"name": "Hillslope well (PLM9)",
				"category": "SFA Intensive",
				"instrumentation": "Shallow groundwater monitoring well",
				"research_theme": "Deep shale bedrock hydrology and geochemistry",
				"description": "Hillslope drilling location used to collect continuous core over the 3-22m depth interval and installation of a 3\" screened borehole for hydrologic testing and moniotirng and geochemical sampling.",
				"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Dissolved Total Nitrogen (DTN); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-PLM9_1AWokwE0jGeAWSrkgDo7aHP8W8CphDOFs"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-GLS1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0021174,
					38.97757966,
					2925.04
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-GLS1",
				"name": "Gothic Lower Subalpine",
				"category": "SFA Satellite Site",
				"instrumentation": "Deep groundwater monitoring well",
				"research_theme": "Solute composition of deep groundwater",
				"description": "Data used to constrain temporal variations in geochemical composition of deep groundwater within the Mancos Shale. Well depth is 200-ft with the production zone unknown.",
				"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Dissolved Total Nitrogen (DTN); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-GLS1_1kakMTKZyBgPBuqJVibVpFEJCr5kdRiOA"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-GUM1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9923898,
					38.95504938,
					2894.54
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-GUM1",
				"name": "Gothic Upper Montane-1",
				"category": "SFA Satellite Site",
				"instrumentation": "Deep groundwater monitoring well",
				"research_theme": "Solute composition of deep groundwater",
				"description": "Data used to constrain temporal variations in geochemical composition of deep groundwater within the Mancos Shale. Well depth is 200-ft with the production zone unknown.",
				"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Dissolved Total Nitrogen (DTN); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-GUM1_1c0VY7VgJXkJcReKGNHRllcR-zgy9UntY"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-IRW1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.099899,
					38.875618,
					3141.92
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-IRW1",
				"name": "Irwin Well",
				"category": "SFA Satellite Site",
				"instrumentation": "Deep groundwater monitoring well",
				"research_theme": "Solute composition of deep groundwater",
				"description": "Data used to constrain temporal variations in geochemical composition of deep groundwater within the Mancos Shale. Well depth is 200-ft with the production zone unknown.",
				"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Dissolved Total Nitrogen (DTN); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-INY1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9868278,
					38.95516944,
					2905.13
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-INY1",
				"name": "Inouye Well",
				"category": "SFA Satellite Site",
				"instrumentation": "Deep groundwater monitoring well",
				"research_theme": "Solute composition of deep groundwater",
				"description": "Data used to constrain temporal variations in geochemical composition of deep groundwater within the Mancos Shale. Well depth is 200-ft with the production zone unknown.",
				"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Total Iron (Fe); Calcium (Ca); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Arsenic (As); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Total Phosphorous (P); Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Water - Deuterium (dD); Water - d18O; Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-RBL1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9896811,
					38.9587928,
					2889.89
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-RBL1",
				"name": "RMBL Well",
				"category": "SFA Satellite Site",
				"instrumentation": "Deep groundwater monitoring well",
				"research_theme": "Solute composition of deep groundwater",
				"description": "Data used to constrain temporal variations in geochemical composition of deep groundwater within a confined layer sandstone interbed aquifer of the Mancos Shale. Well depth is 200 ft with the production zone from 160 to 200-ft. Samples for geochemical analysis are collected at ground surface due to artesian flow from the aquifer.",
				"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Total Iron (Fe); Calcium (Ca); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Arsenic (As); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Total Phosphorous (P); Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Water - Deuterium (dD); Water - d18O; Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-RBL1_1YqONoeAgGi9Si2GNTKLRIK42To9evQ7u",
						"ER-RBL1_1cJ1OiF7IENtxOHbfSYRWyZEgkUdZtn4F"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-RCK1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0055887,
					38.98166807,
					2933.69
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-RCK1",
				"name": "Rock Creek",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location, Discharge transducer",
				"research_theme": "Surface discharge and solute flux",
				"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. Rating curved approach applied to pressure transducer data.",
				"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-RCK1_1ivpBjVxrUm4TLEXTOrkI5CEE6FRCsGsf"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-RUS1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.007755,
					38.98893967,
					2952.39
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-RUS1",
				"name": "Rustlers Gulch",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location, Discharge transducer",
				"research_theme": "Surface discharge and solute flux",
				"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. Rating curved approach applied to pressure transducer data.",
				"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-RUS1_1OIeaRvvdHvD5p3uPJDZSVGBlA0BXVno_",
						"ER-RUS1_1ohNTLHoppzt0PVq2rMK6dnDlknjwMwht",
						"ER-RUS1_1BTMfEXu88ZC6D5upFaILb-QYccTJ-Ro2",
						"ER-RUS1_1XzC1308rUUeFMQmw8E-fkQ55HHEqplbw"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SHM1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9895197,
					38.94540579,
					2879.75
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SHM1",
				"name": "Shumway Well",
				"category": "SFA Satellite Site",
				"instrumentation": "Deep groundwater monitoring well",
				"research_theme": "Variations in groundwater elevation and solute composition",
				"description": "221 ft (well currently not being used for water production; production zone unknown)",
				"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Total Iron (Fe); Calcium (Ca); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Arsenic (As); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Total Phosphorous (P); Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Water - Deuterium (dD); Water - d18O; Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SNI1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9798065,
					38.92619374,
					3145.58
				]
			},
			"properties": {
				"contact": {
					"name": "Matthias Sprenger",
					"email": "msprenger@lbl.gov",
					"affiliation": "LBNL EESA"
				},
				"id": "SG-SNI1",
				"name": "Snodgrass Borehole 1",
				"category": "SFA Intensive",
				"instrumentation": "Borehole with Gas Samplers, Water Samplers,Soil Matric Potential Sensors, thermistors, piezometer",
				"research_theme": "Subsurface water and solute inventories and fluxes",
				"description": "Information needed to quantify water and gas phase flow and transport in the subsurface is being obtained through measurements of profile physical and biogeochemical characteristics, wetting-drying trends, composition of aqueous and gas phases",
				"variables_measured": "Pore water temperature; matric potentials; water levels; pore water chemical composition; pore gas composition",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"SG-SNI1_1GD0L15_EP_zsxG8I7yC_4iCSD7PDhbh_"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SNI2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9766448,
					38.92577653,
					3123.97
				]
			},
			"properties": {
				"contact": {
					"name": "Matthias Sprenger",
					"email": "msprenger@lbl.gov",
					"affiliation": "LBNL EESA"
				},
				"id": "SG-SNI2",
				"name": "Snodgrass Borehole 2",
				"category": "SFA Intensive",
				"instrumentation": "Borehole with Gas Samplers, Water Samplers,Soil Matric Potential Sensors, thermistors, piezometer",
				"research_theme": "Subsurface water and solute inventories and fluxes",
				"description": "Information needed to quantify water and gas phase flow and transport in the subsurface is being obtained through measurements of profile physical and biogeochemical characteristics, wetting-drying trends, composition of aqueous and gas phases",
				"variables_measured": "Pore water temperature; matric potentials; water levels; pore water chemical composition; pore gas composition",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"SG-SNI2_1FwnVgeFB0GpzEdjUBuvM09VPagZ_-cdv"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SNI3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9709078,
					38.92552828,
					3021.25
				]
			},
			"properties": {
				"contact": {
					"name": "Matthias Sprenger",
					"email": "msprenger@lbl.gov",
					"affiliation": "LBNL EESA"
				},
				"id": "SG-SNI3",
				"name": "Snodgrass Borehole 3",
				"category": "SFA Intensive",
				"instrumentation": "Borehole with Gas Samplers, Water Samplers,Soil Matric Potential Sensors, thermistors, piezometer",
				"research_theme": "Subsurface water and solute inventories and fluxes",
				"description": "Information needed to quantify water and gas phase flow and transport in the subsurface is being obtained through measurements of profile physical and biogeochemical characteristics, wetting-drying trends, composition of aqueous and gas phases",
				"variables_measured": "Pore water temperature; matric potentials; water levels; pore water chemical composition; pore gas composition",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"SG-SNI3_1ZZqFlY8qPbPgsF1al8_bmeZPD76seTrJ",
						"SG-SNI3_1L7ksbmn65NwDC05Bz0Qqex7AINgaZAeO",
						"SG-SNI3_1zIbU3MPWQIcnH_F7DYGlhL4PvfcRwjLo",
						"SG-SNI3_1Is2b80PfDj8yzd4j0pVc7MLFMNfRO8KL"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SNI4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9861055,
					38.93233584,
					3358.96
				]
			},
			"properties": {
				"contact": {
					"name": "Matthias Sprenger",
					"email": "msprenger@lbl.gov",
					"affiliation": "LBNL EESA"
				},
				"id": "SG-SNI4",
				"name": "Snodgrass Borehole 4",
				"category": "SFA Intensive",
				"instrumentation": "Borehole with Gas Samplers, Water Samplers,Soil Matric Potential Sensors, thermistors",
				"research_theme": "Subsurface water and solute inventories and fluxes",
				"description": "Information needed to quantify water and gas phase flow and transport in the subsurface is being obtained through measurements of profile physical and biogeochemical characteristics, wetting-drying trends, composition of aqueous and gas phases",
				"variables_measured": "Pore water temperature; matric potentials; pore water chemical composition; pore gas composition",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"SG-SNI4_1zh6BrWWyDtiriDnL8Ig1YkOVE56bYmPv",
						"SG-SNI4_1kpXzr_vGy_gWtPr7eVwMCoLSlsKBWtEI",
						"SG-SNI4_1OtwbUipI5wa_2x56RFvo-jYp6wyrOquA",
						"SG-SNI4_1CUdYvu_GEzg97KRjJehBYKCQJ9KgYjfh"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PHF0",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9508278,
					38.92244722,
					2759.57
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-PHF0",
				"name": "Pumphouse ISCO",
				"category": "SFA Intensive",
				"instrumentation": "ISCO Stream Sampler, Discharge transducer",
				"research_theme": "Surface discharge and solute flux",
				"description": "Data used to quantify integrated watershed processes. Discharge calculations based on a rating cuve approach. Two ISCOs serve the site. One to collect anions, cations, trace metals, DIC and NOPC. The second collects samples for stable isotopes with each bottle filled with approx. 2 cm oil to minimize evaproation between sample retrival.  ISCOs collect from the stream during ice-free days (April through October) and sample from winter storage (WS) November through March.",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": [
						"ER-PHF0_1SUNKjCfCU105x69XIkqnfnwEV0TRiwDm",
						"ER-PHF0_1AjzaqW2975cRaNzzSISAsDcbb8Uj9_0i"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PHF1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.951405,
					38.922353,
					2759.54
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-PHF1",
				"name": "Pumphouse YSI",
				"category": "SFA Intensive",
				"instrumentation": "YSI Sonde",
				"research_theme": "Stream water quality parameters",
				"description": "Multi-parameter probe installed within the East River water column adjacent to the ER-PHF0 discharge transducer measuring the following water quality paramters at 5-minute intervals: pH, oxidation reduction potential (ORP), temperature, fluid conductivity, water column height, dissolved oxygen, fluorescent dissolved organic matter (fDOM), turbidity.",
				"variables_measured": "Water Temperature; Electrical Conductivity (EC); pH; Redox Potential (ORP); Water Level; Total Dissolved Solids (TDS); Dissolved Oxygen (DO); Colored Dissolved Organic Matter (FDOM); Turbidity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-PHF1_1aNmd-9OBx33o3jfwjkcFwpfc3TFWeSqk"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SUF1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9772066,
					38.9225152,
					3070.06
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SG-SUF1",
				"name": "Snodgrass Upper Flume",
				"category": "SFA Intensive",
				"instrumentation": "Stream flume",
				"research_theme": "Surface discharge and solute flux",
				"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. Discharge data determined through direct measurement via stream flume",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-AVY1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9973282,
					38.97521672,
					2923.93
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-AVY1",
				"name": "Avery Creek",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location, Discharge transducer",
				"research_theme": "Surface discharge and solute flux",
				"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. Rating curved approach applied to pressure transducer data.",
				"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-AVY1_1nnkbVSeckmOCSVbiPAJlpWE0TcH0m1xF",
						"ER-AVY1_1HFoba3DfET07yAfpMYgob55oZF1jQH0Z"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-BCC0",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9094606,
					38.88659938,
					2722.2
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-BCC0",
				"name": "Brush Creek Confluence ISCO",
				"category": "SFA Satellite Site",
				"instrumentation": "ISCO Stream Sampler",
				"research_theme": "Surface water solute flux",
				"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. The ISCO was deployed during ice-free conditions in 2015. Data window: April 3, 2015 to October 24, 2015.",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Total Iron (Fe); Calcium (Ca); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Arsenic (As); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Total Phosphorous (P); Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Phosphate (PO4)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-BCC0_1rmKoACou7XMB5MmaYYBEutbkPYBTfjLY",
						"ER-BCC0_1f3GdVRWTQS6AMq3pHUO8eF_i9H_cMBTX",
						"ER-BCC0_1IZPq1EJPIq3_rZt8wC5w6o-FIHHj1yG9",
						"ER-BCC0_13ztzLwVTVcTDYYH8DfJ-CL-t77N3xx2q"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-BRD1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0048454,
					38.98540925,
					2939.9
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-BRD1",
				"name": "Bradley Creek",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location, Discharge transducer",
				"research_theme": "Surface discharge and solute flux",
				"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. Rating curved approach applied to pressure transducer data.",
				"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-BRD1_1YrnvDmmLbq_m7pckHaqEK9zRAZxc1hej"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-BTH1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9923154,
					38.96082622,
					2900.65
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-BTH1",
				"name": "Benthette Brook",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location, Discharge transducer",
				"research_theme": "Surface discharge and solute flux",
				"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. Rating curved approach applied to pressure transducer data. Data window: July 30, 2014 to October 19, 2016.",
				"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "Coal-11",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.033615,
					38.863696,
					2838.72
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "Coal-11",
				"name": "Coal-11",
				"category": "SFA Satellite Site",
				"instrumentation": "ISCO Stream Sampler during ice free conditions; direct sampling from stream water at other times",
				"research_theme": "Surface discharge and solute flux",
				"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale.",
				"variables_measured": "Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-CPR1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.988286,
					38.95705903,
					2884.74
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-CPR1",
				"name": "Copper Creek",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location, Discharge transducer",
				"research_theme": "Surface discharge and solute flux",
				"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. Rating curved approach applied to pressure transducer data.",
				"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-CPR1_1YABLBd05P-y8NhdOQJb4Y_ruc95IwAit"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-EAQ1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0145513,
					38.99518558,
					2983.96
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-EAQ1",
				"name": "East River above Quigley Creek",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location, Discharge transducer",
				"research_theme": "Surface discharge and solute flux",
				"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale.  Rating curved approach applied to pressure transducer data.",
				"variables_measured": "Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-EAQ1_1iAT3Un1XYN79br8b27e2aGHBNWpG6ht4"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-EBC0",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9894862,
					38.95242537,
					2864.92
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-EBC0",
				"name": "East River below Copper Creek ISCO",
				"category": "SFA Satellite Site",
				"instrumentation": "ISCO Stream Sampler",
				"research_theme": "Surface discharge and solute flux",
				"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. The ISCO is deployed during ice-free conditions in 2015 and 2016. Data windows: April 5 to September 20, 2015; May 28 to September 27, 2016.",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Total Iron (Fe); Calcium (Ca); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Arsenic (As); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Total Phosphorous (P); Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-EBC0_1VC-KmuX1iROuujgfWarajGUvaXiMyQLm"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-EBC1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9894862,
					38.95242537,
					2864.92
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-EBC1",
				"name": "East River below Copper Creek",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location, Discharge transducer",
				"research_theme": "Surface discharge and solute flux",
				"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. Rating curved approach applied to pressure transducer data.",
				"variables_measured": "Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P); Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-EBC1_1sjwAulA3mjsE1OfJ2KdGVOHeMEcGbRQW"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-YUL0",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9908336,
					38.9576942,
					2882.7
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-YUL0",
				"name": "Yule ISCO",
				"category": "SFA Satellite Site",
				"instrumentation": "ISCO Stream Sampler",
				"research_theme": "Surface water solute flux",
				"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. The ISCO was deployed during ice-free conditions in 2014. Data window: May 9, 2014 to October 26, 2014.",
				"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Dissolved Total Nitrogen (DTN); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-YUL0_1SgG10QYcOkRTL2o694mcT3qBrNCgZsIG",
						"ER-YUL0_1Cf-iHrXGhBarsVu5nXIUz07R9Cc6MBwo"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-GTH1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0045576,
					38.97845224,
					2935.22
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-GTH1",
				"name": "Gothic Creek",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location, Discharge transducer",
				"research_theme": "Surface discharge and solute flux",
				"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. Rating curved approach applied to pressure transducer data.",
				"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-GTH1_1AtWkH44Jams2WJsCyCEoV3Vi6Ta0eNXM"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MMT1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9978241,
					38.97930968,
					2969.49
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-MMT1",
				"name": "Marmot Creek",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location, Discharge transducer",
				"research_theme": "Surface discharge and solute flux",
				"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. Rating curved approach applied to pressure transducer data.",
				"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-MMT1_1bsH_cMQXOv6f_z8s00VyUSkTz_4c2IdV"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-QLY1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0141949,
					38.9934266,
					2981.63
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-QLY1",
				"name": "Quigley Creek",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location, Discharge transducer",
				"research_theme": "Surface discharge and solute flux",
				"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. Rating curved approach applied to pressure transducer data.",
				"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Dissolved Total Nitrogen (DTN); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-QLY1_1NbFc2sZR8W7fwJJP000umti3ZQP9j6Iq"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "Elk-00",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.059989,
					38.857128,
					2926.27
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "Elk-00",
				"name": "Elk-00",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location; stream flume",
				"research_theme": "Surface discharge and solute flux",
				"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN); stream discharge",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "TR-LOC1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.621097,
					38.769319,
					2789.79
				]
			},
			"properties": {
				"contact": {
					"name": "Kenneth Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "TR-LOC1",
				"name": "Lottis Creek gauging station",
				"category": "SFA Intensive",
				"instrumentation": "Transducer, ISCO automatic sampler",
				"research_theme": "Surface discharge and solute flux",
				"description": "Stream gauging station with automatic sampler",
				"variables_measured": "DOC/DIC, Cations, anions, water isotope, discharge, stage",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SR-NLA1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.011,
					38.89693,
					2712.59
				]
			},
			"properties": {
				"contact": {
					"name": "Rosemary Carroll",
					"email": "rosemary.carroll@dri.edu; rcarrollcb@gmail.com",
					"affiliation": "DRI"
				},
				"id": "SR-NLA1",
				"name": "Nicholson Lake",
				"category": "SFA Satellite Site",
				"instrumentation": "Pressure transducer (Hobo MX2001-04) serial number 20752650",
				"research_theme": "Surface discharge",
				"description": "Data used to quantify seasonal discharge.",
				"variables_measured": "Stream temperature, water level above sensor, discharge",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SR-GSB1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0144444,
					38.93888889,
					3003.47
				]
			},
			"properties": {
				"contact": {
					"name": "Rosemary Carroll",
					"email": "rosemary.carroll@dri.edu; rcarrollcb@gmail.com",
					"affiliation": "DRI"
				},
				"id": "SR-GSB1",
				"name": "Gunsight Bridge",
				"category": "SFA Satellite Site",
				"instrumentation": "Pressure transducer (Hobo MX2001-04) serial number 20739205",
				"research_theme": "Surface discharge",
				"description": "Data used to quantify seasonal discharge.",
				"variables_measured": "Stream temperature, water level above sensor, discharge",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-COL115",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.043765,
					38.862236,
					2868.46
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-COL115",
				"name": "CC-11.5",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": [
						"CC-COL115_1Aqx-YUD-_rxM3AzXoiGrX3t3YFALDiVu"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "Wild-00",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.009074,
					38.869424,
					2767.55
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "Wild-00",
				"name": "Wildcat Creek",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "Splains",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06417,
					38.8552,
					2922.7
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "Splains",
				"name": "Splains",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-RLY1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.021425,
					38.868361,
					2817.86
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-RLY1",
				"name": "Red Lady",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": [
						"CC-RLY1_1cmOTVtFTXg_A2Kwp9llMCnfYZKiAhYgI"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-OHO1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.092554,
					38.855179,
					2988.53
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-OHO1",
				"name": "Ohio Creek",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": [
						"CC-OHO1_1P_P9OQUhhJLbMwXchqxW3eag6LZaY6Sv"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-OHO2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0968,
					38.84995,
					3023.09
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-OHO2",
				"name": "Ohio Creek-2",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "Solute composition of surface water",
				"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-OHO3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09589,
					38.85185,
					3012.63
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-OHO3",
				"name": "Ohio Creek-3",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "Solute composition of surface water",
				"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-OHO4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09429,
					38.85379,
					2999.35
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-OHO4",
				"name": "Ohio Creek-4",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "Solute composition of surface water",
				"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-OHP1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09805,
					38.84567,
					3043.11
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-OHP1",
				"name": "Ohio Pass",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "Solute composition of surface water",
				"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "IR-00",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.100659,
					38.875245,
					3144.61
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "IR-00",
				"name": "IR-00",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "Evans",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.050068,
					38.860616,
					2893.22
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "Evans",
				"name": "Evans",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "Elk-East",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.058804,
					38.857112,
					2924.58
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "Elk-East",
				"name": "Elk East",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "Coal-5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.020513,
					38.86837,
					2798.14
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "Coal-5",
				"name": "Coal-5",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "Coal-20",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.059795,
					38.85597,
					2908.77
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "Coal-20",
				"name": "Coal-20",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "Coal-2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.990217,
					38.86804,
					2731.79
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "Coal-2",
				"name": "Coal-2",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "Coal-15",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.058623,
					38.856062,
					2904.97
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "Coal-15",
				"name": "Coal-15",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "Coal-12",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.046608,
					38.861683,
					2866.6
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "Coal-12",
				"name": "Coal-12",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "Coal-30",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.093626,
					38.866714,
					3047.85
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "Coal-30",
				"name": "Coal-30",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-COL9",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06315,
					38.855573,
					2920.84
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-COL9",
				"name": "CC-9",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": [
						"CC-COL9_1cMYlJHh0_LzvhnmQVfYRGdX2ETL55C9p"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-COL8",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.07307,
					38.855716,
					2952.68
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-COL8",
				"name": "CC-8",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": [
						"CC-COL8_16sQb6kgKMGe4rSkfS3_URsnZi75EvhH4"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-COL7",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.079844,
					38.854348,
					2968.05
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-COL7",
				"name": "CC-7",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": [
						"CC-COL7_1bN9L3MsxC1SYzBVBFyRvLmButPlZNnn_"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-COL6",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.085749,
					38.853976,
					2976.56
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-COL6",
				"name": "CC-6",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": [
						"CC-COL6_1UwGzcnd8AgGHuFpWY2S8I7InHIjor_Bq"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-COL5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.095536,
					38.858234,
					3001.41
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-COL5",
				"name": "CC-5",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": [
						"CC-COL5_1k8tymV5VzOjNmHISsgw8Zhb0xx_keqSE",
						"CC-COL5_1QZCx0I6v6mzOJpWDBVpLclgcEtv4I4Mi"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-COL3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.095071,
					38.8719,
					3085.28
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-COL3",
				"name": "CC-3",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": [
						"CC-COL3_1SEtNaLFEC_42OJvCdsP6NIvzgVd_imyP"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-COL2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.094504,
					38.872883,
					3098.47
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-COL2",
				"name": "CC-2",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": [
						"CC-COL2_1iPXeiW0_6up-t9saTIgQ0f0pax0MXmnQ",
						"CC-COL2_1PLZwHKjMfezer6ngabdM9MUWG2Bvcej8"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-COL12",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.007998,
					38.869416,
					2766.6
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-COL12",
				"name": "CC-12",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": [
						"CC-COL12_1dZS-vgDc7bdqE7ewY2V4QaLZ0qJN30Xz",
						"CC-COL12_1KYEkU4-w3ca9aRvpCmoumEmAyxf5zvlJ"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-COL11",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.048801,
					38.859758,
					2872.77
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-COL11",
				"name": "CC-11",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": [
						"CC-COL11_1Da6CBQXvEf03sEZIAJ83TvcmX9kYKQEn",
						"CC-COL11_1PuA1qjP2maVZuAXU-R8_a1_c-Lkki03A"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-COL10",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.056848,
					38.85625,
					2899.37
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-COL10",
				"name": "CC-10",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": [
						"CC-COL10_1xnca96C8jvKv6yqECRYlnRZxh3iyEddN"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-BOG3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.043242,
					38.862473,
					2874.53
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-BOG3",
				"name": "Bog-03",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": [
						"CC-BOG3_151QuDD2UzRCXC5DTTtCM8MWqloRxdWXp"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-BOG2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.043604,
					38.862433,
					2875.13
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-BOG2",
				"name": "Bog-02",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-BOG0",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.044806,
					38.863,
					2880.64
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-BOG0",
				"name": "Bog-00",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": [
						"CC-BOG0_1YIffKvdArow8ys3h1hJzjbHcNoqMq5Jm"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-BOG4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0428,
					38.8625,
					2873.55
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-BOG4",
				"name": "Bog-04",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-KYS1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.024,
					38.8676,
					2827.59
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-KYS1",
				"name": "Keystone",
				"category": "SFA Satellite Site",
				"instrumentation": "Stream sampling location",
				"research_theme": "Solute composition of surface water",
				"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-CBS1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.061086,
					38.855914,
					2912.6
				]
			},
			"properties": {
				"contact": {
					"name": "Wendy S. Brown",
					"email": "bugsunlimitedllc@gmail.com",
					"affiliation": "The Rocky Mountain Biological Laboratory"
				},
				"id": "CC-CBS1",
				"name": "Coal Below Splains",
				"category": "SFA Intensive",
				"instrumentation": "",
				"research_theme": "Weekly data about 2km upstream of Coal11",
				"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes in Coal Creek.",
				"variables_measured": "Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P); Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SS1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97987,
					38.92493964,
					3128.7
				]
			},
			"properties": {
				"contact": {
					"name": "Kenneth Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "SG-SS1",
				"name": "Snodgrass Synoptic site 1",
				"category": "SFA Intensive",
				"instrumentation": "",
				"research_theme": "Subsurface water and carbon inventories and fluxes",
				"description": "Information needed to quantify water flow and transport from the hillslope subsurface to East river channel surface water",
				"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-MT1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9795183,
					38.92478731,
					3119.85
				]
			},
			"properties": {
				"contact": {
					"name": "Kenneth Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "SG-MT1",
				"name": "Snodgrass synoptic meadow tributary 1",
				"category": "SFA Intensive",
				"instrumentation": "",
				"research_theme": "Subsurface water and carbon inventories and fluxes",
				"description": "Information needed to quantify water flow and transport from the hillslope subsurface to East river channel surface water",
				"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SS2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9790488,
					38.92433618,
					3111.74
				]
			},
			"properties": {
				"contact": {
					"name": "Kenneth Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "SG-SS2",
				"name": "Snodgrass synoptic site 2",
				"category": "SFA Intensive",
				"instrumentation": "",
				"research_theme": "Subsurface water and carbon inventories and fluxes",
				"description": "Information needed to quantify water flow and transport from the hillslope subsurface to East river channel surface water",
				"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-MT2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9783835,
					38.92399746,
					3096.91
				]
			},
			"properties": {
				"contact": {
					"name": "Kenneth Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "SG-MT2",
				"name": "Snodgrass synoptic meadow tributary 2",
				"category": "SFA Intensive",
				"instrumentation": "",
				"research_theme": "Subsurface water and carbon inventories and fluxes",
				"description": "Information needed to quantify water flow and transport from the hillslope subsurface to East river channel surface water",
				"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SS3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9783835,
					38.92399746,
					3096.91
				]
			},
			"properties": {
				"contact": {
					"name": "Kenneth Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "SG-SS3",
				"name": "Snodgrass synoptic site 3",
				"category": "SFA Intensive",
				"instrumentation": "",
				"research_theme": "Subsurface water and carbon inventories and fluxes",
				"description": "Information needed to quantify water flow and transport from the hillslope subsurface to East river channel surface water",
				"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SS4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.977957,
					38.92349366,
					3085.75
				]
			},
			"properties": {
				"contact": {
					"name": "Kenneth Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "SG-SS4",
				"name": "Snodgrass synoptic site 4",
				"category": "SFA Intensive",
				"instrumentation": "",
				"research_theme": "Subsurface water and carbon inventories and fluxes",
				"description": "Information needed to quantify water flow and transport from the hillslope subsurface to East river channel surface water",
				"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SS5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9776867,
					38.92311427,
					3079.21
				]
			},
			"properties": {
				"contact": {
					"name": "Kenneth Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "SG-SS5",
				"name": "Snodgrass synoptic site 5",
				"category": "SFA Intensive",
				"instrumentation": "",
				"research_theme": "Subsurface water and carbon inventories and fluxes",
				"description": "Information needed to quantify water flow and transport from the hillslope subsurface to East river channel surface water",
				"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-FT1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9771441,
					38.9230646,
					3080.83
				]
			},
			"properties": {
				"contact": {
					"name": "Kenneth Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "SG-FT1",
				"name": "Snodgrass synoptic forest tributary 1",
				"category": "SFA Intensive",
				"instrumentation": "",
				"research_theme": "Subsurface water and carbon inventories and fluxes",
				"description": "Information needed to quantify water flow and transport from the hillslope subsurface to East river channel surface water",
				"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SLF1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97331,
					38.91687,
					2926.36
				]
			},
			"properties": {
				"contact": {
					"name": "Kenneth Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "SG-SLF1",
				"name": "Snodgrass Lower Flume",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Water Quality",
				"description": "Grab Samples near terminus of Snodgrass Stream Reach",
				"variables_measured": "Electrical Conductivity, Total Dissolved Solids, Oxidation/Reduction Potential, pH, Total Dissolved Carbon, Cations, Anions, Ammonium",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PHR1       ",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9463049,
					38.921345,
					2756.61
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-PHR1       ",
				"name": "pumphouse 10 Meander, location1",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PHR2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.947941,
					38.921743,
					2756.96
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-PHR2",
				"name": "pumphouse 10 Meander, location2",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PHR3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.94927,
					38.922213,
					2757.45
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-PHR3",
				"name": "pumphouse 10 Meander, location3",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PHR4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.949477,
					38.923097,
					2758.13
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-PHR4",
				"name": "pumphouse 10 Meander, location4",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PHR5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.950427,
					38.922816,
					2759.85
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-PHR5",
				"name": "pumphouse 10 Meander, location5",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PHR6",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.951271,
					38.922157,
					2762.12
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-PHR6",
				"name": "pumphouse 10 Meander, location6",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PHR7",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.953858,
					38.923302,
					2760.24
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-PHR7",
				"name": "pumphouse 10 Meander, location7",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PHR8",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.952521,
					38.924748,
					2760.74
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-PHR8",
				"name": "pumphouse 10 Meander, location9",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PHR9",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.954602,
					38.925008,
					2761.49
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-PHR9",
				"name": "pumphouse 10 Meander, location11",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PHR10",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.954797,
					38.925675,
					2762.18
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-PHR10",
				"name": "pumphouse 10 Meander, location13",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PHR11",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95563,
					38.9269069,
					2764.17
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-PHR11",
				"name": "pumphouse 10 Meander, location14",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PHR12",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95752,
					38.928536,
					2765.88
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-PHR12",
				"name": "pumphouse 10 Meander, location15",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PHR13",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.959354,
					38.930631,
					2768.13
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-PHR13",
				"name": "pumphouse 10 Meander, location16",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MTR8",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.953432,
					38.923772,
					2760.42
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-MTR8",
				"name": "pumphouse 10 Meander, location8",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MTR10",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95404,
					38.924465,
					2762.1
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-MTR10",
				"name": "pumphouse 10 Meander, location10",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MTR12",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.955573,
					38.9253,
					2763.31
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-MTR12",
				"name": "pumphouse 10 Meander, location12",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-BCC1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.909214,
					38.894202,
					2725.2
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-BCC1",
				"name": "brush creek 10 Meander, site1",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-BCC2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.908515,
					38.893079,
					2725.5
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-BCC2",
				"name": "brush creek 10 Meander, site2",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-BCC3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.908735,
					38.892255,
					2724.86
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-BCC3",
				"name": "brush creek 10 Meander, site3",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-BCC4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.908955,
					38.891644,
					2724.5
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-BCC4",
				"name": "brush creek 10 Meander, site4",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-BCC5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.908828,
					38.890363,
					2724.18
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-BCC5",
				"name": "brush creek 10 Meander, site5",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-BCC6",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.907962,
					38.889797,
					2723.48
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-BCC6",
				"name": "brush creek 10 Meander, site6",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-BCC7",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.90727,
					38.889583,
					2723.28
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-BCC7",
				"name": "brush creek 10 Meander, site7",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-BCC8",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.908104,
					38.889311,
					2723.39
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-BCC8",
				"name": "brush creek 10 Meander, site8",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-BCC9",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.909216,
					38.888608,
					2722.97
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-BCC9",
				"name": "brush creek 10 Meander, site9",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-BCC10",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.908622,
					38.886602,
					2722.19
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-BCC10",
				"name": "brush creek 10 Meander, site10",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "river solute concentrations",
				"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-PZ01",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9797,
					38.92725,
					3162.9
				]
			},
			"properties": {
				"contact": {
					"name": "Kenneth Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "SG-PZ01",
				"name": "Historic Snodgrass well 1",
				"category": "SFA Intensive",
				"instrumentation": "",
				"research_theme": "Subsurface water and carbon/nutrient inventories and fluxes",
				"description": "Well used to collect groundwater geochemical samples",
				"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-PZ02",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97743,
					38.92366,
					3093.59
				]
			},
			"properties": {
				"contact": {
					"name": "Kenneth Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "SG-PZ02",
				"name": "Historic Snodgrass well 2",
				"category": "SFA Intensive",
				"instrumentation": "",
				"research_theme": "Subsurface water and carbon/nutrient inventories and fluxes",
				"description": "Well used to collect groundwater geochemical samples",
				"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-PZ04",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97665,
					38.92255,
					3070.75
				]
			},
			"properties": {
				"contact": {
					"name": "Kenneth Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "SG-PZ04",
				"name": "Historic Snodgrass well 4",
				"category": "SFA Intensive",
				"instrumentation": "",
				"research_theme": "Subsurface water and carbon/nutrient inventories and fluxes",
				"description": "Well used to collect groundwater geochemical samples",
				"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-PZ05",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97613,
					38.92063,
					3036.18
				]
			},
			"properties": {
				"contact": {
					"name": "Kenneth Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "SG-PZ05",
				"name": "Historic Snodgrass well 5",
				"category": "SFA Intensive",
				"instrumentation": "",
				"research_theme": "Subsurface water and carbon/nutrient inventories and fluxes",
				"description": "Well used to collect groundwater geochemical samples",
				"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-TTL1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9909661,
					38.9450276,
					2911.82
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-TTL1",
				"name": "Tuttle spring",
				"category": "SFA Satellite Site",
				"instrumentation": "Surface spring",
				"research_theme": "solute composition of surface spring",
				"description": "Data used to evaluate seasonal changes in spring geochemistry",
				"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Total Iron (Fe); Calcium (Ca); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Arsenic (As); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Total Phosphorous (P); Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Water - Deuterium (dD); Water - d18O; Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-BLY1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9924642,
					38.9636028,
					2922.43
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-BLY1",
				"name": "billy's spring",
				"category": "SFA Satellite Site",
				"instrumentation": "Surface spring",
				"research_theme": "solute composition of surface spring",
				"description": "Data used to evaluate seasonal changes in spring geochemistry",
				"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Total Iron (Fe); Calcium (Ca); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Arsenic (As); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Total Phosphorous (P); Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Water - Deuterium (dD); Water - d18O; Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th)",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": [
						"ER-BLY1_1lfq6itnxKJjJOeHstOJNFgh7_m28P7tt"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-JCH1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.038739,
					39.006026,
					3196.9
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-JCH1",
				"name": "East River below Emerald Lake",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Groundwater flux to river, sources of dissolved elements",
				"description": "Samples taken for isotopic measurement and [222Rn]",
				"variables_measured": "[222Rn]; DO; Temp; 87Sr/86Sr",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-JCH2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.017662,
					38.995781,
					2995.24
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-JCH2",
				"name": "East River above Gothic Beaver Cmplx",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Groundwater flux to river, sources of dissolved elements",
				"description": "Samples taken for isotopic measurement and [222Rn]",
				"variables_measured": "[222Rn]; DO; Temp; 87Sr/86Sr",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-JCH3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.014524,
					38.995168,
					2983.93
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-JCH3",
				"name": "East River above Quigley at road",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Groundwater flux to river, sources of dissolved elements",
				"description": "Samples taken for isotopic measurement and [222Rn]",
				"variables_measured": "[222Rn]; DO; Temp; 87Sr/86Sr",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-JCH4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.013267,
					38.993772,
					2978.29
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-JCH4",
				"name": "East River just above Quigley",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Groundwater flux to river, sources of dissolved elements",
				"description": "Samples taken for isotopic measurement and [222Rn]",
				"variables_measured": "[222Rn]; DO; Temp; 87Sr/86Sr",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-JCH5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00831,
					38.991445,
					2956.49
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-JCH5",
				"name": "East River at Rustler Shale",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Groundwater flux to river, sources of dissolved elements",
				"description": "Samples taken for isotopic measurement and [222Rn]",
				"variables_measured": "[222Rn]; DO; Temp; 87Sr/86Sr",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-JCH6",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.002027,
					38.97767,
					2924.89
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-JCH6",
				"name": "East River above Texas Bridge",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Groundwater flux to river, sources of dissolved elements",
				"description": "Samples taken for isotopic measurement and [222Rn]",
				"variables_measured": "[222Rn]; DO; Temp; 87Sr/86Sr",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-JCH7",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.996545,
					38.970326,
					2918.53
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-JCH7",
				"name": "East River at Bus Turnaround",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Groundwater flux to river, sources of dissolved elements",
				"description": "Samples taken for isotopic measurement and [222Rn]",
				"variables_measured": "[222Rn]; DO; Temp; 87Sr/86Sr",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-JCH8",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.991159,
					38.956849,
					2878.22
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-JCH8",
				"name": "East River below Director's Cabin",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Groundwater flux to river, sources of dissolved elements",
				"description": "Samples taken for isotopic measurement and [222Rn]",
				"variables_measured": "[222Rn]; DO; Temp; 87Sr/86Sr",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-JCH9",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.989221,
					38.952139,
					2863.7
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-JCH9",
				"name": "East River Downstream Gothic Bridge",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Groundwater flux to river, sources of dissolved elements",
				"description": "Samples taken for isotopic measurement and [222Rn]",
				"variables_measured": "[222Rn]; DO; Temp; 87Sr/86Sr",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-JCH10",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.989513,
					38.952476,
					2865.01
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-JCH10",
				"name": "East River Upstream of Gothic Bridge",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Groundwater flux to river, sources of dissolved elements",
				"description": "Samples taken for isotopic measurement and [222Rn]",
				"variables_measured": "[222Rn]; DO; Temp; 87Sr/86Sr",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-JCH11",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.013967,
					38.993666,
					2980.4
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-JCH11",
				"name": "Quigley CK at road",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Sources of dissolved elements to ER- 87Sr/86Sr etc",
				"description": "Samples taken for isotopic measurement",
				"variables_measured": "87Sr/86Sr; d34S of sulfate",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-JCH12",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.007654,
					38.989692,
					2958.55
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-JCH12",
				"name": "Rustler's Creek near road",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Sources of dissolved elements to ER- 87Sr/86Sr etc",
				"description": "Samples taken for isotopic measurement",
				"variables_measured": "87Sr/86Sr; d34S of sulfate (DO; Temp) [222Rn]",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-JCH13",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.005609,
					38.981659,
					2933.75
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-JCH13",
				"name": "Rock Ck at road",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Sources of dissolved elements to ER- 87Sr/86Sr etc",
				"description": "Samples taken for isotopic measurement",
				"variables_measured": "87Sr/86Sr; (DO; Temp) [222Rn]",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-JCH14",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.005625,
					38.981672,
					2933.88
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-JCH14",
				"name": "Fe Ck (next to Rock Ck)",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Sources of dissolved elements to ER- 87Sr/86Sr etc",
				"description": "Samples taken for isotopic measurement",
				"variables_measured": "87Sr/86Sr",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-JCH15",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.988324,
					38.957047,
					2884.58
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-JCH15",
				"name": "Copper Ck at RMBL",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Sources of dissolved elements to ER- 87Sr/86Sr etc",
				"description": "Samples taken for isotopic measurement",
				"variables_measured": "87Sr/86Sr; d34S of sulfate (DO; Temp) [222Rn]",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-JCH16",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.977477,
					38.937794,
					2886.22
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-JCH16",
				"name": "Quién Sabe Ck",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Sources of dissolved elements to ER- 87Sr/86Sr etc",
				"description": "Samples taken for isotopic measurement",
				"variables_measured": "87Sr/86Sr",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PLM11",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.947546,
					38.921134,
					2756.57
				]
			},
			"properties": {
				"contact": {
					"name": "Tetsu Tokunaga",
					"email": "tktokunaga@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-PLM11",
				"name": "PLM River1 Steam Sample",
				"category": "SFA Intensive",
				"instrumentation": "Stream Sampling Location",
				"research_theme": "Subsurface water and carbon inventories and fluxes",
				"description": "Information needed to quantify water flow and transport from the hillslope subsurface to East river channel surface water",
				"variables_measured": "Dissolved Carbon, Anions, Cations, Ammonium, Stable Water Isotopes",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PLM12",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.947546,
					38.921134,
					2756.57
				]
			},
			"properties": {
				"contact": {
					"name": "Tetsu Tokunaga",
					"email": "tktokunaga@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-PLM12",
				"name": "PLM River2 Steam Sample",
				"category": "SFA Intensive",
				"instrumentation": "Stream Sampling Location",
				"research_theme": "Subsurface water and carbon inventories and fluxes",
				"description": "Information needed to quantify water flow and transport from the hillslope subsurface to East river channel surface water",
				"variables_measured": "Dissolved Carbon, Anions, Cations, Ammonium, Stable Water Isotopes",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "TR-TCT1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.6248004,
					38.89986029,
					3055.53
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "TR-TCT1",
				"name": "Trail Creek Trib 1",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "Groundwater flux to stream, sources of dissolved elements",
				"description": "Samples taken for isotopic measurement, [222Rn], elemental composition",
				"variables_measured": "222Rn, 87Sr/86Sr, water isotopes, elemental composition, DO, temperature, conductance, turbidity, Q",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "TR-TCT2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.6190439,
					38.90761057,
					3042.13
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "TR-TCT2",
				"name": "Trail Creek Trib 2",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "Groundwater flux to stream, sources of dissolved elements",
				"description": "Samples taken for isotopic measurement, [222Rn], elemental composition",
				"variables_measured": "222Rn, 87Sr/86Sr, water isotopes, elemental composition, DO, temperature, conductance, turbidity, Q",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "TR-TCR1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.62314,
					38.900568,
					3051.18
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "TR-TCR1",
				"name": "Trail Creek 1",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "Groundwater flux to stream, sources of dissolved elements",
				"description": "Samples taken for isotopic measurement, [222Rn], elemental composition",
				"variables_measured": "222Rn, 87Sr/86Sr, water isotopes, elemental composition, DO, temperature, conductance, turbidity, Q",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "TR-TCR2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.619764,
					38.904554,
					3043.1
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "TR-TCR2",
				"name": "Trail Creek 2",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "Groundwater flux to stream, sources of dissolved elements",
				"description": "Samples taken for isotopic measurement, [222Rn], elemental composition",
				"variables_measured": "222Rn, 87Sr/86Sr, water isotopes, elemental composition, DO, temperature, conductance, turbidity, Q",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "TR-TCR3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.619885,
					38.907755,
					3038.62
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "TR-TCR3",
				"name": "Trail Creek 3",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "Groundwater flux to stream, sources of dissolved elements",
				"description": "Samples taken for isotopic measurement, [222Rn], elemental composition",
				"variables_measured": "222Rn, 87Sr/86Sr, water isotopes, elemental composition, DO, temperature, conductance, turbidity, Q",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "TR-TCR4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.621033,
					38.90973,
					3035.39
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "TR-TCR4",
				"name": "Trail Creek 4",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "Groundwater flux to stream, sources of dissolved elements",
				"description": "Samples taken for isotopic measurement, [222Rn], elemental composition",
				"variables_measured": "222Rn, 87Sr/86Sr, water isotopes, elemental composition, DO, temperature, conductance, turbidity, Q",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "TR-TCR5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.619573,
					38.911675,
					3032.9
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "TR-TCR5",
				"name": "Trail Creek 5",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "Groundwater flux to stream, sources of dissolved elements",
				"description": "Samples taken for isotopic measurement, [222Rn], elemental composition",
				"variables_measured": "222Rn, 87Sr/86Sr, water isotopes, elemental composition, DO, temperature, conductance, turbidity, Q",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "TR-TCR6",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.617688,
					38.913863,
					3029.86
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "TR-TCR6",
				"name": "Trail Creek 6",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "Groundwater flux to stream, sources of dissolved elements",
				"description": "Samples taken for isotopic measurement, [222Rn], elemental composition",
				"variables_measured": "222Rn, 87Sr/86Sr, water isotopes, elemental composition, DO, temperature, conductance, turbidity, Q",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "TR-TCR7",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.617538,
					38.917136,
					3026.15
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "TR-TCR7",
				"name": "Trail Creek 7",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "Groundwater flux to stream, sources of dissolved elements",
				"description": "Samples taken for isotopic measurement, [222Rn], elemental composition",
				"variables_measured": "222Rn, 87Sr/86Sr, water isotopes, elemental composition, DO, temperature, conductance, turbidity, Q",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "TR-TCR8",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.613626,
					38.920046,
					3022.45
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "TR-TCR8",
				"name": "Trail Creek 8",
				"category": "SFA Satellite Site",
				"instrumentation": "",
				"research_theme": "Groundwater flux to stream, sources of dissolved elements",
				"description": "Samples taken for isotopic measurement, [222Rn], elemental composition",
				"variables_measured": "222Rn, 87Sr/86Sr, water isotopes, elemental composition, DO, temperature, conductance, turbidity, Q",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "TR-TCR9",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.604171,
					38.921036,
					2957.87
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "TR-TCR9",
				"name": "Trail Creek 9",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Groundwater flux to stream, sources of dissolved elements",
				"description": "Samples taken for isotopic measurement, [222Rn], elemental composition",
				"variables_measured": "222Rn, 87Sr/86Sr, water isotopes, elemental composition, DO, temperature, conductance, turbidity, Q",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-JCH17",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.003082,
					38.981382,
					2928.9
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-JCH17",
				"name": "East River just below Rock Ck, Xe tracer experiment",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Rearation rate for gas exchange. Injection point",
				"description": "Injection point for Xe tracer experiments",
				"variables_measured": "[Xe] Injection point for Xe experiments",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-JCH18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.002118,
					38.977276,
					2924.49
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-JCH18",
				"name": "East River just downstream of Texas bridge, Xe time series",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Rearation rate for gas exchange. Collection point for Xe time series",
				"description": "Station for time series collection of Xe samples",
				"variables_measured": "[Xe] Time series station for Xe",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-JCH19",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.951074,
					38.923511,
					2759.06
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-JCH19",
				"name": "Pump House Xe Tracer Experiment",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Rearation rate for gas exchange. Injection point",
				"description": "Injection point for Xe tracer experiments",
				"variables_measured": "[Xe] Injection point for Xe experiments",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-JCH20",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.947367,
					38.920877,
					2756.36
				]
			},
			"properties": {
				"contact": {
					"name": "John Christensen",
					"email": "jnchristensen@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-JCH20",
				"name": "Pump Houes Xe time series",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Rearation rate for gas exchange. Injection point",
				"description": "Station for time series collection of Xe samples",
				"variables_measured": "[Xe] Time series station for Xe",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-LMA1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97113,
					38.90874,
					2888.47
				]
			},
			"properties": {
				"contact": {
					"name": "Rosemary Carroll",
					"email": "Rosemary.Carroll@dri.edu",
					"affiliation": "DRI"
				},
				"id": "WG-LMA1",
				"name": "Local Metrologic Water Line (LMWL) subregion location A",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "End member mixing Analysis",
				"description": "Snowmelt was collected using a buried reservoir from which snowmelt entered with no contact with the soil. A sampling port allowed me to pull all the snowmelt from the reservoir. Data was collected weekly and analyzed for water isotopes d2H and d18O. Snow depth and snowmelt volume were collected concurrently.",
				"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-LMB1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97107,
					38.90873,
					2888.52
				]
			},
			"properties": {
				"contact": {
					"name": "Rosemary Carroll",
					"email": "Rosemary.Carroll@dri.edu",
					"affiliation": "DRI"
				},
				"id": "WG-LMB1",
				"name": "Local Metrologic Water Line (LMWL) subregion location B",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "End member mixing Analysis",
				"description": "Snowmelt was collected using a buried reservoir from which snowmelt entered with no contact with the soil. A sampling port allowed me to pull all the snowmelt from the reservoir. Data was collected weekly and analyzed for water isotopes d2H and d18O. Snow depth and snowmelt volume were collected concurrently.",
				"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-LMC1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97101,
					38.90872,
					2888.66
				]
			},
			"properties": {
				"contact": {
					"name": "Rosemary Carroll",
					"email": "Rosemary.Carroll@dri.edu",
					"affiliation": "DRI"
				},
				"id": "WG-LMC1",
				"name": "Local Metrologic Water Line (LMWL) subregion location C",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "End member mixing Analysis",
				"description": "Snowmelt was collected using a buried reservoir from which snowmelt entered with no contact with the soil. A sampling port allowed me to pull all the snowmelt from the reservoir. Data was collected weekly and analyzed for water isotopes d2H and d18O. Snow depth and snowmelt volume were collected concurrently.",
				"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SPH1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9514,
					38.92213,
					2763.19
				]
			},
			"properties": {
				"contact": {
					"name": "Rosemary Carroll",
					"email": "Rosemary.Carroll@dri.edu",
					"affiliation": "DRI"
				},
				"id": "ER-SPH1",
				"name": "Snowmelt location near C-Q stations at Pumphouse intensive region",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "End member mixing Analysis",
				"description": "Snowmelt was collected using a buried reservoir from which snowmelt entered with no contact with the soil. A sampling port allowed me to pull all the snowmelt from the reservoir. Data was collected weekly and analyzed for water isotopes d2H and d18O. Snow depth and snowmelt volume were collected concurrently.",
				"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SPM1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.94929,
					38.91972,
					2787.62
				]
			},
			"properties": {
				"contact": {
					"name": "Rosemary Carroll",
					"email": "Rosemary.Carroll@dri.edu",
					"affiliation": "DRI"
				},
				"id": "ER-SPM1",
				"name": "Snowmelt location near PLM1 shallow groundwater well",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "End member mixing Analysis",
				"description": "Snowmelt was collected using a buried reservoir from which snowmelt entered with no contact with the soil. A sampling port allowed me to pull all the snowmelt from the reservoir. Data was collected weekly and analyzed for water isotopes d2H and d18O. Snow depth and snowmelt volume were collected concurrently.",
				"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SBB1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.99286,
					38.96297,
					2918.4
				]
			},
			"properties": {
				"contact": {
					"name": "Rosemary Carroll",
					"email": "Rosemary.Carroll@dri.edu",
					"affiliation": "DRI"
				},
				"id": "ER-SBB1",
				"name": "Snowmelt location near Billy Barr weather station",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "End member mixing Analysis",
				"description": "Snowmelt was collected using a buried reservoir from which snowmelt entered with no contact with the soil. A sampling port allowed me to pull all the snowmelt from the reservoir. Data was collected weekly and analyzed for water isotopes d2H and d18O. Snow depth and snowmelt volume were collected concurrently.",
				"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SBT1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95331,
					38.89434,
					3104.8
				]
			},
			"properties": {
				"contact": {
					"name": "Rosemary Carroll",
					"email": "Rosemary.Carroll@dri.edu",
					"affiliation": "DRI"
				},
				"id": "ER-SBT1",
				"name": "Snowmelt location near Butte SNOTEL station",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "End member mixing Analysis",
				"description": "Snowmelt was collected using a buried reservoir from which snowmelt entered with no contact with the soil. A sampling port allowed me to pull all the snowmelt from the reservoir. Data was collected weekly and analyzed for water isotopes d2H and d18O. Snow depth and snowmelt volume were collected concurrently.",
				"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SSG1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98627,
					38.93234,
					3358.55
				]
			},
			"properties": {
				"contact": {
					"name": "Rosemary Carroll",
					"email": "Rosemary.Carroll@dri.edu",
					"affiliation": "DRI"
				},
				"id": "SG-SSG1",
				"name": "Snowmelt location near Snodgrass weather station",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "End member mixing Analysis",
				"description": "Snowmelt was collected using a buried reservoir from which snowmelt entered with no contact with the soil. A sampling port allowed me to pull all the snowmelt from the reservoir. Data was collected weekly and analyzed for water isotopes d2H and d18O. Snow depth and snowmelt volume were collected concurrently.",
				"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-EST1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.858597,
					38.731972,
					2513.62
				]
			},
			"properties": {
				"contact": {
					"name": "Carleton Bern",
					"email": "cbern@usgs.gov",
					"affiliation": "USGS NGWOS"
				},
				"id": "ER-EST1",
				"name": "Estess",
				"category": "SFA Collaborator",
				"instrumentation": "",
				"research_theme": "Snowmelt and water isotope ratios",
				"description": "Precipitation samples collected weekly and seasonally measuring water isotope ratios. The Location_ID prefix (i.e. AA-) and the Geographic_Region do not match; the Location ID was assigned before verifying that the point location was registered within the correct drainage basin. 08/2022: While coordinates are outside of the East River (ER) watershed boundary, we are anticipating that the watershed boundaries will expand as the project grows-- ER is the correct region code.",
				"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
				"measurement_categories": [
					"hydrogeology",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-IRB2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.107721259,
					38.88793153,
					3181.55
				]
			},
			"properties": {
				"contact": {
					"name": "Carleton Bern",
					"email": "cbern@usgs.gov",
					"affiliation": "USGS NGWOS"
				},
				"id": "CC-IRB2",
				"name": "Irwin Barn",
				"category": "SFA Collaborator",
				"instrumentation": "",
				"research_theme": "Snowmelt and water isotope ratios",
				"description": "Precipitation samples collected weekly and seasonally measuring water isotope ratios. The Location_ID prefix (i.e. AA-) and the Geographic_Region do not match; the Location ID was assigned before verifying that the point location was registered within the correct drainage basin. 08/2022: This Irwin Barn location falls just outside of the Coal Creek (CC) watershed boundary but it is treated as input data signals for CC-- CC is the correct region code. ",
				"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
				"measurement_categories": [
					"hydrogeology",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-BRD2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00374,
					38.9875,
					2972.54
				]
			},
			"properties": {
				"contact": {
					"name": "Rosemary Carroll",
					"email": "Rosemary.Carroll@dri.edu",
					"affiliation": "DRI"
				},
				"id": "ER-BRD2",
				"name": "Bradley Creek weekly rain chemistry",
				"category": "SFA One-off Sampling",
				"instrumentation": "single gauge",
				"research_theme": "streamflow age rSAS",
				"description": "weekly summer rain collected with plastic gauge w/mineral oil",
				"variables_measured": "rain volume; water isotopes d2H and d18O",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-FRR1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98563,
					38.95793,
					2910.51
				]
			},
			"properties": {
				"contact": {
					"name": "Rosemary Carroll",
					"email": "Rosemary.Carroll@dri.edu",
					"affiliation": "DRI"
				},
				"id": "ER-FRR1",
				"name": "Forest site near warming meadow weekly rain chemistry",
				"category": "SFA One-off Sampling",
				"instrumentation": "single gauge",
				"research_theme": "streamflow age rSAS",
				"description": "weekly summer rain collected with plastic gauge w/mineral oil",
				"variables_measured": "rain volume; water isotopes d2H and d18O",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-LMR1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97091,
					38.90889,
					2885.52
				]
			},
			"properties": {
				"contact": {
					"name": "Rosemary Carroll",
					"email": "Rosemary.Carroll@dri.edu",
					"affiliation": "DRI"
				},
				"id": "WG-LMR1",
				"name": "Local Meteorologic Water Line (LMWL) subregion weekly rain chemistry",
				"category": "SFA One-off Sampling",
				"instrumentation": "two gauges. w/o mineral oil",
				"research_theme": "streamflow age rSAS",
				"description": "weekly summer rain collected with plastic gauge w/mineral oil",
				"variables_measured": "rain volume; water isotopes d2H and d18O; cations; anions; NPOC; DIC",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-RCH403",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0363,
					38.97442,
					3451.61
				]
			},
			"properties": {
				"contact": {
					"name": "Rosemary Carroll",
					"email": "Rosemary.Carroll@dri.edu",
					"affiliation": "DRI"
				},
				"id": "ER-RCH403",
				"name": "Rain chemistry near trail 403 in Rock Creek",
				"category": "SFA One-off Sampling",
				"instrumentation": "single gauge",
				"research_theme": "streamflow age rSAS",
				"description": "weekly summer rain collected with plastic gauge w/mineral oil",
				"variables_measured": "rain volume; water isotopes d2H and d18O",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-LMR1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.985552,
					38.867674,
					2718.08
				]
			},
			"properties": {
				"contact": {
					"name": "Wendy S. Brown",
					"email": "bugsunlimitedllc@gmail.com",
					"affiliation": "The Rocky Mountain Biological Laboratory"
				},
				"id": "CC-LMR1",
				"name": "LMWL_CB",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Rain and Snow data",
				"description": "Data used to establish a Local Meteoric Water Line",
				"variables_measured": "Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P); Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-EST2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.858597,
					38.731972,
					2513.62
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-EST2",
				"name": "Event based precipitation measurments at Estess ranch",
				"category": "SFA Intensive",
				"instrumentation": "",
				"research_theme": "Precipitation/snowmelt water isotope ratios",
				"description": "Precipitation samples collected on an event basis measuring water isotopes and volume of event. The Location_ID prefix (i.e. AA-) and the Geographic_Region do not match; the Location ID was assigned before verifying that the point location was registered within the correct drainage basin. 08/2022: While coordinates are outside of the East River (ER) watershed boundary, we are anticipating that the watershed boundaries will expand as the project grows-- ER is the correct region code.",
				"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
				"measurement_categories": [
					"hydrogeology",
					"climate"
				],
				"links": {
					"images": [
						"ER-EST2_12U0xe6oGY5MQqYx9_PFOAMWrLJekUPxJ"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-IRB3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.107721259,
					38.88793153,
					3181.55
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-IRB3",
				"name": "Event based precipitation measurments at Irwin Barn",
				"category": "SFA Intensive",
				"instrumentation": "",
				"research_theme": "Precipitation/snowmelt water isotope ratios",
				"description": "Precipitation samples collected on an event basis measuring water isotopes and volume of event. The Location_ID prefix (i.e. AA-) and the Geographic_Region do not match; the Location ID was assigned before verifying that the point location was registered within the correct drainage basin. 08/2022: This Irwin Barn location falls just outside of the Coal Creek (CC) watershed boundary but it is treated as input data signals for CC-- CC is the correct region code. ",
				"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
				"measurement_categories": [
					"hydrogeology",
					"climate"
				],
				"links": {
					"images": [
						"CC-IRB3_1a9UiHSCTmRMHIGshhH4-NXwUROt9eSz5"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-LMR2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.971092,
					38.908878,
					2890.36
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "WG-LMR2",
				"name": "Event based precipitation measurements at historic LMWL measurement site",
				"category": "SFA Intensive",
				"instrumentation": "",
				"research_theme": "Precipitation/snowmelt water isotope ratios",
				"description": "Precipitation samples collected on an event basis measuring water isotopes and volume of event",
				"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
				"measurement_categories": [
					"hydrogeology",
					"climate"
				],
				"links": {
					"images": [
						"WG-LMR2_1xFtTmjUsG8iRdihZwudzxi5AdCFYgnb3"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PPT1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.949333,
					38.92095,
					2767.31
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-PPT1",
				"name": "Rain based precipitation measurments at Pumphouse site",
				"category": "SFA Intensive",
				"instrumentation": "",
				"research_theme": "Precipitation water isotope ratios",
				"description": "Precipitation samples collected on an event basis measuring water isotopes and volume of event, utilizing mineral oil to prevent evaporation",
				"variables_measured": "Water isotopes D2H and d18O.",
				"measurement_categories": [
					"hydrogeology",
					"climate"
				],
				"links": {
					"images": [
						"ER-PPT1_19_38ZGn_3zxTUXE45Lz3b0gnir0Sw1Tv"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-CPA1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9499837,
					38.923195,
					2759.45
				]
			},
			"properties": {
				"contact": {
					"name": "Baptiste Dafflon",
					"email": "BDafflon@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-CPA1",
				"name": "CP1-BOT",
				"category": "SFA Intensive",
				"instrumentation": "Pressure transducer and fluid temperature probe. An Air Hobo is colocated with CP1.",
				"research_theme": "Subsurface water",
				"description": "Floodplain groundwater level measurements measured with a piezometer. These locations were previously maintained by Helen Melenda from Colorado School of Mines to measure water level and chemistry (see location Alias field for prior identifiers starting with CMSL_).",
				"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-CPA2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9498154,
					38.9232443,
					2759
				]
			},
			"properties": {
				"contact": {
					"name": "Baptiste Dafflon",
					"email": "BDafflon@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-CPA2",
				"name": "CP2-BOT",
				"category": "SFA Intensive",
				"instrumentation": "Pressure transducer and fluid temperature probe. An Air Hobo is colocated with CP1.",
				"research_theme": "Subsurface water",
				"description": "Floodplain groundwater level measurements measured with a piezometer. These locations were previously maintained by Helen Melenda from Colorado School of Mines to measure water level and chemistry (see location Alias field for prior identifiers starting with CMSL_).",
				"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-CPA3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9495975,
					38.923195,
					2758.93
				]
			},
			"properties": {
				"contact": {
					"name": "Baptiste Dafflon",
					"email": "BDafflon@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-CPA3",
				"name": "CP3-BOT",
				"category": "SFA Intensive",
				"instrumentation": "Pressure transducer and fluid temperature probe. An Air Hobo is colocated with CP1.",
				"research_theme": "Subsurface water",
				"description": "Floodplain groundwater level measurements measured with a piezometer. These locations were previously maintained by Helen Melenda from Colorado School of Mines to measure water level and chemistry (see location Alias field for prior identifiers starting with CMSL_).",
				"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-CPA4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9497815,
					38.92312214,
					2759.09
				]
			},
			"properties": {
				"contact": {
					"name": "Baptiste Dafflon",
					"email": "BDafflon@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-CPA4",
				"name": "CP4-BOT",
				"category": "SFA Intensive",
				"instrumentation": "Pressure transducer and fluid temperature probe. An Air Hobo is colocated with CP1.",
				"research_theme": "Subsurface water",
				"description": "Floodplain groundwater level measurements measured with a piezometer. These locations were previously maintained by Helen Melenda from Colorado School of Mines to measure water level and chemistry (see location Alias field for prior identifiers starting with CMSL_).",
				"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-CPA5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9499118,
					38.9229531,
					2759.58
				]
			},
			"properties": {
				"contact": {
					"name": "Baptiste Dafflon",
					"email": "BDafflon@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-CPA5",
				"name": "CP5-BOT",
				"category": "SFA Intensive",
				"instrumentation": "Pressure transducer and fluid temperature probe. An Air Hobo is colocated with CP1.",
				"research_theme": "Subsurface water",
				"description": "Floodplain groundwater level measurements measured with a piezometer. These locations were previously maintained by Helen Melenda from Colorado School of Mines to measure water level and chemistry (see location Alias field for prior identifiers starting with CMSL_).",
				"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-CPA6",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9497278,
					38.9229671,
					2759.17
				]
			},
			"properties": {
				"contact": {
					"name": "Baptiste Dafflon",
					"email": "BDafflon@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-CPA6",
				"name": "CP6-BOT",
				"category": "SFA Intensive",
				"instrumentation": "Pressure transducer and fluid temperature probe. An Air Hobo is colocated with CP1.",
				"research_theme": "Subsurface water",
				"description": "Floodplain groundwater level measurements measured with a piezometer. These locations were previously maintained by Helen Melenda from Colorado School of Mines to measure water level and chemistry (see location Alias field for prior identifiers starting with CMSL_).",
				"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-DOW",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9499648,
					38.9216511,
					2759.62
				]
			},
			"properties": {
				"contact": {
					"name": "Baptiste Dafflon",
					"email": "BDafflon@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-DOW",
				"name": "DO1WEST-BOT",
				"category": "SFA Intensive",
				"instrumentation": "Pressure transducer and fluid temperature",
				"research_theme": "Subsurface water",
				"description": "Floodplain groundwater level and temperature",
				"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-DOE",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9510847,
					38.9239407,
					2760.11
				]
			},
			"properties": {
				"contact": {
					"name": "Baptiste Dafflon",
					"email": "BDafflon@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-DOE",
				"name": "DO2EAST-BOT",
				"category": "SFA Intensive",
				"instrumentation": "Pressure transducer and fluid temperature",
				"research_theme": "Subsurface water",
				"description": "Floodplain groundwater level and temperature",
				"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MBA1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9506166,
					38.9227614,
					2760.1
				]
			},
			"properties": {
				"contact": {
					"name": "Baptiste Dafflon",
					"email": "BDafflon@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-MBA1",
				"name": "M1BEND1-BOT",
				"category": "SFA Intensive",
				"instrumentation": "Pressure transducer and fluid temperature",
				"research_theme": "Subsurface water",
				"description": "Floodplain groundwater level and temperature",
				"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MBA2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9505485,
					38.9228061,
					2759.89
				]
			},
			"properties": {
				"contact": {
					"name": "Baptiste Dafflon",
					"email": "BDafflon@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-MBA2",
				"name": "M1BEND2-BOT",
				"category": "SFA Intensive",
				"instrumentation": "Pressure transducer and fluid temperature",
				"research_theme": "Subsurface water",
				"description": "Floodplain groundwater level and temperature",
				"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-UPW",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9522385,
					38.92315,
					2759.95
				]
			},
			"properties": {
				"contact": {
					"name": "Baptiste Dafflon",
					"email": "BDafflon@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-UPW",
				"name": "UP1WEST-BOT",
				"category": "SFA Intensive",
				"instrumentation": "Pressure transducer and fluid temperature",
				"research_theme": "Subsurface water",
				"description": "Floodplain groundwater level and temperature",
				"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-UPM",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9518048,
					38.9235342,
					2760.27
				]
			},
			"properties": {
				"contact": {
					"name": "Baptiste Dafflon",
					"email": "BDafflon@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-UPM",
				"name": "UP2M-BOT",
				"category": "SFA Intensive",
				"instrumentation": "Pressure transducer and fluid temperature",
				"research_theme": "Subsurface water",
				"description": "Floodplain groundwater level and temperature",
				"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-UPE",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9510847,
					38.9239407,
					2760.11
				]
			},
			"properties": {
				"contact": {
					"name": "Baptiste Dafflon",
					"email": "BDafflon@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-UPE",
				"name": "UP3EAST-BOT",
				"category": "SFA Intensive",
				"instrumentation": "Pressure transducer and fluid temperature",
				"research_theme": "Subsurface water",
				"description": "Floodplain groundwater level and temperature",
				"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MCP1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9503469,
					38.92285027,
					2759.3
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-MCP1",
				"name": "Meander MCP1",
				"category": "SFA Intensive",
				"instrumentation": "Drive-point piezometer.",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying the Meander C floodplain at the Pumphouse location. The piezometer is designed to collected groundwater from a depth of 1.8-m over a slotted section of 15-cm.",
				"variables_measured": "Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MCP2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9501704,
					38.9228384,
					2759.66
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-MCP2",
				"name": "Meander MCP2",
				"category": "SFA Intensive",
				"instrumentation": "Drive-point piezometer.",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying the Meander C floodplain at the Pumphouse location. The piezometer is designed to collected groundwater from a depth of 1.8-m over a slotted section of 15-cm.",
				"variables_measured": "Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MCP3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9499975,
					38.92283223,
					2759.47
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-MCP3",
				"name": "Meander MCP3",
				"category": "SFA Intensive",
				"instrumentation": "Drive-point piezometer.",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying the Meander C floodplain at the Pumphouse location. The piezometer is designed to collected groundwater from a depth of 1.8-m over a slotted section of 15-cm.",
				"variables_measured": "Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MCP4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9498236,
					38.92281603,
					2759.28
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-MCP4",
				"name": "Meander MCP4",
				"category": "SFA Intensive",
				"instrumentation": "Drive-point piezometer.",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying the Meander C floodplain at the Pumphouse location. The piezometer is designed to collected groundwater from a depth of 1.8-m over a slotted section of 15-cm.",
				"variables_measured": "Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MCP5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9496442,
					38.92279538,
					2758.34
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-MCP5",
				"name": "Meander MCP5",
				"category": "SFA Intensive",
				"instrumentation": "Drive-point piezometer.",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Hillslope drilling location used to collect continuous core over the 0 to 10-m depth interval and to install a groundwater monitoring well used to measure sesonal variations in groundwater elevation and solute composition. Groundwater sampling depth is 7.6-m below ground surface.",
				"variables_measured": "Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MDP1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9471793,
					38.9213208,
					2757.09
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-MDP1",
				"name": "Meander MDP1",
				"category": "SFA Intensive",
				"instrumentation": "Drive-point piezometer.",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying the Meander D floodplain at the Pumphouse location. The piezometer is designed to collected groundwater from a depth of 1.1-m over a slotted section of 15-cm.",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Total Iron (Fe); Calcium (Ca); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Arsenic (As); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Total Phosphorous (P)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MDP2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9472086,
					38.9211396,
					2757.03
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-MDP2",
				"name": "Meander MDP2",
				"category": "SFA Intensive",
				"instrumentation": "Drive-point piezometer.",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying the Meander D floodplain at the Pumphouse location. The piezometer is designed to collected groundwater from a depth of 1.1-m over a slotted section of 15-cm.",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Total Iron (Fe); Calcium (Ca); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Arsenic (As); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Total Phosphorous (P)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MDP3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9471435,
					38.9210594,
					2756.73
				]
			},
			"properties": {
				"contact": {
					"name": "Ken Williams",
					"email": "khwilliams@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-MDP3",
				"name": "Meander MDP3",
				"category": "SFA Intensive",
				"instrumentation": "Drive-point piezometer.",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying the Meander D floodplain at the Pumphouse location. The piezometer is designed to collected groundwater from a depth of 1.1-m over a slotted section of 15-cm.",
				"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Total Iron (Fe); Calcium (Ca); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Arsenic (As); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Total Phosphorous (P)",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MOP1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9478836,
					38.92197704,
					2758.02
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-MOP1",
				"name": "Meander O (oxbow), position 1",
				"category": "SFA Intensive",
				"instrumentation": "Single piezometers",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying the Meander O (oxbow) floodplain at the Pumphouse location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
				"variables_measured": "Ground water samples; biogeochemical cycling",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MOP2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9477129,
					38.92191415,
					2757.75
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-MOP2",
				"name": "Meander O (oxbow), position 2",
				"category": "SFA Intensive",
				"instrumentation": "Single piezometers",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying the Meander O (oxbow) floodplain at the Pumphouse location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
				"variables_measured": "Ground water samples; biogeochemical cycling",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MOP3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9475228,
					38.92186363,
					2757.39
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-MOP3",
				"name": "Meander O (oxbow), position 3",
				"category": "SFA Intensive",
				"instrumentation": "Single piezometers",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying the Meander O (oxbow) floodplain at the Pumphouse location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
				"variables_measured": "Ground water samples; biogeochemical cycling",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MOP4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.947293,
					38.92184408,
					2756.93
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-MOP4",
				"name": "Meander O (oxbow), position 4",
				"category": "SFA Intensive",
				"instrumentation": "Single piezometers",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying the Meander O (oxbow) floodplain at the Pumphouse location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
				"variables_measured": "Ground water samples; biogeochemical cycling",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MCB1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9501598,
					38.92296836,
					2759.71
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-MCB1",
				"name": "Meander C, transect 2, position 1",
				"category": "SFA Intensive",
				"instrumentation": "Cluster of piezometers and soil rhizon samplers installed to various depths",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander C at the Pumphouse location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
				"variables_measured": "Ground water samples; biogeochemical cycling",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MCB2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9500587,
					38.92295536,
					2759.59
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-MCB2",
				"name": "Meander C, transect 2, position 2",
				"category": "SFA Intensive",
				"instrumentation": "Cluster of piezometers and soil rhizon samplers installed to various depths",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander C at the Pumphouse location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
				"variables_measured": "Ground water samples; biogeochemical cycling",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MCB3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9499313,
					38.922948,
					2759.54
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-MCB3",
				"name": "Meander C, transect 2, position 3",
				"category": "SFA Intensive",
				"instrumentation": "Cluster of piezometers and soil rhizon samplers installed to various depths",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander C at the Pumphouse location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
				"variables_measured": "Ground water samples; biogeochemical cycling",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MCB4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9497152,
					38.92292541,
					2759.27
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-MCB4",
				"name": "Meander C, transect 2, position 4",
				"category": "SFA Intensive",
				"instrumentation": "Cluster of piezometers and soil rhizon samplers installed to various depths",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander C at the Pumphouse location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
				"variables_measured": "Ground water samples; biogeochemical cycling",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MZA1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9081525,
					38.88977065,
					2723.88
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBL"
				},
				"id": "ER-MZA1",
				"name": "Meander Z, transect 1, position 1",
				"category": "SFA Satellite Site",
				"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Z at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
				"variables_measured": "Ground water samples; biogeochemical cycling",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MZA2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9081644,
					38.88965275,
					2723.68
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBL"
				},
				"id": "ER-MZA2",
				"name": "Meander Z, transect 1, position 2",
				"category": "SFA Satellite Site",
				"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Z at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
				"variables_measured": "Ground water samples; biogeochemical cycling",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MZA3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9081672,
					38.88954611,
					2723.65
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBL"
				},
				"id": "ER-MZA3",
				"name": "Meander Z, transect 1, position 3",
				"category": "SFA Satellite Site",
				"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Z at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
				"variables_measured": "Ground water samples; biogeochemical cycling",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MZA4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.908172,
					38.88943873,
					2723.55
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBL"
				},
				"id": "ER-MZA4",
				"name": "Meander Z, transect 1, position 4",
				"category": "SFA Satellite Site",
				"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Z at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
				"variables_measured": "Ground water samples; biogeochemical cycling",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MZA5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9081634,
					38.88934289,
					2723.58
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBL"
				},
				"id": "ER-MZA5",
				"name": "Meander Z, transect 1, position 5",
				"category": "SFA Satellite Site",
				"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Z at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
				"variables_measured": "Ground water samples; biogeochemical cycling",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MZB1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9077575,
					38.88987028,
					2723.52
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBL"
				},
				"id": "ER-MZB1",
				"name": "Meander Z, transect 2, position 1",
				"category": "SFA Satellite Site",
				"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Z at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
				"variables_measured": "Ground water samples; biogeochemical cycling",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MZB2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9077752,
					38.88972131,
					2723.8
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBL"
				},
				"id": "ER-MZB2",
				"name": "Meander Z, transect 2, position 2",
				"category": "SFA Satellite Site",
				"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Z at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
				"variables_measured": "Ground water samples; biogeochemical cycling",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MZB3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9078013,
					38.88958791,
					2723.68
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBL"
				},
				"id": "ER-MZB3",
				"name": "Meander Z, transect 2, position 3",
				"category": "SFA Satellite Site",
				"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Z at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
				"variables_measured": "Ground water samples; biogeochemical cycling",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MZB4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9078238,
					38.88949574,
					2723.58
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBL"
				},
				"id": "ER-MZB4",
				"name": "Meander Z, transect 2, position 4",
				"category": "SFA Satellite Site",
				"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Z at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
				"variables_measured": "Ground water samples; biogeochemical cycling",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MZB5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9078419,
					38.8893628,
					2723.63
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBL"
				},
				"id": "ER-MZB5",
				"name": "Meander Z, transect 2, position 5",
				"category": "SFA Satellite Site",
				"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Z at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
				"variables_measured": "Ground water samples; biogeochemical cycling",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MYP1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9088918,
					38.88989028,
					2723.98
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBL"
				},
				"id": "ER-MYP1",
				"name": "Meander Y (oxbow just above MZ) piezometer 2",
				"category": "SFA Satellite Site",
				"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Y (oxbow) at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
				"variables_measured": "Ground water samples; biogeochemical cycling",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MYP2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9090547,
					38.88989372,
					2723.95
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBL"
				},
				"id": "ER-MYP2",
				"name": "Meander Y (oxbow just above MZ) piezometer 1",
				"category": "SFA Satellite Site",
				"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
				"research_theme": "Alluvial aquifer solute concentrations.",
				"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Y (oxbow) at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
				"variables_measured": "Ground water samples; biogeochemical cycling",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_AP-1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95101,
					38.92334,
					2759.81
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_AP-1",
				"name": "CMSL_AP-1",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer",
				"research_theme": "Hydrology",
				"description": "Piezometer",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_AP-2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95096,
					38.92315,
					2759.94
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_AP-2",
				"name": "CMSL_AP-2",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer",
				"research_theme": "Hydrology",
				"description": "Piezometer",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_AP-3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95068,
					38.92324,
					2759.65
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_AP-3",
				"name": "CMSL_AP-3",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer",
				"research_theme": "Hydrology",
				"description": "Piezometer",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_AP-4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95074,
					38.92296,
					2759.93
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_AP-4",
				"name": "CMSL_AP-4",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer",
				"research_theme": "Hydrology",
				"description": "Piezometer",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_DP1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9472,
					38.92135,
					2757.09
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_DP1",
				"name": "CMSL_DP1",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer",
				"research_theme": "Hydrology",
				"description": "Piezometer",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_DP2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9471,
					38.92128,
					2756.85
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_DP2",
				"name": "CMSL_DP2",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer",
				"research_theme": "Hydrology",
				"description": "Piezometer",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_DP3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.94733,
					38.92129,
					2757.15
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_DP3",
				"name": "CMSL_DP3",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer",
				"research_theme": "Hydrology",
				"description": "Piezometer",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_DP4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.94722,
					38.92115,
					2757.04
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_DP4",
				"name": "CMSL_DP4",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer",
				"research_theme": "Hydrology",
				"description": "Piezometer",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_DP5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.94715,
					38.92108,
					2756.85
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_DP5",
				"name": "CMSL_DP5",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer",
				"research_theme": "Hydrology",
				"description": "Piezometer",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_DSW",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.94744,
					38.92115,
					2756.66
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_DSW",
				"name": "CMSL_DSW",
				"category": "SFA Collaborator",
				"instrumentation": "Stilling Well",
				"research_theme": "Hydrology",
				"description": "Stilling Well",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_EP1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.90887,
					38.88702,
					2723.05
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_EP1",
				"name": "CMSL_EP1",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer",
				"research_theme": "Hydrology",
				"description": "Piezometer",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_EP2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.90874,
					38.8867,
					2722.9
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_EP2",
				"name": "CMSL_EP2",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer",
				"research_theme": "Hydrology",
				"description": "Piezometer",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_EP3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.90901,
					38.88674,
					2722.79
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_EP3",
				"name": "CMSL_EP3",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer. Air Hobo colocated with EP3",
				"research_theme": "Hydrology",
				"description": "Piezometer",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_EP4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.90891,
					38.88681,
					2722.96
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_EP4",
				"name": "CMSL_EP4",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer",
				"research_theme": "Hydrology",
				"description": "Piezometer",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_EP5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.90905,
					38.88689,
					2722.95
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_EP5",
				"name": "CMSL_EP5",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer",
				"research_theme": "Hydrology",
				"description": "Piezometer",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_ESW",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.90874,
					38.88612,
					2721.96
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_ESW",
				"name": "CMSL_ESW",
				"category": "SFA Collaborator",
				"instrumentation": "Stilling Well",
				"research_theme": "Hydrology",
				"description": "Stilling Well",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_FP-1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.90807,
					38.8861,
					2722.5
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_FP-1",
				"name": "CMSL_FP-1",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer",
				"research_theme": "Hydrology",
				"description": "Piezometer",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_FP-2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.908,
					38.88591,
					2722.42
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_FP-2",
				"name": "CMSL_FP-2",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer",
				"research_theme": "Hydrology",
				"description": "Piezometer",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_FP-3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.90839,
					38.88572,
					2722.49
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_FP-3",
				"name": "CMSL_FP-3",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer",
				"research_theme": "Hydrology",
				"description": "Piezometer",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_FP-4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.90829,
					38.88591,
					2722.64
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_FP-4",
				"name": "CMSL_FP-4",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer",
				"research_theme": "Hydrology",
				"description": "Piezometer",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_FP-5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9088,
					38.88601,
					2723.08
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_FP-5",
				"name": "CMSL_FP-5",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer",
				"research_theme": "Hydrology",
				"description": "Piezometer",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_GP1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00315,
					38.97795,
					2925.92
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_GP1",
				"name": "CMSL_GP1",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer",
				"research_theme": "Hydrology",
				"description": "Piezometer, Air Hobo",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_GP2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00303,
					38.97808,
					2925.89
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_GP2",
				"name": "CMSL_GP2",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer",
				"research_theme": "Hydrology",
				"description": "Piezometer",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_GP3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00275,
					38.978,
					2925.82
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_GP3",
				"name": "CMSL_GP3",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer",
				"research_theme": "Hydrology",
				"description": "Piezometer",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_GP4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00293,
					38.97792,
					2925.57
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_GP4",
				"name": "CMSL_GP4",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer",
				"research_theme": "Hydrology",
				"description": "Piezometer",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_GP5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00282,
					38.97783,
					2925.68
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_GP5",
				"name": "CMSL_GP5",
				"category": "SFA Collaborator",
				"instrumentation": "Piezometer",
				"research_theme": "Hydrology",
				"description": "Piezometer",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CMSL_GSW",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00317,
					38.97807,
					2925.53
				]
			},
			"properties": {
				"contact": {
					"name": "Kamini Singha",
					"email": "ksingha@mines.edu",
					"affiliation": "Colorado School of Mines"
				},
				"id": "CMSL_GSW",
				"name": "CMSL_GSW",
				"category": "SFA Collaborator",
				"instrumentation": "Stilling Well",
				"research_theme": "Hydrology",
				"description": "Stilling Well",
				"variables_measured": "Water level",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LPZ1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.94915,
					38.921047,
					2761.75
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBL"
				},
				"id": "ER-LPZ1",
				"name": "Lower Montane Piezometer 1",
				"category": "SFA Intensive",
				"instrumentation": "drive point piezometer",
				"research_theme": "hillslope-floodplain connection",
				"description": "Piezometer used to collect shallow groundwater geochemical samples near the toeslope in the pumphouse vicinity. Data is used to understand the contribution of hillslope groundwater to the floodplain/river corridor. ",
				"variables_measured": "",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LPZ2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948642,
					38.9214,
					2758
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBL"
				},
				"id": "ER-LPZ2",
				"name": "Lower Montane Piezometer 2",
				"category": "SFA Intensive",
				"instrumentation": "drive point piezometer",
				"research_theme": "hillslope-floodplain connection",
				"description": "Piezometer used to collect shallow groundwater geochemical samples near the toeslope in the pumphouse vicinity. Data is used to understand the contribution of hillslope groundwater to the floodplain/river corridor. ",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LPZ3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948344,
					38.921522,
					2758.29
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBL"
				},
				"id": "ER-LPZ3",
				"name": "Lower Montane Piezometer 3",
				"category": "SFA Intensive",
				"instrumentation": "drive point piezometer",
				"research_theme": "hillslope-floodplain connection",
				"description": "Piezometer used to collect shallow groundwater geochemical samples near the toeslope in the pumphouse vicinity. Data is used to understand the contribution of hillslope groundwater to the floodplain/river corridor. ",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LPZ4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948131,
					38.920767,
					2759.41
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBL"
				},
				"id": "ER-LPZ4",
				"name": "Lower Montane Piezometer 4",
				"category": "SFA Intensive",
				"instrumentation": "drive point piezometer",
				"research_theme": "hillslope-floodplain connection",
				"description": "Piezometer used to collect shallow groundwater geochemical samples near the toeslope in the pumphouse vicinity. Data is used to understand the contribution of hillslope groundwater to the floodplain/river corridor. ",
				"variables_measured": "",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LPZ5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.947969,
					38.920897,
					2757.61
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBL"
				},
				"id": "ER-LPZ5",
				"name": "Lower Montane Piezometer 5",
				"category": "SFA Intensive",
				"instrumentation": "drive point piezometer",
				"research_theme": "hillslope-floodplain connection",
				"description": "Piezometer used to collect shallow groundwater geochemical samples near the toeslope in the pumphouse vicinity. Data is used to understand the contribution of hillslope groundwater to the floodplain/river corridor. ",
				"variables_measured": "",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LPZ6",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9478,
					38.921147,
					2757.18
				]
			},
			"properties": {
				"contact": {
					"name": "Patricia Fox",
					"email": "pmfox@lbl.gov",
					"affiliation": "LBL"
				},
				"id": "ER-LPZ6",
				"name": "Lower Montane Piezometer 6",
				"category": "SFA Intensive",
				"instrumentation": "drive point piezometer",
				"research_theme": "hillslope-floodplain connection",
				"description": "Piezometer used to collect shallow groundwater geochemical samples near the toeslope in the pumphouse vicinity. Data is used to understand the contribution of hillslope groundwater to the floodplain/river corridor. ",
				"variables_measured": "DIC; DOC; Anions; Cations; NH4",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "MeanderA_RB_A",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9512095,
					38.92315752,
					2759.26
				]
			},
			"properties": {
				"contact": {
					"name": "Mike Wilkins",
					"email": "mike.wilkins@colostate.edu",
					"affiliation": "Colorado State University"
				},
				"id": "MeanderA_RB_A",
				"name": "MeanderA_RB_A",
				"category": "SFA Collaborator",
				"instrumentation": "HOBO temperature loggers installed in riverbed at 5, 10, 20, and 35-cm depths.",
				"research_theme": "Hydrogeology, Biogeochemistry, Microbiology, Surface discharge and solute flux",
				"description": "Data used to quantify river water and groundwater mixing dynamics and associated biogeochemical/microbiological responses",
				"variables_measured": "Temperature; metagenomics",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "MeanderA_RB_B",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.951007,
					38.92354069,
					2759.1
				]
			},
			"properties": {
				"contact": {
					"name": "Mike Wilkins",
					"email": "mike.wilkins@colostate.edu",
					"affiliation": "Colorado State University"
				},
				"id": "MeanderA_RB_B",
				"name": "MeanderA_RB_B",
				"category": "SFA Collaborator",
				"instrumentation": "HOBO temperature loggers installed in riverbed at 5, 10, 20, and 35-cm depths.",
				"research_theme": "Hydrogeology, Biogeochemistry, Microbiology, Surface discharge and solute flux",
				"description": "Data used to quantify river water and groundwater mixing dynamics and associated biogeochemical/microbiological responses",
				"variables_measured": "Temperature; metagenomics",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "MeanderA_RB_C",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9505926,
					38.92331134,
					2759.06
				]
			},
			"properties": {
				"contact": {
					"name": "Mike Wilkins",
					"email": "mike.wilkins@colostate.edu",
					"affiliation": "Colorado State University"
				},
				"id": "MeanderA_RB_C",
				"name": "MeanderA_RB_C",
				"category": "SFA Collaborator",
				"instrumentation": "HOBO temperature loggers installed in riverbed at 5, 10, 20, and 35-cm depths.",
				"research_theme": "Hydrogeology, Biogeochemistry, Microbiology, Surface discharge and solute flux",
				"description": "Data used to quantify river water and groundwater mixing dynamics and associated biogeochemical/microbiological responses",
				"variables_measured": "Temperature; metagenomics",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMA1L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948681,
					38.920199,
					2776.55
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-LMA1L",
				"name": "Lower Montane A1 left",
				"category": "SFA Intensive",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMA1R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9487,
					38.920206,
					2776.37
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-LMA1R",
				"name": "Lower Montane A1 right",
				"category": "SFA Intensive",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMA2L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948827,
					38.920264,
					2775.94
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-LMA2L",
				"name": "Lower Montane A2 left",
				"category": "SFA Intensive",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMA2R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.94885,
					38.920274,
					2775.86
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-LMA2R",
				"name": "Lower Montane A2 right",
				"category": "SFA Intensive",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB1L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948368,
					38.920264,
					2772.31
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-LMB1L",
				"name": "Lower Montane B1 left",
				"category": "SFA Intensive",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB1R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948385,
					38.920272,
					2772.41
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-LMB1R",
				"name": "Lower Montane B1 right",
				"category": "SFA Intensive",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB2L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948532,
					38.920357,
					2771.39
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-LMB2L",
				"name": "Lower Montane B2 left",
				"category": "SFA Intensive",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB2R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948553,
					38.920362,
					2771.55
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-LMB2R",
				"name": "Lower Montane B2 right",
				"category": "SFA Intensive",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB2L17",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948517,
					38.92032,
					2772.49
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-LMB2L17",
				"name": "Lower Montane B2 left 2017",
				"category": "SFA Intensive",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB2R17",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948531,
					38.920326,
					2772.48
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-LMB2R17",
				"name": "Lower Montane B2 right 2017",
				"category": "SFA Intensive",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMC1L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948652,
					38.92041,
					2771.33
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-LMC1L",
				"name": "Lower Montane C1 left",
				"category": "SFA Intensive",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMC1R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948669,
					38.920417,
					2771.31
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-LMC1R",
				"name": "Lower Montane C1 right",
				"category": "SFA Intensive",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMC2L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.94883,
					38.920444,
					2771.61
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-LMC2L",
				"name": "Lower Montane C2 left",
				"category": "SFA Intensive",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMC2R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948847,
					38.92045,
					2771.48
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-LMC2R",
				"name": "Lower Montane C2 right",
				"category": "SFA Intensive",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-UMA1L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.009247,
					38.932903,
					2945.14
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-UMA1L",
				"name": "Upper Montane A1 left",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-UMA1R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.009284,
					38.932915,
					2944.99
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-UMA1R",
				"name": "Upper Montane A1 right",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-UMA2L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.009091,
					38.932854,
					2945.38
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-UMA2L",
				"name": "Upper Montane A2 left",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-UMA2R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.009123,
					38.932865,
					2945.46
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-UMA2R",
				"name": "Upper Montane A2 right",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-UMB1L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.008757,
					38.932734,
					2944
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-UMB1L",
				"name": "Upper Montane B1 left",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-UMB1R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.008762,
					38.932743,
					2943.99
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-UMB1R",
				"name": "Upper Montane B1 right",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-UMB2L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.008543,
					38.932668,
					2943.42
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-UMB2L",
				"name": "Upper Montane B2 left",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-UMB2R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.008562,
					38.932673,
					2943.48
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-UMB2R",
				"name": "Upper Montane B2 right",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-UMC1L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.008255,
					38.932677,
					2940.7
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-UMC1L",
				"name": "Upper Montane C1 left",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-UMC1R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.008281,
					38.932691,
					2940.83
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-UMC1R",
				"name": "Upper Montane C1 right",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-UMC2L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.008133,
					38.932596,
					2940.6
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-UMC2L",
				"name": "Upper Montane C2 left",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-UMC2R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.008153,
					38.93261,
					2940.71
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-UMC2R",
				"name": "Upper Montane C2 right",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-LSA1L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02897,
					38.95598,
					3116.22
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-LSA1L",
				"name": "Lower Subalpine A1 left",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-LSA1R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.028999,
					38.956019,
					3116.63
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-LSA1R",
				"name": "Lower Subalpine A1 right",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-LSA2L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02893,
					38.95584,
					3115.68
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-LSA2L",
				"name": "Lower Subalpine A2 left",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-LSA2R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.028945,
					38.955876,
					3115.78
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-LSA2R",
				"name": "Lower Subalpine A2 right",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-LSB1L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.028891,
					38.95571,
					3115.59
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-LSB1L",
				"name": "Lower Subalpine B1 left",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-LSB1R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0289,
					38.955732,
					3115.52
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-LSB1R",
				"name": "Lower Subalpine B1 right",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-LSB2L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.028853,
					38.955566,
					3114.91
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-LSB2L",
				"name": "Lower Subalpine B2 left",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-LSB2R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.028863,
					38.955582,
					3114.99
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-LSB2R",
				"name": "Lower Subalpine B2 right",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-LSC1L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.028516,
					38.955129,
					3109.13
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-LSC1L",
				"name": "Lower Subalpine C1 left",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-LSC1R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.028534,
					38.955172,
					3109.57
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-LSC1R",
				"name": "Lower Subalpine C1 right",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-LSC2L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.028487,
					38.954969,
					3108.5
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-LSC2L",
				"name": "Lower Subalpine C2 left",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WG-LSC2R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.028502,
					38.955014,
					3108.86
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "WG-LSC2R",
				"name": "Lower Subalpine C2 right",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-USA1L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.036676,
					38.974022,
					3460.58
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-USA1L",
				"name": "Upper Subalpine A1 left",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-USA1R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.036711,
					38.974012,
					3460.66
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-USA1R",
				"name": "Upper Subalpine A1 right",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-USA2L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.036824,
					38.973974,
					3461.09
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-USA2L",
				"name": "Upper Subalpine A2 left",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-USA2R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.036871,
					38.973961,
					3461.23
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-USA2R",
				"name": "Upper Subalpine A2 right",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-USB1L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.036707,
					38.974244,
					3458.39
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-USB1L",
				"name": "Upper Subalpine B1 left",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-USB1R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.036745,
					38.974253,
					3458.42
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-USB1R",
				"name": "Upper Subalpine B1 right",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-USB2L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.036518,
					38.97436,
					3454.88
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-USB2L",
				"name": "Upper Subalpine B2 left",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-USB2R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.036553,
					38.974362,
					3455.07
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-USB2R",
				"name": "Upper Subalpine B2 right",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-USC1L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.037085,
					38.974302,
					3458.78
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-USC1L",
				"name": "Upper Subalpine C1 left",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-USC1R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.037109,
					38.974304,
					3458.8
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-USC1R",
				"name": "Upper Subalpine C1 right",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-USC2L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.037236,
					38.974332,
					3459.34
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-USC2L",
				"name": "Upper Subalpine C2 left",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-USC2R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.037269,
					38.974331,
					3459.72
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-USC2R",
				"name": "Upper Subalpine C2 right",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "XX-ALA1L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.067419,
					38.996929,
					3636.23
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "XX-ALA1L",
				"name": "Alpine A1 left",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "XX-ALA1R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.067405,
					38.996955,
					3635.43
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "XX-ALA1R",
				"name": "Alpine A1 right",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "XX-ALB1L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.067228,
					38.996881,
					3629.95
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "XX-ALB1L",
				"name": "Alpine B1 left",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "XX-ALB1R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.067207,
					38.996908,
					3626.65
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "XX-ALB1R",
				"name": "Alpine B1 right",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "XX-ALC1L",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.067085,
					38.996731,
					3620.2
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "XX-ALC1L",
				"name": "Alpine C1 left",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "XX-ALC1R",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.067052,
					38.996758,
					3620.2
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "XX-ALC1R",
				"name": "Alpine C1 right",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
				"description": "Phenology Plot. Subplot within experimental plot",
				"variables_measured": "Phenophases; soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-WMU1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.985509,
					38.95706684,
					2917.46
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-WMU1",
				"name": "Warming Meadow 1 upper zone",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Microclimate monitoring",
				"description": "Experimental plot sub-zone. Subplot within experimental plot",
				"variables_measured": "Soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-WML1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.985446,
					38.95706163,
					2916.18
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-WML1",
				"name": "Warming Meadow 1 lower zone",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Microclimate monitoring",
				"description": "Experimental plot sub-zone. Subplot within experimental plot",
				"variables_measured": "Soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-WMU2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9855037,
					38.95712212,
					2917.36
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-WMU2",
				"name": "Warming Meadow 2 upper zone",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Microclimate monitoring",
				"description": "Experimental plot sub-zone. Subplot within experimental plot",
				"variables_measured": "Soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-WML2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9854379,
					38.95711273,
					2916.16
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-WML2",
				"name": "Warming Meadow 2 lower zone",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Microclimate monitoring",
				"description": "Experimental plot sub-zone. Subplot within experimental plot",
				"variables_measured": "Soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-WMU3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9854849,
					38.95717009,
					2917.19
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-WMU3",
				"name": "Warming Meadow 3 upper zone",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Microclimate monitoring",
				"description": "Experimental plot sub-zone. Subplot within experimental plot",
				"variables_measured": "Soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-WML3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9854232,
					38.95715653,
					2915.8
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-WML3",
				"name": "Warming Meadow 3 lower zone",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Microclimate monitoring",
				"description": "Experimental plot sub-zone. Subplot within experimental plot",
				"variables_measured": "Soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-WMU4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9854688,
					38.95722014,
					2917.12
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-WMU4",
				"name": "Warming Meadow 4 upper zone",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Microclimate monitoring",
				"description": "Experimental plot sub-zone. Subplot within experimental plot",
				"variables_measured": "Soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-WML4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9854058,
					38.95720033,
					2915.81
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-WML4",
				"name": "Warming Meadow 4 lower zone",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Microclimate monitoring",
				"description": "Experimental plot sub-zone. Subplot within experimental plot",
				"variables_measured": "Soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-WMU5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.985442,
					38.95726395,
					2917.03
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-WMU5",
				"name": "Warming Meadow 5 upper zone",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Microclimate monitoring",
				"description": "Experimental plot sub-zone. Subplot within experimental plot",
				"variables_measured": "Soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-WML5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9853843,
					38.95724517,
					2915.8
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-WML5",
				"name": "Warming Meadow 5 lower zone",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Microclimate monitoring",
				"description": "Experimental plot sub-zone. Subplot within experimental plot",
				"variables_measured": "Soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-WMU6",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9854111,
					38.95731192,
					2917.05
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-WMU6",
				"name": "Warming Meadow 6 upper zone",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Microclimate monitoring",
				"description": "Experimental plot sub-zone. Subplot within experimental plot",
				"variables_measured": "Soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-WML6",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9853588,
					38.95729002,
					2915.84
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-WML6",
				"name": "Warming Meadow 6 lower zone",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Microclimate monitoring",
				"description": "Experimental plot sub-zone. Subplot within experimental plot",
				"variables_measured": "Soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-WMU7",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9853776,
					38.95735363,
					2917.25
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-WMU7",
				"name": "Warming Meadow 7 upper zone",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Microclimate monitoring",
				"description": "Experimental plot sub-zone. Subplot within experimental plot",
				"variables_measured": "Soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-WML7",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9853293,
					38.95732652,
					2916.05
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-WML7",
				"name": "Warming Meadow 7 lower zone",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Microclimate monitoring",
				"description": "Experimental plot sub-zone. Subplot within experimental plot",
				"variables_measured": "Soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-WMU8",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9853347,
					38.95739117,
					2917.55
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-WMU8",
				"name": "Warming Meadow 8 upper zone",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Microclimate monitoring",
				"description": "Experimental plot sub-zone. Subplot within experimental plot",
				"variables_measured": "Soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-WML8",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9852904,
					38.95736197,
					2916.35
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-WML8",
				"name": "Warming Meadow 8 lower zone",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Microclimate monitoring",
				"description": "Experimental plot sub-zone. Subplot within experimental plot",
				"variables_measured": "Soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-WMU9",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9852891,
					38.95742976,
					2917.71
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-WMU9",
				"name": "Warming Meadow 9 upper zone",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Microclimate monitoring",
				"description": "Experimental plot sub-zone. Subplot within experimental plot",
				"variables_measured": "Soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-WML9",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9852408,
					38.95739222,
					2916.37
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-WML9",
				"name": "Warming Meadow 9 lower zone",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Microclimate monitoring",
				"description": "Experimental plot sub-zone. Subplot within experimental plot",
				"variables_measured": "Soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-WMU10",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9852341,
					38.95746939,
					2917.8
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-WMU10",
				"name": "Warming Meadow 10 upper zone",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Microclimate monitoring",
				"description": "Experimental plot sub-zone. Subplot within experimental plot",
				"variables_measured": "Soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-WML10",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9851872,
					38.95742976,
					2916.72
				]
			},
			"properties": {
				"contact": {
					"name": "Heidi Steltzer",
					"email": "steltzer_h@fortlewis.edu",
					"affiliation": "Ft. Lewis"
				},
				"id": "ER-WML10",
				"name": "Warming Meadow 10 lower zone",
				"category": "SFA Satellite Site",
				"instrumentation": "HOBO logger and microclimate sensors",
				"research_theme": "Microclimate monitoring",
				"description": "Experimental plot sub-zone. Subplot within experimental plot",
				"variables_measured": "Soil water content; soil temperature",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMA2-1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9488357,
					38.92025272,
					2776.28
				]
			},
			"properties": {
				"contact": {
					"name": "Yuxin Wu",
					"email": "ywu3@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMA2-1",
				"name": "Pumphouse Snow Manipulation Plot sensor station A2-1",
				"category": "SFA Intensive",
				"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
				"measurement_categories": [
					"hydrogeology",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMA2-2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9487786,
					38.92028205,
					2775.28
				]
			},
			"properties": {
				"contact": {
					"name": "Yuxin Wu",
					"email": "ywu3@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMA2-2",
				"name": "Pumphouse Snow Manipulation Plot sensor station A2-2",
				"category": "SFA Intensive",
				"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
				"measurement_categories": [
					"hydrogeology",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMA1-1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9486837,
					38.92021441,
					2776.22
				]
			},
			"properties": {
				"contact": {
					"name": "Yuxin Wu",
					"email": "ywu3@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMA1-1",
				"name": "Pumphouse Snow Manipulation Plot sensor station A1-1",
				"category": "SFA Intensive",
				"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
				"measurement_categories": [
					"hydrogeology",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMA1-2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9486333,
					38.9202656,
					2774.5
				]
			},
			"properties": {
				"contact": {
					"name": "Yuxin Wu",
					"email": "ywu3@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMA1-2",
				"name": "Pumphouse Snow Manipulation Plot sensor station A1-2",
				"category": "SFA Intensive",
				"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
				"measurement_categories": [
					"hydrogeology",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB1-1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9484184,
					38.92030497,
					2771.88
				]
			},
			"properties": {
				"contact": {
					"name": "Yuxin Wu",
					"email": "ywu3@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB1-1",
				"name": "Pumphouse Snow Manipulation Plot sensor station B1-1",
				"category": "SFA Intensive",
				"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
				"measurement_categories": [
					"hydrogeology",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB1-2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948345,
					38.92035176,
					2769.69
				]
			},
			"properties": {
				"contact": {
					"name": "Yuxin Wu",
					"email": "ywu3@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB1-2",
				"name": "Pumphouse Snow Manipulation Plot sensor station B1-2",
				"category": "SFA Intensive",
				"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
				"measurement_categories": [
					"hydrogeology",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB2-1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9484864,
					38.92033763,
					2771.69
				]
			},
			"properties": {
				"contact": {
					"name": "Yuxin Wu",
					"email": "ywu3@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB2-1",
				"name": "Pumphouse Snow Manipulation Plot sensor station B2-1",
				"category": "SFA Intensive",
				"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
				"measurement_categories": [
					"hydrogeology",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB2-2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9485132,
					38.92039429,
					2770.27
				]
			},
			"properties": {
				"contact": {
					"name": "Yuxin Wu",
					"email": "ywu3@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB2-2",
				"name": "Pumphouse Snow Manipulation Plot sensor station B2-2",
				"category": "SFA Intensive",
				"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
				"measurement_categories": [
					"hydrogeology",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMC1-1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9486608,
					38.92039446,
					2771.8
				]
			},
			"properties": {
				"contact": {
					"name": "Yuxin Wu",
					"email": "ywu3@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMC1-1",
				"name": "Pumphouse Snow Manipulation Plot sensor station C1-1",
				"category": "SFA Intensive",
				"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
				"measurement_categories": [
					"hydrogeology",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMC1-2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9486782,
					38.9204693,
					2769.65
				]
			},
			"properties": {
				"contact": {
					"name": "Yuxin Wu",
					"email": "ywu3@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMC1-2",
				"name": "Pumphouse Snow Manipulation Plot sensor station C1-2",
				"category": "SFA Intensive",
				"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
				"measurement_categories": [
					"hydrogeology",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMC2-1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9488019,
					38.92045273,
					2771.08
				]
			},
			"properties": {
				"contact": {
					"name": "Yuxin Wu",
					"email": "ywu3@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMC2-1",
				"name": "Pumphouse Snow Manipulation Plot sensor station C2-1",
				"category": "SFA Intensive",
				"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
				"measurement_categories": [
					"hydrogeology",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMC2-2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9487664,
					38.92047172,
					2770.42
				]
			},
			"properties": {
				"contact": {
					"name": "Yuxin Wu",
					"email": "ywu3@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMC2-2",
				"name": "Pumphouse Snow Manipulation Plot sensor station C2-2",
				"category": "SFA Intensive",
				"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
				"measurement_categories": [
					"hydrogeology",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMF1-1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948078,
					38.92100711,
					2757.43
				]
			},
			"properties": {
				"contact": {
					"name": "Yuxin Wu",
					"email": "ywu3@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMF1-1",
				"name": "Pumphouse floodplan sensor station FP - 1",
				"category": "SFA Intensive",
				"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 114cm (T/WP)",
				"measurement_categories": [
					"hydrogeology",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMF2-2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9479755,
					38.92119667,
					2757.6
				]
			},
			"properties": {
				"contact": {
					"name": "Yuxin Wu",
					"email": "ywu3@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMF2-2",
				"name": "Pumphouse floodplan sensor station FP - 2",
				"category": "SFA Intensive",
				"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 114cm (T/WP)",
				"measurement_categories": [
					"hydrogeology",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMF3-3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.947799,
					38.92134673,
					2757.47
				]
			},
			"properties": {
				"contact": {
					"name": "Yuxin Wu",
					"email": "ywu3@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMF3-3",
				"name": "Pumphouse floodplan sensor station FP - 3",
				"category": "SFA Intensive",
				"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 114cm (T/WP)",
				"measurement_categories": [
					"hydrogeology",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PHS1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95,
					38.92,
					2791.16
				]
			},
			"properties": {
				"contact": {
					"name": "Yuxin Wu",
					"email": "ywu3@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-PHS1",
				"name": "PumpHouse sensor tower #1",
				"category": "SFA Intensive",
				"instrumentation": "Station includes a suite of above and below ground sensors including a micromet sensor, infrared sensor, net radiation sensor, temperature probes, soil moisture sensors, soil matrix potential sensor, soil heat flux sensor, CO2 flux chamber.",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "This is the above and below ground sensor suite station #1 installed close to the new deep wells on the north facing slope close to PLM#2. This has a weather Station, Sampling Station, Soil moisture sensor, soil matrix potential sensor, CO2 flux chamber, Infrared camera, Net radiation sensor, Soil heat flux, temperature probes",
				"variables_measured": "3m (Micromet); 2.5m (PAR); 1.6m (NetR; IR); 0m (CO2 flux); -5cm (Heat flux);-10cm (T/WC/EC); -30cm(T/WC/EC/WP/O2); -60cm (T/WC/EC); -115 cm(T/WC/EC)2",
				"measurement_categories": [
					"hydrogeology",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PHS2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9472883,
					38.9225826,
					2760.73
				]
			},
			"properties": {
				"contact": {
					"name": "Yuxin Wu",
					"email": "ywu3@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-PHS2",
				"name": "Pumphouse sensor tower #2",
				"category": "SFA Intensive",
				"instrumentation": "Station includes a suite of above and below ground sensors including a micromet sensor, infrared sensor, net radiation sensor, temperature probes, soil moisture sensors, soil matrix potential sensor, soil heat flux sensor, CO2 flux chamber.",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "This is the above and below ground sensor suite station #1 installed close to the new deep wells on the north facing slope close to PLM#2. This has a weather Station, Sampling Station, Soil moisture sensor, soil matrix potential sensor, CO2 flux chamber, Infrared camera, Net radiation sensor, Soil heat flux, temperature probes",
				"variables_measured": "3m (Micromet); 2.5m (PAR); 1.6m (NetR; IR); 0m (CO2 flux); -5cm (Heat flux);-10cm (T/WC/EC); -30cm(T/WC/EC/WP/O2); -60cm (T/WC/EC); -115 cm(T/WC/EC)2",
				"measurement_categories": [
					"hydrogeology",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PHS3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9516586,
					38.9206498,
					2789.22
				]
			},
			"properties": {
				"contact": {
					"name": "Yuxin Wu",
					"email": "Ywu3@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-PHS3",
				"name": "Pumphouse sensor tower #3",
				"category": "SFA Intensive",
				"instrumentation": "As of October 2021, this site only contains soil sensors. Historical Location Instrumentation: Station includes a suite of above and below ground sensors including a micromet sensor, infrared sensor, net radiation sensor, temperature probes, soil moisture sensors, soil matrix potential sensor, soil heat flux sensor, CO2 flux chamber.",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "As of October 2021, this sensor tower, along with ER-PHS4, was moved to new monitoring locations at SG-EHS7 and SG-EHS8. The site as of October 2021, has a reduced sensor package only containing soil sensors. Historical Location Description: This is the above and below ground sensor suite station #1 installed close to the new deep wells on the north facing slope close to PLM#2. This has a weather Station, Sampling Station, Soil moisture sensor, soil matrix potential sensor, CO2 flux chamber, Infrared camera, Net radiation sensor, Soil heat flux, temperature probes",
				"variables_measured": "3m (Micromet); 2.5m (PAR); 1.6m (NetR; IR); 0m (CO2 flux); -5cm (Heat flux);-10cm (T/WC/EC); -30cm(T/WC/EC/WP/O2); -60cm (T/WC/EC); -115 cm(T/WC/EC)2",
				"measurement_categories": [
					"hydrogeology",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PHS4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95154,
					38.9205581,
					2791.19
				]
			},
			"properties": {
				"contact": {
					"name": "Yuxin Wu",
					"email": "ywu3@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-PHS4",
				"name": "Pumphouse sensor tower #4",
				"category": "SFA Intensive",
				"instrumentation": "As of October 2021, this site only contains soil sensors. Historical Location Instrumentation: Station includes a suite of above and below ground sensors including a micromet sensor, infrared sensor, net radiation sensor, temperature probes, soil moisture sensors, soil matrix potential sensor, soil heat flux sensor, CO2 flux chamber.",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "As of October 2021, this sensor tower, along with ER-PHS3, was moved to new monitoring locations at SG-EHS7 and SG-EHS8. The site as of October 2021, has a reduced sensor package only containing soil sensors. Historical Location Description: This is the above and below ground sensor suite station #1 installed close to the new deep wells on the north facing slope close to PLM#2. This has a weather Station, Sampling Station, Soil moisture sensor, soil matrix potential sensor, CO2 flux chamber, Infrared camera, Net radiation sensor, Soil heat flux, temperature probes",
				"variables_measured": "3m (Micromet); 2.5m (PAR); 1.6m (NetR; IR); 0m (CO2 flux); -5cm (Heat flux);-10cm (T/WC/EC); -30cm(T/WC/EC/WP/O2); -60cm (T/WC/EC); -115 cm(T/WC/EC)2",
				"measurement_categories": [
					"hydrogeology",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-EHS5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98,
					38.92625,
					3146.68
				]
			},
			"properties": {
				"contact": {
					"name": "Yuxin Wu",
					"email": "Ywu3@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SG-EHS5",
				"name": "Snodgrass tower #5",
				"category": "SFA Intensive",
				"instrumentation": "Station includes a suite of above and below ground sensors including a micromet sensor, infrared sensor, net radiation sensor, temperature probes, soil moisture sensors, soil matrix potential sensor, soil heat flux sensor, CO2 flux chamber.",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "This is the above and below ground sensor suite station #1 installed close to the new deep wells on the north facing slope close to PLM#2. This has a weather Station, Sampling Station, Soil moisture sensor, soil matrix potential sensor, CO2 flux chamber, Infrared camera, Net radiation sensor, Soil heat flux, temperature probes",
				"variables_measured": "4m (Micromet); 3.5m (PAR); 2m (NetR; IR; Snow Depth); 0m (CO2 flux); -5cm (Heat flux);-10cm (T/WC/EC); -30cm(T/WC/EC/WP/O2); -60cm (T/WC/EC); -115 cm(T/WC/EC)2",
				"measurement_categories": [
					"hydrogeology",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-EHS6",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.977,
					38.92565,
					3120.61
				]
			},
			"properties": {
				"contact": {
					"name": "Yuxin Wu",
					"email": "ywu3@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SG-EHS6",
				"name": "Snodgrass tower #6",
				"category": "SFA Intensive",
				"instrumentation": "Station includes a suite of above and below ground sensors including a micromet sensor, infrared sensor, net radiation sensor, temperature probes, soil moisture sensors, soil matrix potential sensor, soil heat flux sensor, CO2 flux chamber.",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "This is the above and below ground sensor suite station #1 installed close to the new deep wells on the north facing slope close to PLM#2. This has a weather Station, Sampling Station, Soil moisture sensor, soil matrix potential sensor, CO2 flux chamber, Infrared camera, Net radiation sensor, Soil heat flux, temperature probes",
				"variables_measured": "4m (Micromet); 3.5m (PAR); 2m (NetR; IR; Snow Depth); 0m (CO2 flux); -5cm (Heat flux);-10cm (T/WC/EC); -30cm(T/WC/EC/WP/O2); -60cm (T/WC/EC)",
				"measurement_categories": [
					"hydrogeology",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-EHS7",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9861122,
					38.9323418,
					3558.95
				]
			},
			"properties": {
				"contact": {
					"name": "Yuxin Wu",
					"email": "ywu3@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SG-EHS7",
				"name": "Snodgrass tower #7",
				"category": "SFA Intensive",
				"instrumentation": "Station includes a suite of above and below ground sensors including a micromet sensor, infrared sensor, net radiation sensor, PAR sensor, temperature probes, soil moisture sensors, soil matrix potential sensor, soil heat flux sensor, soil oxygen sensor, CO2 flux chamber.",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "This site is at the snodgrass mountain sumit, in a conifer understory. We monitor ambient and soil variables to model daily, seasonal and long-term energy fluxes (i.e. evapotranspiration) and soil water dynamics (i.e. snow, melt, monsoon and plant water use). ",
				"variables_measured": "3.35m (Micromet: air temperature, vapor pressure, barometric pressure, wind and gust speed (2D), wind direction (2D), precipitation); 2.7m (Photosynthetic active radiation, incoming); 2m (Net radiation); 1.9m (Infrared temperature); 0m (Soil CO2 flux); -0.05m (Soil heat flux); -0.1m (Soil temperature/water content/bulk electrical conductivity); -0.3 m(Soil T/WC/EC/matric potential/O2 concentration); -0.5m (Soil T/WC/EC)",
				"measurement_categories": [
					"hydrogeology",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-EHS8",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9707767,
					38.9255186,
					3020.68
				]
			},
			"properties": {
				"contact": {
					"name": "Yuxin Wu",
					"email": "ywu3@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SG-EHS8",
				"name": "Snodgrass tower #8",
				"category": "SFA Intensive",
				"instrumentation": "Station includes a suite of above and below ground sensors including a micromet sensor, infrared sensor, net radiation sensor, PAR sensor, temperature probes, snow depth sensor, soil moisture sensors, soil matrix potential sensor, soil heat flux sensor, soil oxygen sensor, CO2 flux chamber.",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "This site is at the snodgrass mountain (right pass the third gate), in an aspen understory. We monitor ambient and soil variables to model and study daily, seasonal and long-term energy fluxes (i.e. evapotranspiration) and soil water dynamics (i.e. snow, melt, monsoon and plant water use). ",
				"variables_measured": "2.8m (Micromet: air temperature, vapor pressure, barometric pressure, wind and gust speed (2D), wind direction (2D), precipitation); 2.4m (Photosynthetic active radiation, incoming); 1.75m (Net radiation, snow depth); 1.65m (Infrared temperature); 0m (Soil CO2 flux); -0.05m (Soil heat flux); -0.1m (Soil temperature/water content/bulk electrical conductivity); -0.3 m(Soil T/WC/EC/matric potential/O2 concentration); -0.6m (Soil T/WC/EC); -0.75m (Soil T/WC/EC)",
				"measurement_categories": [
					"hydrogeology",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SMA1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98427,
					38.9220943,
					3283.98
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SG-SMA1",
				"name": "Soil array at Snodgrass southwest ridge 1 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
				"research_theme": "Subsurface water",
				"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, 60, and 80 cm",
				"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SMB1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98427,
					38.9220943,
					3283.98
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SG-SMB1",
				"name": "Soil array at Snodgrass southwest ridge 1 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
				"research_theme": "Subsurface water",
				"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 30 and 60 cm",
				"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SMA2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03067,
					38.9761534,
					3342.23
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SMA2",
				"name": "Soil array at Baldy Mountain east slope 1 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
				"research_theme": "Subsurface water",
				"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
				"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SMB2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03067,
					38.9761534,
					3342.23
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SMB2",
				"name": "Soil array at Baldy Mountain east slope 1 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
				"research_theme": "Subsurface water",
				"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
				"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SMA3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.99245,
					38.9770753,
					3048.21
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SMA3",
				"name": "Soil array at Avery Peak lower west slope 1 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
				"research_theme": "Subsurface water",
				"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
				"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SMB3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.99245,
					38.9770753,
					3048.21
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SMB3",
				"name": "Soil array at Avery Peak lower west slope 1 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
				"research_theme": "Subsurface water",
				"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
				"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "XX-SMA4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03922,
					38.8165497,
					2990.91
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "XX-SMA4",
				"name": "Soil array at Carbon Creek valley 3 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
				"research_theme": "Subsurface water",
				"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
				"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "XX-SMB4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03922,
					38.8165497,
					2990.91
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "XX-SMB4",
				"name": "Soil array at Carbon Creek valley 3 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
				"research_theme": "Subsurface water",
				"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
				"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SMA5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0059,
					38.9770912,
					3006.02
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SMA5",
				"name": "Soil array at Gothic Mountain east slope replicate A",
				"category": "SFA Intensive",
				"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
				"research_theme": "Subsurface water",
				"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
				"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SMB5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0059,
					38.9770912,
					3006.02
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SMB5",
				"name": "Soil array at Gothic Mountain east slope replicate B",
				"category": "SFA Intensive",
				"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
				"research_theme": "Subsurface water",
				"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
				"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "XX-SMA6",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.8694,
					38.8536627,
					3131.21
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "XX-SMA6",
				"name": "Soil array at Point Lookout north slope 2 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
				"research_theme": "Subsurface water",
				"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
				"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "XX-SMB6",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.8694,
					38.8536627,
					3131.21
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "XX-SMB6",
				"name": "Soil array at Point Lookout north slope 2 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
				"research_theme": "Subsurface water",
				"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
				"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SR-SMA7",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.08073,
					38.954328,
					2969.08
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SR-SMA7",
				"name": "Soil array at Poverty Gulch 1 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
				"research_theme": "Subsurface water",
				"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
				"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SR-SMB7",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.08073,
					38.954328,
					2969.08
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SR-SMB7",
				"name": "Soil array at Poverty Gulch 1 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
				"research_theme": "Subsurface water",
				"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
				"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SMA8",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98033,
					38.9790796,
					3552.61
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SMA8",
				"name": "Soil array at Avery Peak upper west slope 1 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
				"research_theme": "Subsurface water",
				"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
				"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SMB8",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98033,
					38.9790796,
					3552.61
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SMB8",
				"name": "Soil array at Avery Peak upper west slope 1 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
				"research_theme": "Subsurface water",
				"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
				"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-SMA9",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03527,
					38.8609133,
					2907.2
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-SMA9",
				"name": "Soil array at Coal Valley south 1 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
				"research_theme": "Subsurface water",
				"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
				"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-SMB9",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03527,
					38.8609133,
					2907.2
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-SMB9",
				"name": "Soil array at Coal Valley south 1 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
				"research_theme": "Subsurface water",
				"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
				"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SMA10",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9865,
					38.933091,
					3334.63
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SG-SMA10",
				"name": "Soil array at Snodgrass northeast slope 1 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
				"research_theme": "Subsurface water",
				"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
				"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SMB10",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9865,
					38.933091,
					3334.63
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SG-SMB10",
				"name": "Soil array at Snodgrass northeast slope 1 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
				"research_theme": "Subsurface water",
				"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
				"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SNA1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98427,
					38.9220943,
					3283.98
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SG-SNA1",
				"name": "Distributed snow temperature profiling system at Snodgrass southwest ridge 1 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "Distributed snow temperature profiling system",
				"research_theme": "Snow inputs to water fluxes",
				"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
				"variables_measured": "Snow depth inferred via snow-air temperature differential",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SNB1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98427,
					38.9220943,
					3283.98
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SG-SNB1",
				"name": "Distributed snow temperature profiling system at Snodgrass southwest ridge 1 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "Distributed snow temperature profiling system",
				"research_theme": "Snow inputs to water fluxes",
				"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
				"variables_measured": "Snow depth inferred via snow-air temperature differential",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SNA2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03067,
					38.9761534,
					3342.23
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SNA2",
				"name": "Distributed snow temperature profiling system at Baldy Mountain east slope 1 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "Distributed snow temperature profiling system",
				"research_theme": "Snow inputs to water fluxes",
				"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
				"variables_measured": "Snow depth inferred via snow-air temperature differential",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SNB2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03067,
					38.9761534,
					3342.23
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SNB2",
				"name": "Distributed snow temperature profiling system at Baldy Mountain east slope 1 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "Distributed snow temperature profiling system",
				"research_theme": "Snow inputs to water fluxes",
				"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
				"variables_measured": "Snow depth inferred via snow-air temperature differential",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SNA3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.99245,
					38.9770753,
					3048.21
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SNA3",
				"name": "Distributed snow temperature profiling system at Avery Peak lower west slope 1 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "Distributed snow temperature profiling system",
				"research_theme": "Snow inputs to water fluxes",
				"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
				"variables_measured": "Snow depth inferred via snow-air temperature differential",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SNB3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.99245,
					38.9770753,
					3048.21
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SNB3",
				"name": "Distributed snow temperature profiling system at Avery Peak lower west slope 1 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "Distributed snow temperature profiling system",
				"research_theme": "Snow inputs to water fluxes",
				"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
				"variables_measured": "Snow depth inferred via snow-air temperature differential",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "XX-SNA4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03922,
					38.8165497,
					2990.91
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "XX-SNA4",
				"name": "Distributed snow temperature profiling system at Carbon Creek valley 3 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "Distributed snow temperature profiling system",
				"research_theme": "Snow inputs to water fluxes",
				"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
				"variables_measured": "Snow depth inferred via snow-air temperature differential",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "XX-SNB4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03922,
					38.8165497,
					2990.91
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "XX-SNB4",
				"name": "Distributed snow temperature profiling system at Carbon Creek valley 3 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "Distributed snow temperature profiling system",
				"research_theme": "Snow inputs to water fluxes",
				"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
				"variables_measured": "Snow depth inferred via snow-air temperature differential",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "XX-SNC4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03922,
					38.8165497,
					2990.91
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "XX-SNC4",
				"name": "Distributed snow temperature profiling system at Carbon Creek valley 3 replicate C",
				"category": "SFA Intensive",
				"instrumentation": "Distributed snow temperature profiling system",
				"research_theme": "Snow inputs to water fluxes",
				"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
				"variables_measured": "Snow depth inferred via snow-air temperature differential",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SNA5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0059,
					38.9770912,
					3006.02
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SNA5",
				"name": "Distributed snow temperature profiling system at Gothic Mountain east slope replicate A",
				"category": "SFA Intensive",
				"instrumentation": "Distributed snow temperature profiling system",
				"research_theme": "Snow inputs to water fluxes",
				"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
				"variables_measured": "Snow depth inferred via snow-air temperature differential",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SNB5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0059,
					38.9770912,
					3006.02
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SNB5",
				"name": "Distributed snow temperature profiling system at Gothic Mountain east slope replicate B",
				"category": "SFA Intensive",
				"instrumentation": "Distributed snow temperature profiling system",
				"research_theme": "Snow inputs to water fluxes",
				"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
				"variables_measured": "Snow depth inferred via snow-air temperature differential",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "XX-SNA6",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.8694,
					38.8536627,
					3131.2
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "XX-SNA6",
				"name": "Distributed snow temperature profiling system at Point Lookout north slope 2 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "Distributed snow temperature profiling system",
				"research_theme": "Snow inputs to water fluxes",
				"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
				"variables_measured": "Snow depth inferred via snow-air temperature differential",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "XX-SNB6",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.8694,
					38.8536627,
					3131.2
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "XX-SNB6",
				"name": "Distributed snow temperature profiling system at Point Lookout north slope 2 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "Distributed snow temperature profiling system",
				"research_theme": "Snow inputs to water fluxes",
				"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
				"variables_measured": "Snow depth inferred via snow-air temperature differential",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SR-SNA7",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.08073,
					38.954328,
					2969.01
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SR-SNA7",
				"name": "Distributed snow temperature profiling system at Poverty Gulch 1 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "Distributed snow temperature profiling system",
				"research_theme": "Snow inputs to water fluxes",
				"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
				"variables_measured": "Snow depth inferred via snow-air temperature differential",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SR-SNB7",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.08073,
					38.954328,
					2969.01
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SR-SNB7",
				"name": "Distributed snow temperature profiling system at Poverty Gulch 1 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "Distributed snow temperature profiling system",
				"research_theme": "Snow inputs to water fluxes",
				"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
				"variables_measured": "Snow depth inferred via snow-air temperature differential",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SNA8",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98033,
					38.9790796,
					3552.61
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SNA8",
				"name": "Distributed snow temperature profiling system at Avery Peak upper west slope 1 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "Distributed snow temperature profiling system",
				"research_theme": "Snow inputs to water fluxes",
				"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
				"variables_measured": "Snow depth inferred via snow-air temperature differential",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SNB8",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98033,
					38.9790796,
					3552.61
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SNB8",
				"name": "Distributed snow temperature profiling system at Avery Peak upper west slope 1 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "Distributed snow temperature profiling system",
				"research_theme": "Snow inputs to water fluxes",
				"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
				"variables_measured": "Snow depth inferred via snow-air temperature differential",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-SNA9",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03527,
					38.8609133,
					2907.2
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-SNA9",
				"name": "Distributed snow temperature profiling system at Coal Valley south 1 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "Distributed snow temperature profiling system",
				"research_theme": "Snow inputs to water fluxes",
				"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
				"variables_measured": "Snow depth inferred via snow-air temperature differential",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-SNB9",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03527,
					38.8609133,
					2907.2
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-SNB9",
				"name": "Distributed snow temperature profiling system at Coal Valley south 1 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "Distributed snow temperature profiling system",
				"research_theme": "Snow inputs to water fluxes",
				"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
				"variables_measured": "Snow depth inferred via snow-air temperature differential",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SNA10",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9865,
					38.933091,
					3334.63
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SG-SNA10",
				"name": "Distributed snow temperature profiling system at Snodgrass northeast slope 1 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "Distributed snow temperature profiling system",
				"research_theme": "Snow inputs to water fluxes",
				"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
				"variables_measured": "Snow depth inferred via snow-air temperature differential",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SNB10",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9865,
					38.933091,
					3334.63
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SG-SNB10",
				"name": "Distributed snow temperature profiling system at Snodgrass northeast slope 1 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "Distributed snow temperature profiling system",
				"research_theme": "Snow inputs to water fluxes",
				"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
				"variables_measured": "Snow depth inferred via snow-air temperature differential",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SOA1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98427,
					38.9220943,
					3283.98
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SG-SOA1",
				"name": "Distributed soil temperature profiling system at Snodgrass southwest ridge 1 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "Distributed soil temperature profiling system",
				"research_theme": "Subsurface water and energy flux",
				"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
				"variables_measured": "Soil temperature along vertical profile",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SOB1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98427,
					38.9220943,
					3283.98
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SG-SOB1",
				"name": "Distributed soil temperature profiling system at Snodgrass southwest ridge 1 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "Distributed soil temperature profiling system",
				"research_theme": "Subsurface water and energy flux",
				"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
				"variables_measured": "Soil temperature along vertical profile",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SOA2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03067,
					38.9761534,
					3342.23
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SOA2",
				"name": "Distributed soil temperature profiling system at Baldy Mountain east slope 1 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "Distributed soil temperature profiling system",
				"research_theme": "Subsurface water and energy flux",
				"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
				"variables_measured": "Soil temperature along vertical profile",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SOB2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03067,
					38.9761534,
					3342.23
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SOB2",
				"name": "Distributed soil temperature profiling system at Baldy Mountain east slope 1 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "Distributed soil temperature profiling system",
				"research_theme": "Subsurface water and energy flux",
				"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
				"variables_measured": "Soil temperature along vertical profile",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SOA3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.99245,
					38.9770753,
					3048.21
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SOA3",
				"name": "Distributed soil temperature profiling system at Avery Peak lower west slope 1 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "Distributed soil temperature profiling system",
				"research_theme": "Subsurface water and energy flux",
				"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
				"variables_measured": "Soil temperature along vertical profile",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SOB3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.99245,
					38.9770753,
					3048.21
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SOB3",
				"name": "Distributed soil temperature profiling system at Avery Peak lower west slope 1 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "Distributed soil temperature profiling system",
				"research_theme": "Subsurface water and energy flux",
				"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
				"variables_measured": "Soil temperature along vertical profile",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "XX-SOA4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03922,
					38.8165497,
					2990.91
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "XX-SOA4",
				"name": "Distributed soil temperature profiling system at Carbon Creek valley 3 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "Distributed soil temperature profiling system",
				"research_theme": "Subsurface water and energy flux",
				"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
				"variables_measured": "Soil temperature along vertical profile",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "XX-SOB4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03922,
					38.8165497,
					2990.91
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "XX-SOB4",
				"name": "Distributed soil temperature profiling system at Carbon Creek valley 3 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "Distributed soil temperature profiling system",
				"research_theme": "Subsurface water and energy flux",
				"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
				"variables_measured": "Soil temperature along vertical profile",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SOA5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0059,
					38.9770912,
					3006.02
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SOA5",
				"name": "Distributed soil temperature profiling system at Gothic Mountain east slope replicate A",
				"category": "SFA Intensive",
				"instrumentation": "Distributed soil temperature profiling system",
				"research_theme": "Subsurface water and energy flux",
				"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
				"variables_measured": "Soil temperature along vertical profile",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SOB5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0059,
					38.9770912,
					3006.02
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SOB5",
				"name": "Distributed soil temperature profiling system at Gothic Mountain east slope replicate B",
				"category": "SFA Intensive",
				"instrumentation": "Distributed soil temperature profiling system",
				"research_theme": "Subsurface water and energy flux",
				"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
				"variables_measured": "Soil temperature along vertical profile",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "XX-SOA6",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.8694,
					38.8536627,
					3131.21
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "XX-SOA6",
				"name": "Distributed soil temperature profiling system at Point Lookout north slope 2 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "Distributed soil temperature profiling system",
				"research_theme": "Subsurface water and energy flux",
				"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
				"variables_measured": "Soil temperature along vertical profile",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "XX-SOB6",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.8694,
					38.8536627,
					3131.21
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "XX-SOB6",
				"name": "Distributed soil temperature profiling system at Point Lookout north slope 2 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "Distributed soil temperature profiling system",
				"research_theme": "Subsurface water and energy flux",
				"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
				"variables_measured": "Soil temperature along vertical profile",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "XX-SOC6",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.8694,
					38.8536627,
					3131.21
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "XX-SOC6",
				"name": "Distributed soil temperature profiling system at Point Lookout north slope 2 replicate C",
				"category": "SFA Intensive",
				"instrumentation": "Distributed soil temperature profiling system",
				"research_theme": "Subsurface water and energy flux",
				"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
				"variables_measured": "Soil temperature along vertical profile",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SR-SOA7",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.08073,
					38.954328,
					2969.01
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SR-SOA7",
				"name": "Distributed soil temperature profiling system at Poverty Gulch 1 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "Distributed soil temperature profiling system",
				"research_theme": "Subsurface water and energy flux",
				"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
				"variables_measured": "Soil temperature along vertical profile",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SR-SOB7",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.08073,
					38.954328,
					2969.01
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SR-SOB7",
				"name": "Distributed soil temperature profiling system at Poverty Gulch 1 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "Distributed soil temperature profiling system",
				"research_theme": "Subsurface water and energy flux",
				"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
				"variables_measured": "Soil temperature along vertical profile",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SOA8",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98033,
					38.9790796,
					3552.61
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SOA8",
				"name": "Distributed soil temperature profiling system at Avery Peak upper west slope 1 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "Distributed soil temperature profiling system",
				"research_theme": "Subsurface water and energy flux",
				"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
				"variables_measured": "Soil temperature along vertical profile",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SOB8",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98033,
					38.9790796,
					3552.61
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SOB8",
				"name": "Distributed soil temperature profiling system at Avery Peak upper west slope 1 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "Distributed soil temperature profiling system",
				"research_theme": "Subsurface water and energy flux",
				"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
				"variables_measured": "Soil temperature along vertical profile",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-SOA9",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03527,
					38.8609133,
					2907.2
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-SOA9",
				"name": "Distributed soil temperature profiling system at Coal Valley south 1 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "Distributed soil temperature profiling system",
				"research_theme": "Subsurface water and energy flux",
				"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
				"variables_measured": "Soil temperature along vertical profile",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-SOB9",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03527,
					38.8609133,
					2907.2
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-SOB9",
				"name": "Distributed soil temperature profiling system at Coal Valley south 1 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "Distributed soil temperature profiling system",
				"research_theme": "Subsurface water and energy flux",
				"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
				"variables_measured": "Soil temperature along vertical profile",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SOA10",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9865,
					38.933091,
					3334.63
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SG-SOA10",
				"name": "Distributed soil temperature profiling system at Snodgrass northeast slope 1 replicate A",
				"category": "SFA Intensive",
				"instrumentation": "Distributed soil temperature profiling system",
				"research_theme": "Subsurface water and energy flux",
				"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
				"variables_measured": "Soil temperature along vertical profile",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SOB10",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9865,
					38.933091,
					3334.63
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SG-SOB10",
				"name": "Distributed soil temperature profiling system at Snodgrass northeast slope 1 replicate B",
				"category": "SFA Intensive",
				"instrumentation": "Distributed soil temperature profiling system",
				"research_theme": "Subsurface water and energy flux",
				"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
				"variables_measured": "Soil temperature along vertical profile",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-ATH1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98427,
					38.9220943,
					3283.98
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SG-ATH1",
				"name": "Air temperature and relative humidity sensor at Snodgrass southwest ridge 1",
				"category": "SFA Intensive",
				"instrumentation": "Onset HOBO U23 Pro v2 External Temperature/Relative Humidity Data Sensor and Logger mounted on 2 m fencepost",
				"research_theme": "Surface-atmosphere water and energy flux",
				"description": "Continuous external air temperature and relative humidity measurements",
				"variables_measured": "External air temperature and relative humidity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-ATH2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03067,
					38.9761534,
					3342.23
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-ATH2",
				"name": "Air temperature and relative humidity sensor at Baldy Mountain east slope 1",
				"category": "SFA Intensive",
				"instrumentation": "Onset HOBO U23 Pro v2 External Temperature/Relative Humidity Data Sensor and Logger mounted on 2 m fencepost",
				"research_theme": "Surface-atmosphere water and energy flux",
				"description": "Continuous external air temperature and relative humidity measurements",
				"variables_measured": "External air temperature and relative humidity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-ATH3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.99245,
					38.9770753,
					3048.21
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-ATH3",
				"name": "Air temperature and relative humidity sensor at Avery Peak lower west slope 1",
				"category": "SFA Intensive",
				"instrumentation": "Onset HOBO U23 Pro v2 External Temperature/Relative Humidity Data Sensor and Logger mounted on 2 m fencepost",
				"research_theme": "Surface-atmosphere water and energy flux",
				"description": "Continuous external air temperature and relative humidity measurements",
				"variables_measured": "External air temperature and relative humidity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "XX-ATH4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03922,
					38.8165497,
					2990.91
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "XX-ATH4",
				"name": "Air temperature and relative humidity sensor at Carbon Creek valley 3",
				"category": "SFA Intensive",
				"instrumentation": "Onset HOBO U23 Pro v2 External Temperature/Relative Humidity Data Sensor and Logger mounted on 2 m fencepost",
				"research_theme": "Surface-atmosphere water and energy flux",
				"description": "Continuous external air temperature and relative humidity measurements",
				"variables_measured": "External air temperature and relative humidity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-ATH5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0059,
					38.9770912,
					3006.02
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-ATH5",
				"name": "Air temperature and relative humidity sensor at Gothic Mountain east slope",
				"category": "SFA Intensive",
				"instrumentation": "Onset HOBO U23 Pro v2 External Temperature/Relative Humidity Data Sensor and Logger mounted on 2 m fencepost",
				"research_theme": "Surface-atmosphere water and energy flux",
				"description": "Continuous external air temperature and relative humidity measurements",
				"variables_measured": "External air temperature and relative humidity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "XX-ATH6",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.8694,
					38.8536627,
					3131.21
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "XX-ATH6",
				"name": "Air temperature and relative humidity sensor at Point Lookout north slope 2",
				"category": "SFA Intensive",
				"instrumentation": "Onset HOBO U23 Pro v2 External Temperature/Relative Humidity Data Sensor and Logger mounted on 2 m fencepost",
				"research_theme": "Surface-atmosphere water and energy flux",
				"description": "Continuous external air temperature and relative humidity measurements",
				"variables_measured": "External air temperature and relative humidity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SR-ATH7",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.08073,
					38.954328,
					2969.01
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SR-ATH7",
				"name": "Air temperature and relative humidity sensor at Poverty Gulch 1",
				"category": "SFA Intensive",
				"instrumentation": "Onset HOBO U23 Pro v2 External Temperature/Relative Humidity Data Sensor and Logger mounted on 2 m fencepost",
				"research_theme": "Surface-atmosphere water and energy flux",
				"description": "Continuous external air temperature and relative humidity measurements",
				"variables_measured": "External air temperature and relative humidity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-ATH8",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98033,
					38.9790796,
					3552.61
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-ATH8",
				"name": "Air temperature and relative humidity sensor at Avery Peak upper west slope 1",
				"category": "SFA Intensive",
				"instrumentation": "Onset HOBO U23 Pro v2 External Temperature/Relative Humidity Data Sensor and Logger mounted on 2 m fencepost",
				"research_theme": "Surface-atmosphere water and energy flux",
				"description": "Continuous external air temperature and relative humidity measurements",
				"variables_measured": "External air temperature and relative humidity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CC-ATH9",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03527,
					38.8609133,
					2907.2
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "CC-ATH9",
				"name": "Air temperature and relative humidity sensor at Coal Valley south 1",
				"category": "SFA Intensive",
				"instrumentation": "Onset HOBO U23 Pro v2 External Temperature/Relative Humidity Data Sensor and Logger mounted on 2 m fencepost",
				"research_theme": "Surface-atmosphere water and energy flux",
				"description": "Continuous external air temperature and relative humidity measurements",
				"variables_measured": "External air temperature and relative humidity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-ATH10",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9865,
					38.933091,
					3334.63
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SG-ATH10",
				"name": "Air temperature and relative humidity sensor at Snodgrass northeast slope 1",
				"category": "SFA Intensive",
				"instrumentation": "Onset HOBO U23 Pro v2 External Temperature/Relative Humidity Data Sensor and Logger mounted on 2 m fencepost",
				"research_theme": "Surface-atmosphere water and energy flux",
				"description": "Continuous external air temperature and relative humidity measurements",
				"variables_measured": "External air temperature and relative humidity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SMN1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9486228,
					38.92059975,
					2765.05
				]
			},
			"properties": {
				"contact": {
					"name": "Baptiste Dafflon",
					"email": "BDafflon@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SMN1",
				"name": "E1-54",
				"category": "SFA Intensive",
				"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"variables_measured": "-50 cm (T/WC/EC); -50 (T/WP); -10 (T/WC/EC); -10 (T/WP)",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SMN2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9485847,
					38.92072525,
					2761.17
				]
			},
			"properties": {
				"contact": {
					"name": "Baptiste Dafflon",
					"email": "BDafflon@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SMN2",
				"name": "E2-3",
				"category": "SFA Intensive",
				"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"variables_measured": "-50 cm (T/WC/EC); -50 (T/WP); -30 (T/WP); -10 (T/WP)",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SMN3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9485306,
					38.92090132,
					2759.26
				]
			},
			"properties": {
				"contact": {
					"name": "Baptiste Dafflon",
					"email": "BDafflon@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SMN3",
				"name": "E2-19",
				"category": "SFA Intensive",
				"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"variables_measured": "-50 cm (T/WC/EC); -50 (T/WP); -30 (T/WC/EC); -10 (T/WC/EC); -10 (T/WP)",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SMN4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9484757,
					38.92105419,
					2758.81
				]
			},
			"properties": {
				"contact": {
					"name": "Baptiste Dafflon",
					"email": "BDafflon@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SMN4",
				"name": "E2-33",
				"category": "SFA Intensive",
				"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"variables_measured": "-40 cm (T/WC/EC); -40 (T/WP); -30 (T/WC/EC); -10 (T/WC/EC); -10 (T/WP)",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SMN5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9484702,
					38.92113326,
					2757.86
				]
			},
			"properties": {
				"contact": {
					"name": "Baptiste Dafflon",
					"email": "BDafflon@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-SMN5",
				"name": "E2-40",
				"category": "SFA Intensive",
				"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"research_theme": "Thermohydroclimate Monitoring",
				"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
				"variables_measured": "-50 cm (T/WC/EC); -50 (T/WP); -30 (T/WP); -10 (T/WC/EC); -10 (T/WP)",
				"measurement_categories": [
					"hydrogeology"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WU-KCOCREST10",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97194,
					38.894249,
					2803.56
				]
			},
			"properties": {
				"contact": {
					"name": "",
					"email": "",
					"affiliation": "Weather Underground"
				},
				"id": "WU-KCOCREST10",
				"name": "Weather Underground KCOCREST10",
				"category": "External Datasource",
				"instrumentation": "Weather Station",
				"research_theme": "",
				"description": "Weather Underground Weather Station",
				"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Precipitation",
				"measurement_categories": [
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WU-KCOCREST4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9762,
					38.8803978,
					2707.16
				]
			},
			"properties": {
				"contact": {
					"name": "",
					"email": "",
					"affiliation": "Weather Underground"
				},
				"id": "WU-KCOCREST4",
				"name": "Weather Underground KCOCREST4",
				"category": "External Datasource",
				"instrumentation": "Weather Station",
				"research_theme": "",
				"description": "Weather Underground Weather Station",
				"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Precipitation",
				"measurement_categories": [
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WU-KCOCREST6",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.944467,
					38.8494644,
					2708.87
				]
			},
			"properties": {
				"contact": {
					"name": "",
					"email": "",
					"affiliation": "Weather Underground"
				},
				"id": "WU-KCOCREST6",
				"name": "Weather Underground KCOCREST6",
				"category": "External Datasource",
				"instrumentation": "Weather Station",
				"research_theme": "",
				"description": "Weather Underground Weather Station",
				"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Precipitation",
				"measurement_categories": [
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WU-KCOMTCRE2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95892,
					38.9150314,
					2923.12
				]
			},
			"properties": {
				"contact": {
					"name": "",
					"email": "",
					"affiliation": "Weather Underground"
				},
				"id": "WU-KCOMTCRE2",
				"name": "Weather Underground KCOMTCRE2",
				"category": "External Datasource",
				"instrumentation": "Weather Station",
				"research_theme": "",
				"description": "Weather Underground Weather Station near Crested Butte",
				"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Precipitation",
				"measurement_categories": [
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WU-MRMEX",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.064,
					39.0283,
					3410.51
				]
			},
			"properties": {
				"contact": {
					"name": "",
					"email": "",
					"affiliation": "Weather Underground"
				},
				"id": "WU-MRMEX",
				"name": "Weather Underground MRMEX",
				"category": "External Datasource",
				"instrumentation": "Weather Station",
				"research_theme": "",
				"description": "Weather Underground Weather Station",
				"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Precipitation",
				"measurement_categories": [
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "WU-MTAPC2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.603,
					38.9086,
					3174.17
				]
			},
			"properties": {
				"contact": {
					"name": "",
					"email": "",
					"affiliation": "Weather Underground"
				},
				"id": "WU-MTAPC2",
				"name": "Weather Underground MTAPC2",
				"category": "External Datasource",
				"instrumentation": "Weather Station",
				"research_theme": "",
				"description": "Weather Underground Weather Station",
				"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Precipitation",
				"measurement_categories": [
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-AMT1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.8591304,
					38.65369565,
					2440.03
				]
			},
			"properties": {
				"contact": {
					"name": "Dave Gochis",
					"email": "gochis@ucar.edu",
					"affiliation": "LBNL"
				},
				"id": "ER-AMT1",
				"name": "Almont Weather Station",
				"category": "SFA Collaborator",
				"instrumentation": "Weather Station. Maintained currently by NCAR, instrumentation partly paid for by the SFA.",
				"research_theme": "Atmospheric inputs of water and energy",
				"description": "Data define boundary condition fluxes of water and energy at the landsurface for hydrologic interpretation. Weather stations are positioned across an elevation gradient.",
				"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Snow Depth; Photosynthetically Active Radiation; Reflected PAR; Soil Temperature; Soil Moisture (TDR);",
				"measurement_categories": [
					"hydrogeology",
					"climate"
				],
				"links": {
					"images": [
						"ER-AMT1_1WL_KcZGPiRKNgAKsqdZs5ZwKK3ub_nk6"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-BLB1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9911594,
					38.96021739,
					2902.17
				]
			},
			"properties": {
				"contact": {
					"name": "Dave Gochis",
					"email": "gochis@ucar.edu",
					"affiliation": "LBNL"
				},
				"id": "ER-BLB1",
				"name": "Billy Barr Weather Station",
				"category": "SFA Collaborator",
				"instrumentation": "Weather Station. Maintained currently by NCAR",
				"research_theme": "Atmospheric inputs of water and energy",
				"description": "Data define boundary condition fluxes of water and energy at the landsurface for hydrologic interpretation. Weather stations are positioned across an elevation gradient.",
				"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Snow Depth;",
				"measurement_categories": [
					"hydrogeology",
					"climate"
				],
				"links": {
					"images": [
						"ER-BLB1_19HFEd1-3inv9qhhPaZeDIMRNV9QATzqg",
						"ER-BLB1_1m8X3jwzFJRo-ss8Q1tmLHM8qWJXoJh1g"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-JDF1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9835507,
					38.96065217,
					2975.59
				]
			},
			"properties": {
				"contact": {
					"name": "Dave Gochis",
					"email": "gochis@ucar.edu",
					"affiliation": "LBNL"
				},
				"id": "ER-JDF1",
				"name": "Judd Falls Weather Station",
				"category": "SFA Collaborator",
				"instrumentation": "Weather Station. Maintained currently by NCAR",
				"research_theme": "Atmospheric inputs of water and energy",
				"description": "Data define boundary condition fluxes of water and energy at the landsurface for hydrologic interpretation. Weather stations are positioned across an elevation gradient.",
				"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Snow Depth; Photosynthetically Active Radiation; Reflected PAR; Soil Temperature; Soil Moisture (TDR);",
				"measurement_categories": [
					"hydrogeology",
					"climate"
				],
				"links": {
					"images": [
						"ER-JDF1_1X-gx9lYQxfDlkoi30dtHycjnXzcrEBmm"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-KLP1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9716667,
					38.93985507,
					2838.19
				]
			},
			"properties": {
				"contact": {
					"name": "Dave Gochis",
					"email": "gochis@ucar.edu",
					"affiliation": "LBNL"
				},
				"id": "ER-KLP1",
				"name": "Kettle Ponds Weather Station",
				"category": "SFA Collaborator",
				"instrumentation": "Weather Station. Maintained currently by NCAR",
				"research_theme": "Atmospheric inputs of water and energy",
				"description": "Data define boundary condition fluxes of water and energy at the landsurface for hydrologic interpretation. Weather stations are positioned across an elevation gradient.",
				"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Snow Depth; Photosynthetically Active Radiation; Reflected PAR; Soil Temperature; Soil Moisture (TDR);",
				"measurement_categories": [
					"hydrogeology",
					"climate"
				],
				"links": {
					"images": [
						"ER-KLP1_1UmAgH7geJfEQL4g0C7QbTyOr6Ish_9xG"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-MXC1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0606522,
					39.0257971,
					3404.08
				]
			},
			"properties": {
				"contact": {
					"name": "Dave Gochis",
					"email": "gochis@ucar.edu",
					"affiliation": "LBNL"
				},
				"id": "ER-MXC1",
				"name": "Mexican Cut Weather Station",
				"category": "SFA Collaborator",
				"instrumentation": "Weather Station. Maintained currently by NCAR",
				"research_theme": "Atmospheric inputs of water and energy",
				"description": "Data define boundary condition fluxes of water and energy at the landsurface for hydrologic interpretation. Weather stations are positioned across an elevation gradient.",
				"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Photosynthetically Active Radiation; Reflected PAR; Soil Temperature; Soil Moisture (TDR); Snow Depth",
				"measurement_categories": [
					"hydrogeology",
					"climate"
				],
				"links": {
					"images": [
						"ER-MXC1_1xNMfshzZmjtgj8Nqf1nQQ6SkMRjAsySy",
						"ER-MXC1_1wfQjfEhZlZTNHkx12kkEhfg5hDRmr_sB"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SMT1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9855072,
					38.92949275,
					3328.16
				]
			},
			"properties": {
				"contact": {
					"name": "Dave Gochis",
					"email": "gochis@ucar.edu",
					"affiliation": "LBNL"
				},
				"id": "SG-SMT1",
				"name": "Snodgrass Mountain Weather Station",
				"category": "SFA Collaborator",
				"instrumentation": "Weather Station. Maintained currently by NCAR",
				"research_theme": "Atmospheric inputs of water and energy",
				"description": "Data define boundary condition fluxes of water and energy at the landsurface for hydrologic interpretation. Weather stations are positioned across an elevation gradient.",
				"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Photosynthetically Active Radiation; Reflected PAR; Soil Temperature; Soil Moisture (TDR);",
				"measurement_categories": [
					"hydrogeology",
					"climate"
				],
				"links": {
					"images": [
						"SG-SMT1_1AQlOkPrE3UFy-AHWUerfe-Whr4EmWcCl"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PFT0",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.949699,
					38.922242,
					2759.11
				]
			},
			"properties": {
				"contact": {
					"name": "Dave Gochis",
					"email": "gochis@ucar.edu",
					"affiliation": "LBNL"
				},
				"id": "ER-PFT0",
				"name": "Pumphouse Flux Tower",
				"category": "SFA Collaborator",
				"instrumentation": "The eddy flux tower stands at six meters high and supports multiple sensors. The sensor suite for the eddy covariance (EC)/energy balance system include air temperature\n and humidity sensors, a snow depth sensor, an air pressure transducer, a three-dimensional sonic anemometer with integrated CO2 and H2O open-path gas analyzer, two levels of soil moisture, soil temperature and soil electrical conductivity (5 cm and 25 cm), and ground heat flux plates located at a 5cm depth. The measurement height for the eddy covariance/infra-red gas analyzer and 4-way radiometer was set at just below 6 m (5.9 m) which is approximately 3-4 meters above the willow shrub gallery that covers much of the valley floor.",
				"research_theme": "Water-Energy Balance",
				"description": "The 6 m tall tower situated near the pumphouse meanders was situated to capture the turbulence from the dominant northwestern wind direction. Data from the tower are used to constrain the upper values of latent heat flux in the riparian zone. See details in Ryken et al. (2020) in review.",
				"variables_measured": "The sensor suite for the eddy covariance (EC)/energy balance system include air temperature\n and humidity sensors; a snow depth sensor; an air pressure transducer; a three-dimensional sonic anemometer with integrated CO2 and H2O open-path gas analyzer; two levels of soil moisture; soil temperature and soil electrical conductivity (5 cm and 25 cm); and ground heat flux plates located at a 5cm depth.",
				"measurement_categories": [
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-PFT1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95231,
					38.9229,
					2760.43
				]
			},
			"properties": {
				"contact": {
					"name": "David Gochis",
					"email": "gochis@ucar.edu",
					"affiliation": "NCAR"
				},
				"id": "ER-PFT1",
				"name": "SFA Pumphouse Eddy Covariance",
				"category": "SFA Collaborator",
				"instrumentation": "Campbell Scientific Irgason, K&Z CNR4",
				"research_theme": "Evapotranspiration, CO2 and energy fluxes",
				"description": "Eddy Covariance and Energy Balance measurements",
				"variables_measured": "ET, CO2 flux, sensible heat flux, latent heat flux, soil moisture/temperature, ground heat flux, snow depth, T/RH, surface skin temperature",
				"measurement_categories": [
					"hydrogeology",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CASTNET-GTH161",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98587,
					38.95627,
					2917.45
				]
			},
			"properties": {
				"contact": {
					"name": "",
					"email": "",
					"affiliation": "EPA"
				},
				"id": "CASTNET-GTH161",
				"name": "U.S. EPA CASTNET Gothic station",
				"category": "External Datasource",
				"instrumentation": "Air Quality Monitoring Station",
				"research_theme": "",
				"description": "U.S. EPA CASTNET Air Quality Monitoring Station at Gothic (GTH161). See https://www3.epa.gov/castnet/site_pages/GTH161.html for details.",
				"variables_measured": "Ozone; Wet and dry nitrogen and sulfur deposition; Air Temperature; Relative Humidity; Wind Speed; Wind Direction",
				"measurement_categories": [
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "NRCS-380",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.953,
					38.8943,
					3102.73
				]
			},
			"properties": {
				"contact": {
					"name": "",
					"email": "",
					"affiliation": "NRCS"
				},
				"id": "NRCS-380",
				"name": "snotel_butte",
				"category": "External Datasource",
				"instrumentation": "NRCS SNOTEL station",
				"research_theme": "",
				"description": "NRCS SNOTEL station. See https://wcc.sc.egov.usda.gov/nwcc/site?sitenum=380",
				"variables_measured": "Snow Water Equivalent; Snow Depth",
				"measurement_categories": [
					"hydrogeology",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "NRCS-737",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0488,
					39.0152,
					3252.3
				]
			},
			"properties": {
				"contact": {
					"name": "",
					"email": "",
					"affiliation": "NRCS"
				},
				"id": "NRCS-737",
				"name": "snotel_schofield_pass",
				"category": "External Datasource",
				"instrumentation": "NRCS SNOTEL station",
				"research_theme": "",
				"description": "NRCS SNOTEL station. See: https://wcc.sc.egov.usda.gov/nwcc/site?sitenum=737",
				"variables_measured": "Snow Water Equivalent; Snow Depth",
				"measurement_categories": [
					"hydrogeology",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "NRCS-1141",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.7542,
					38.9908,
					3346.86
				]
			},
			"properties": {
				"contact": {
					"name": "",
					"email": "",
					"affiliation": "NRCS"
				},
				"id": "NRCS-1141",
				"name": "snotel_upper_taylor",
				"category": "External Datasource",
				"instrumentation": "NRCS SNOTEL station",
				"research_theme": "",
				"description": "NRCS SNOTEL. See: https://wcc.sc.egov.usda.gov/nwcc/site?sitenum=1141",
				"variables_measured": "Snow Water Equivalent; Snow Depth",
				"measurement_categories": [
					"hydrogeology",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "NRCS-680",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.583333,
					38.816667,
					2937.1
				]
			},
			"properties": {
				"contact": {
					"name": "",
					"email": "",
					"affiliation": "NRCS"
				},
				"id": "NRCS-680",
				"name": "snotel_park_cone",
				"category": "External Datasource",
				"instrumentation": "NRCS SNOTEL station",
				"research_theme": "",
				"description": "NRCS SNOTEL station. See: https://wcc.sc.egov.usda.gov/nwcc/site?sitenum=680",
				"variables_measured": "Snow Water Equivalent; Snow Depth",
				"measurement_categories": [
					"hydrogeology",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-RMT1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9875285,
					38.95777091,
					2889.42
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-RMT1",
				"name": "RMBL Research Meadow PIEN1",
				"category": "SFA Collaborator",
				"instrumentation": "",
				"research_theme": "Tree traits, leaf physiology",
				"description": "Data used to characterize species differences in water-use strategies and transpiration rates.",
				"variables_measured": "Terminal brachlette (needles and stem) pressure-volume curves; apical branch xylem conductivity; stomatal conductance.",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-RMT2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9867145,
					38.95786025,
					2902.42
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-RMT2",
				"name": "RMBL Research Meadow PIEN2",
				"category": "SFA Collaborator",
				"instrumentation": "",
				"research_theme": "Tree traits, leaf physiology",
				"description": "Data used to characterize species differences in water-use strategies and transpiration rates.",
				"variables_measured": "Terminal brachlette (needles and stem) pressure-volume curves; apical branch xylem conductivity; stomatal conductance.",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-RMT3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9865703,
					38.95795908,
					2905.64
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-RMT3",
				"name": "RMBL Research Meadow PIEN3",
				"category": "SFA Collaborator",
				"instrumentation": "",
				"research_theme": "Tree traits, leaf physiology",
				"description": "Data used to characterize species differences in water-use strategies and transpiration rates.",
				"variables_measured": "Terminal brachlette (needles and stem) pressure-volume curves; apical branch xylem conductivity; stomatal conductance.",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-RMT4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.985511,
					38.9580112,
					2910.37
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-RMT4",
				"name": "RMBL Research Meadow PIEN4",
				"category": "SFA Collaborator",
				"instrumentation": "",
				"research_theme": "Tree traits, leaf physiology",
				"description": "Data used to characterize species differences in water-use strategies and transpiration rates.",
				"variables_measured": "Terminal brachlette (needles and stem) pressure-volume curves; apical branch xylem conductivity; stomatal conductance.",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-RMT5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.985663,
					38.95755356,
					2912.03
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-RMT5",
				"name": "RMBL Research Meadow PIEN5",
				"category": "SFA Collaborator",
				"instrumentation": "",
				"research_theme": "Tree traits, leaf physiology",
				"description": "Data used to characterize species differences in water-use strategies and transpiration rates.",
				"variables_measured": "Terminal brachlette (needles and stem) pressure-volume curves; apical branch xylem conductivity; stomatal conductance.",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-RMT6",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9875559,
					38.95771349,
					2889.47
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-RMT6",
				"name": "RMBL Research Meadow ABLA1",
				"category": "SFA Collaborator",
				"instrumentation": "",
				"research_theme": "Tree traits, leaf physiology",
				"description": "Data used to characterize species differences in water-use strategies and transpiration rates.",
				"variables_measured": "Terminal brachlette (needles and stem) pressure-volume curves; apical branch xylem conductivity; stomatal conductance.",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-RMT7",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9866935,
					38.95791657,
					2900.04
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-RMT7",
				"name": "RMBL Research Meadow ABLA2",
				"category": "SFA Collaborator",
				"instrumentation": "",
				"research_theme": "Tree traits, leaf physiology",
				"description": "Data used to characterize species differences in water-use strategies and transpiration rates.",
				"variables_measured": "Terminal brachlette (needles and stem) pressure-volume curves; apical branch xylem conductivity; stomatal conductance.",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-RMT8",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9865978,
					38.95789492,
					2905.65
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-RMT8",
				"name": "RMBL Research Meadow ABLA3",
				"category": "SFA Collaborator",
				"instrumentation": "",
				"research_theme": "Tree traits, leaf physiology",
				"description": "Data used to characterize species differences in water-use strategies and transpiration rates.",
				"variables_measured": "Terminal brachlette (needles and stem) pressure-volume curves; apical branch xylem conductivity; stomatal conductance.",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-RMT9",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9855968,
					38.95796062,
					2910.66
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-RMT9",
				"name": "RMBL Research Meadow ABLA4",
				"category": "SFA Collaborator",
				"instrumentation": "",
				"research_theme": "Tree traits, leaf physiology",
				"description": "Data used to characterize species differences in water-use strategies and transpiration rates.",
				"variables_measured": "Terminal brachlette (needles and stem) pressure-volume curves; apical branch xylem conductivity; stomatal conductance.",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-RMT10",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9855458,
					38.95750334,
					2914.96
				]
			},
			"properties": {
				"contact": {
					"name": "Lara Kueppers",
					"email": "lmkueppers@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-RMT10",
				"name": "RMBL Research Meadow ABLA5",
				"category": "SFA Collaborator",
				"instrumentation": "",
				"research_theme": "Tree traits, leaf physiology",
				"description": "Data used to characterize species differences in water-use strategies and transpiration rates.",
				"variables_measured": "Terminal brachlette (needles and stem) pressure-volume curves; apical branch xylem conductivity; stomatal conductance.",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SFX1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9708,
					38.92578,
					3019.88
				]
			},
			"properties": {
				"contact": {
					"name": "Max Berkelhammer",
					"email": "berkelha@uic.edu",
					"affiliation": "University of Illinois at Chicago"
				},
				"id": "SG-SFX1",
				"name": "Snodgrass Sapflux 1",
				"category": "SFA Collaborator",
				"instrumentation": "ICT SFM 1 standalone sap flux sensor",
				"research_theme": "Transpiration/Hydrogeology",
				"description": "Continuous sap flux measured on fir, spurce and aspen",
				"variables_measured": "Sap velocity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SFX2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9772,
					38.93018,
					3114.81
				]
			},
			"properties": {
				"contact": {
					"name": "Max Berkelhammer",
					"email": "berkelha@uic.edu",
					"affiliation": "University of Illinois at Chicago"
				},
				"id": "SG-SFX2",
				"name": "Snodgrass Sapflux 2",
				"category": "SFA Collaborator",
				"instrumentation": "ICT SFM 1 standalone sap flux sensor",
				"research_theme": "Transpiration/Hydrogeology",
				"description": "Continuous sap flux measured on fir, spurce and aspen",
				"variables_measured": "Sap velocity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SFX3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9796,
					38.92918,
					3177.78
				]
			},
			"properties": {
				"contact": {
					"name": "Max Berkelhammer",
					"email": "berkelha@uic.edu",
					"affiliation": "University of Illinois at Chicago"
				},
				"id": "SG-SFX3",
				"name": "Snodgrass Sapflux 3",
				"category": "SFA Collaborator",
				"instrumentation": "ICT SFM 1 standalone sap flux sensor",
				"research_theme": "Transpiration/Hydrogeology",
				"description": "Continuous sap flux measured on fir, spurce and aspen",
				"variables_measured": "Sap velocity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SFX4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9863,
					38.9276,
					3273.21
				]
			},
			"properties": {
				"contact": {
					"name": "Max Berkelhammer",
					"email": "berkelha@uic.edu",
					"affiliation": "University of Illinois at Chicago"
				},
				"id": "SG-SFX4",
				"name": "Snodgrass Sapflux 4",
				"category": "SFA Collaborator",
				"instrumentation": "ICT SFM 1 standalone sap flux sensor",
				"research_theme": "Transpiration/Hydrogeology",
				"description": "Continuous sap flux measured on fir, spurce and aspen",
				"variables_measured": "Sap velocity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SFX5",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9858,
					38.93207,
					3359.89
				]
			},
			"properties": {
				"contact": {
					"name": "Max Berkelhammer",
					"email": "berkelha@uic.edu",
					"affiliation": "University of Illinois at Chicago"
				},
				"id": "SG-SFX5",
				"name": "Snodgrass Sapflux 5",
				"category": "SFA Collaborator",
				"instrumentation": "ICT SFM 1 standalone sap flux sensor",
				"research_theme": "Transpiration/Hydrogeology",
				"description": "Continuous sap flux measured on fir, spurce and aspen",
				"variables_measured": "Sap velocity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SFX6",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9658,
					38.92759,
					2961.7
				]
			},
			"properties": {
				"contact": {
					"name": "Max Berkelhammer",
					"email": "berkelha@uic.edu",
					"affiliation": "University of Illinois at Chicago"
				},
				"id": "SG-SFX6",
				"name": "Snodgrass Sapflux 6",
				"category": "SFA Collaborator",
				"instrumentation": "ICT SFM 1 standalone sap flux sensor",
				"research_theme": "Transpiration/Hydrogeology",
				"description": "Continuous sap flux measured on fir, spurce and aspen",
				"variables_measured": "Sap velocity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SFX7",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9852,
					38.95765,
					2913
				]
			},
			"properties": {
				"contact": {
					"name": "Max Berkelhammer",
					"email": "berkelha@uic.edu",
					"affiliation": "University of Illinois at Chicago"
				},
				"id": "ER-SFX7",
				"name": "Research Meadow Sapflux 7",
				"category": "SFA Collaborator",
				"instrumentation": "ICT SFM 1 standalone sap flux sensor",
				"research_theme": "Transpiration/Hydrogeology",
				"description": "Continuous sap flux measured on fir, spurce and aspen",
				"variables_measured": "Sap velocity",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation",
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "Almont_Enquist",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.860992,
					38.654421,
					2467.26
				]
			},
			"properties": {
				"contact": {
					"name": "Brian Enquist",
					"email": "benquist@email.arizona.edu",
					"affiliation": "University of Arizona"
				},
				"id": "Almont_Enquist",
				"name": "Almont_Enquist",
				"category": "SFA Collaborator",
				"instrumentation": "Phenocam",
				"research_theme": "",
				"description": "Phenocam",
				"variables_measured": "Photographs",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CBT_Enquist_2012_2014",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.980441,
					38.881751,
					2706.23
				]
			},
			"properties": {
				"contact": {
					"name": "Brian Enquist",
					"email": "benquist@email.arizona.edu",
					"affiliation": "University of Arizona"
				},
				"id": "CBT_Enquist_2012_2014",
				"name": "CBT_Enquist_2012_2014",
				"category": "SFA Collaborator",
				"instrumentation": "Phenocam",
				"research_theme": "",
				"description": "Phenocam",
				"variables_measured": "Photographs",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "CBT_Enquist_2015_2017",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.980293,
					38.88167,
					2706.15
				]
			},
			"properties": {
				"contact": {
					"name": "Brian Enquist",
					"email": "benquist@email.arizona.edu",
					"affiliation": "University of Arizona"
				},
				"id": "CBT_Enquist_2015_2017",
				"name": "CBT_Enquist_2015_2017",
				"category": "SFA Collaborator",
				"instrumentation": "Phenocam",
				"research_theme": "",
				"description": "Phenocam",
				"variables_measured": "Photographs",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "PBM_Enquist_2014_2016",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04111,
					38.96935,
					3372.36
				]
			},
			"properties": {
				"contact": {
					"name": "Brian Enquist",
					"email": "benquist@email.arizona.edu",
					"affiliation": "University of Arizona"
				},
				"id": "PBM_Enquist_2014_2016",
				"name": "PBM_Enquist_2014_2016",
				"category": "SFA Collaborator",
				"instrumentation": "Phenocam",
				"research_theme": "",
				"description": "Phenocam",
				"variables_measured": "Photographs",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "PBM_Enquist_2017",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04088,
					38.969139,
					3369.88
				]
			},
			"properties": {
				"contact": {
					"name": "Brian Enquist",
					"email": "benquist@email.arizona.edu",
					"affiliation": "University of Arizona"
				},
				"id": "PBM_Enquist_2017",
				"name": "PBM_Enquist_2017",
				"category": "SFA Collaborator",
				"instrumentation": "Phenocam",
				"research_theme": "",
				"description": "Phenocam",
				"variables_measured": "Photographs",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "Pfeiler_Enquist_2012_2016",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.031093,
					38.960805,
					3176.39
				]
			},
			"properties": {
				"contact": {
					"name": "Brian Enquist",
					"email": "benquist@email.arizona.edu",
					"affiliation": "University of Arizona"
				},
				"id": "Pfeiler_Enquist_2012_2016",
				"name": "Pfeiler_Enquist_2012_2016",
				"category": "SFA Collaborator",
				"instrumentation": "Phenocam",
				"research_theme": "",
				"description": "Phenocam",
				"variables_measured": "Photographs",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "Pfeiler_Enquist_2017",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.031272,
					38.96056,
					3169.58
				]
			},
			"properties": {
				"contact": {
					"name": "Brian Enquist",
					"email": "benquist@email.arizona.edu",
					"affiliation": "University of Arizona"
				},
				"id": "Pfeiler_Enquist_2017",
				"name": "Pfeiler_Enquist_2017",
				"category": "SFA Collaborator",
				"instrumentation": "Phenocam",
				"research_theme": "",
				"description": "Phenocam",
				"variables_measured": "Photographs",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "Road_Enquist_2012_2016",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.978616,
					38.897206,
					2811.35
				]
			},
			"properties": {
				"contact": {
					"name": "Brian Enquist",
					"email": "benquist@email.arizona.edu",
					"affiliation": "University of Arizona"
				},
				"id": "Road_Enquist_2012_2016",
				"name": "Road_Enquist_2012_2016",
				"category": "SFA Collaborator",
				"instrumentation": "Phenocam",
				"research_theme": "",
				"description": "Phenocam",
				"variables_measured": "Photographs",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "Road_Enquist_2017",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.978186,
					38.897171,
					2807.11
				]
			},
			"properties": {
				"contact": {
					"name": "Brian Enquist",
					"email": "benquist@email.arizona.edu",
					"affiliation": "University of Arizona"
				},
				"id": "Road_Enquist_2017",
				"name": "Road_Enquist_2017",
				"category": "SFA Collaborator",
				"instrumentation": "Phenocam",
				"research_theme": "",
				"description": "Phenocam",
				"variables_measured": "Photographs",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "Baldy_Enquist",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0369021,
					38.97378285,
					3464.03
				]
			},
			"properties": {
				"contact": {
					"name": "Brian Enquist",
					"email": "benquist@email.arizona.edu",
					"affiliation": "University of Arizona"
				},
				"id": "Baldy_Enquist",
				"name": "Baldy",
				"category": "SFA Collaborator",
				"instrumentation": "Phenocam",
				"research_theme": "",
				"description": "Phenocam",
				"variables_measured": "Photographs",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "Lowermontane_Enquist",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9488181,
					38.92014512,
					2778.23
				]
			},
			"properties": {
				"contact": {
					"name": "Brian Enquist",
					"email": "benquist@email.arizona.edu",
					"affiliation": "University of Arizona"
				},
				"id": "Lowermontane_Enquist",
				"name": "Lowermontane",
				"category": "SFA Collaborator",
				"instrumentation": "Phenocam",
				"research_theme": "",
				"description": "Phenocam",
				"variables_measured": "Photographs",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "Pfeiler_Enquist",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0288438,
					38.9555559,
					3114.78
				]
			},
			"properties": {
				"contact": {
					"name": "Brian Enquist",
					"email": "benquist@email.arizona.edu",
					"affiliation": "University of Arizona"
				},
				"id": "Pfeiler_Enquist",
				"name": "Pfeiler",
				"category": "SFA Collaborator",
				"instrumentation": "Phenocam",
				"research_theme": "",
				"description": "Phenocam",
				"variables_measured": "Photographs",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "Uppermontane_Enquist",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0085358,
					38.93262502,
					2943.69
				]
			},
			"properties": {
				"contact": {
					"name": "Brian Enquist",
					"email": "benquist@email.arizona.edu",
					"affiliation": "University of Arizona"
				},
				"id": "Uppermontane_Enquist",
				"name": "Uppermontane",
				"category": "SFA Collaborator",
				"instrumentation": "Phenocam",
				"research_theme": "",
				"description": "Phenocam",
				"variables_measured": "Photographs",
				"measurement_categories": [
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-RMP1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.985268,
					38.957829,
					2913.7
				]
			},
			"properties": {
				"contact": {
					"name": "Mariah S Carbone",
					"email": "mariah.carbone@nau.edu",
					"affiliation": "NAU"
				},
				"id": "ER-RMP1",
				"name": "RMBL Research Meadow Soil Pits",
				"category": "SFA Collaborator",
				"instrumentation": "For each pit there are temperature, moisture, and soil CO2 sensors at 50cm, 15cm, 5cm, 0cm depths. And additional soil CO2 probe and temperature sensor is at 1.5m above the ground. All measurements are hourly.",
				"research_theme": "Soil Carbon cycling",
				"description": "Two soil pits: one in the aspen stand, one in the spruce/fir stand.",
				"variables_measured": "Soil CO2 concentration; temperature; moisture",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMA1-115",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9559947,
					38.917216053,
					2926.62
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMA1-115",
				"name": 115,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMA1-116",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.955994698,
					38.917216053,
					2926.62
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMA1-116",
				"name": 116,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMA1-117",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.955994698,
					38.917216053,
					2926.62
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMA1-117",
				"name": 117,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB1-118",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948286972,
					38.920399525,
					2767.93
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB1-118",
				"name": 118,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB1-119",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948286972,
					38.920399525,
					2767.93
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB1-119",
				"name": 119,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB1-120",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948286972,
					38.920399525,
					2767.93
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB1-120",
				"name": 120,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB1-121",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948286622,
					38.920405996,
					2767.9
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB1-121",
				"name": 121,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB1-122",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948286622,
					38.920405996,
					2767.9
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB1-122",
				"name": 122,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB1-123",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948286622,
					38.920405996,
					2767.9
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB1-123",
				"name": 123,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMA1-134",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948918934,
					38.920281155,
					2776.06
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMA1-134",
				"name": 134,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMA1-135",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948918934,
					38.920281155,
					2776.06
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMA1-135",
				"name": 135,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMA2-139",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948918934,
					38.920281155,
					2776.06
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMA2-139",
				"name": 139,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMA2-140",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948918934,
					38.920281155,
					2776.06
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMA2-140",
				"name": 140,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMA2-141",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948918934,
					38.920281155,
					2776.06
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMA2-141",
				"name": 141,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB1-142",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948452785,
					38.92045766,
					2767.69
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB1-142",
				"name": 142,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB1-143",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948452785,
					38.92045766,
					2767.69
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB1-143",
				"name": 143,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB1-144",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948452785,
					38.92045766,
					2767.69
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB1-144",
				"name": 144,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB1-145",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948452785,
					38.92045766,
					2767.69
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB1-145",
				"name": 145,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB1-146",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948452785,
					38.92045766,
					2767.69
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB1-146",
				"name": 146,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB1-147",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948452785,
					38.92045766,
					2767.69
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB1-147",
				"name": 147,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB1-148",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948452785,
					38.92045766,
					2767.69
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB1-148",
				"name": 148,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB1-149",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948452785,
					38.92045766,
					2767.69
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB1-149",
				"name": 149,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB1-150",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948452785,
					38.92045766,
					2767.69
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB1-150",
				"name": 150,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMC1-151",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948748019,
					38.920576363,
					2766.94
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMC1-151",
				"name": 151,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMC1-152",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948748019,
					38.920576363,
					2766.94
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMC1-152",
				"name": 152,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMC1-153",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948748019,
					38.920576363,
					2766.94
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMC1-153",
				"name": 153,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMC1-157",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948748019,
					38.920576363,
					2766.94
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMC1-157",
				"name": 157,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMC1-158",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948748019,
					38.920576363,
					2766.94
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMC1-158",
				"name": 158,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMC1-159",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948748019,
					38.920576363,
					2766.94
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMC1-159",
				"name": 159,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMA2-181",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948759261,
					38.920297724,
					2774.85
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMA2-181",
				"name": 181,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMA2-182",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948759261,
					38.920297724,
					2774.85
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMA2-182",
				"name": 182,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMA2-183",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948759261,
					38.920297724,
					2774.85
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMA2-183",
				"name": 183,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB1-184",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948394713,
					38.920307005,
					2771.63
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB1-184",
				"name": 184,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB1-185",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948394713,
					38.920307005,
					2771.63
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB1-185",
				"name": 185,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB1-186",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948394713,
					38.920307005,
					2771.63
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB1-186",
				"name": 186,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB2-193",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9484972,
					38.920405922,
					2769.69
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB2-193",
				"name": 193,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB2-194",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9484972,
					38.920405922,
					2769.69
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB2-194",
				"name": 194,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB2-195",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9484972,
					38.920405922,
					2769.69
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB2-195",
				"name": 195,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMC1-196",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948682649,
					38.920405856,
					2771.69
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMC1-196",
				"name": 196,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMC1-197",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948682649,
					38.920405856,
					2771.69
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMC1-197",
				"name": 197,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMC1-198",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948682649,
					38.920405856,
					2771.69
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMC1-198",
				"name": 198,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMC2-202",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948817965,
					38.920442553,
					2771.5
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMC2-202",
				"name": 202,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMC2-203",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948817965,
					38.920442553,
					2771.5
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMC2-203",
				"name": 203,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMC2-204",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948817965,
					38.920442553,
					2771.5
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMC2-204",
				"name": 204,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMA2-355",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.94875775,
					38.920294564,
					2774.89
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMA2-355",
				"name": 355,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMA2-356",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.94875775,
					38.920294564,
					2774.89
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMA2-356",
				"name": 356,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMA2-357",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.94875775,
					38.920294564,
					2774.89
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMA2-357",
				"name": 357,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB2-367",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948476151,
					38.920406451,
					2769.35
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB2-367",
				"name": 367,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB2-368",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948476151,
					38.920406451,
					2769.35
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB2-368",
				"name": 368,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMB2-369",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948476151,
					38.920406451,
					2769.35
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMB2-369",
				"name": 369,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMC2-379",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948785516,
					38.920487572,
					2770.27
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMC2-379",
				"name": 379,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMC2-380",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948785516,
					38.920487572,
					2770.27
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMC2-380",
				"name": 380,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LMC2-381",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948785516,
					38.920487572,
					2770.27
				]
			},
			"properties": {
				"contact": {
					"name": "Eoin Brodie",
					"email": "elbrodie@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LMC2-381",
				"name": 381,
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Plant and Microbial Phenology",
				"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
				"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SPS1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.976111,
					38.926111,
					3128.78
				]
			},
			"properties": {
				"contact": {
					"name": "Matthias Sprenger",
					"email": "msprenger@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SG-SPS1",
				"name": "Conifers on Granodiorite",
				"category": "SFA Intensive",
				"instrumentation": "",
				"research_theme": "Hydrogeology, Biogeochemistry, Microbiology",
				"description": "Soil and plant sampling for isotope and biogeochemical, microbiological analyeses",
				"variables_measured": "2H & 18O (H2O); 15N, 17O, 18O (NO3); 87Sr/ 86Sr + 44Ca; N; DOC; DOM; Microbiology ",
				"measurement_categories": [
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SPS2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98,
					38.92625,
					3146.68
				]
			},
			"properties": {
				"contact": {
					"name": "Matthias Sprenger",
					"email": "msprenger@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SG-SPS2",
				"name": "Meadow",
				"category": "SFA Intensive",
				"instrumentation": "",
				"research_theme": "Hydrogeology, Biogeochemistry, Microbiology",
				"description": "Soil and plant sampling for isotope and biogeochemical, microbiological analyeses",
				"variables_measured": "2H & 18O (H2O); 15N, 17O, 18O (NO3); 87Sr/ 86Sr + 44Ca; N; DOC; DOM; Microbiology ",
				"measurement_categories": [
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SPS3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.977,
					38.92565,
					3120.61
				]
			},
			"properties": {
				"contact": {
					"name": "Matthias Sprenger",
					"email": "msprenger@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SG-SPS3",
				"name": "Conifers on Shale",
				"category": "SFA Intensive",
				"instrumentation": "",
				"research_theme": "Hydrogeology, Biogeochemistry, Microbiology",
				"description": "Soil and plant sampling for isotope and biogeochemical, microbiological analyeses",
				"variables_measured": "2H & 18O (H2O); 15N, 17O, 18O (NO3); 87Sr/ 86Sr + 44Ca; N; DOC; DOM; Microbiology ",
				"measurement_categories": [
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "SG-SPS4",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9708,
					38.92578,
					3019.88
				]
			},
			"properties": {
				"contact": {
					"name": "Matthias Sprenger",
					"email": "msprenger@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "SG-SPS4",
				"name": "Aspen on Shale",
				"category": "SFA Intensive",
				"instrumentation": "",
				"research_theme": "Hydrogeology, Biogeochemistry, Microbiology",
				"description": "Soil and plant sampling for isotope and biogeochemical, microbiological analyeses",
				"variables_measured": "2H & 18O (H2O); 15N, 17O, 18O (NO3); 87Sr/ 86Sr + 44Ca; N; DOC; DOM; Microbiology ",
				"measurement_categories": [
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-LLN1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.948333,
					38.920555,
					2764.91
				]
			},
			"properties": {
				"contact": {
					"name": "Ben Gilbert",
					"email": "bgilbert@lbl.gov",
					"affiliation": "LBNL"
				},
				"id": "ER-LLN1",
				"name": "North Facing Hillslope Sagebrush Site 1",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Subsurface deep-root inducing rock weathering",
				"description": "Geochemical analysis and metagenomic of soil and root rhizosphere",
				"variables_measured": "Soil geochemical analysis, water content, microbiology, metabolomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T1-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0031454,
					38.97796352,
					2926.06
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T1-0m",
				"name": "Meander G, Banfield Transect 1: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T1-19m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0030383,
					38.97780667,
					2925.98
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T1-19m",
				"name": "Meander G, Banfield Transect 1: 19m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T1-38m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0029515,
					38.97765246,
					2925.69
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T1-38m",
				"name": "Meander G, Banfield Transect 1: 38m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T1-57m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0028515,
					38.97751102,
					2925.88
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T1-57m",
				"name": "Meander G, Banfield Transect 1: 57m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T2-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0030191,
					38.97818072,
					2925.49
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T2-0m",
				"name": "Meander G, Banfield Transect 2: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T2-22m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0028979,
					38.97799937,
					2925.66
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T2-22m",
				"name": "Meander G, Banfield Transect 2: 22m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T2-44m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.002778,
					38.97782265,
					2925.75
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T2-44m",
				"name": "Meander G, Banfield Transect 2: 44m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T2-66m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0026628,
					38.97765338,
					2925.59
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T2-66m",
				"name": "Meander G, Banfield Transect 2: 66m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T3-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.002696,
					38.97806743,
					2925.13
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T3-0m",
				"name": "Meander G, Banfield Transect 3: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T3-19m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0025907,
					38.97791787,
					2925.47
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T3-19m",
				"name": "Meander G, Banfield Transect 3: 19m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T3-38m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0024813,
					38.97777158,
					2925.52
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T3-38m",
				"name": "Meander G, Banfield Transect 3: 38m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T3-57m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0023841,
					38.97761482,
					2925.23
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T3-57m",
				"name": "Meander G, Banfield Transect 3: 57m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T4-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0024506,
					38.97799882,
					2925.38
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T4-0m",
				"name": "Meander G, Banfield Transect 4: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T4-18m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0023256,
					38.9778785,
					2925.92
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T4-18m",
				"name": "Meander G, Banfield Transect 4: 18m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T4-36m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0022256,
					38.97773274,
					2925.21
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T4-36m",
				"name": "Meander G, Banfield Transect 4: 36m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T4-54m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0021148,
					38.97759448,
					2925
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T4-54m",
				"name": "Meander G, Banfield Transect 4: 54m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T5-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0032328,
					38.97790012,
					2926.2
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T5-0m",
				"name": "Meander G, Banfield Transect 5: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T5-13m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0031251,
					38.97797787,
					2926.12
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T5-13m",
				"name": "Meander G, Banfield Transect 5: 13m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T5-26m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0030096,
					38.97806503,
					2925.85
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T5-26m",
				"name": "Meander G, Banfield Transect 5: 26m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T5-39m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0029099,
					38.97814385,
					2925.69
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T5-39m",
				"name": "Meander G, Banfield Transect 5: 39m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T6-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0030271,
					38.97777495,
					2925.96
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T6-0m",
				"name": "Meander G, Banfield Transect 6: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T6-15m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.002895,
					38.97786211,
					2925.68
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T6-15m",
				"name": "Meander G, Banfield Transect 6: 15m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T6-30m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0027664,
					38.97795089,
					2925.72
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T6-30m",
				"name": "Meander G, Banfield Transect 6: 30m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T6-42m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0026456,
					38.97804542,
					2925.63
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T6-42m",
				"name": "Meander G, Banfield Transect 6: 42m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T7-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0029218,
					38.97756833,
					2925.87
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T7-0m",
				"name": "Meander G, Banfield Transect 7: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T7-23m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00273,
					38.97770911,
					2925.56
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T7-23m",
				"name": "Meander G, Banfield Transect 7: 23m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T7-45m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0025408,
					38.97785589,
					2925.67
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T7-45m",
				"name": "Meander G, Banfield Transect 7: 45m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T7-69m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0023516,
					38.97798779,
					2925.15
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T7-69m",
				"name": "Meander G, Banfield Transect 7: 69m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T8-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0024421,
					38.97765067,
					2925.67
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T8-0m",
				"name": "Meander G, Banfield Transect 8: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T8-14m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.002317,
					38.97774113,
					2925.33
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T8-14m",
				"name": "Meander G, Banfield Transect 8: 14m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T8-28m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0022098,
					38.97783142,
					2925.43
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T8-28m",
				"name": "Meander G, Banfield Transect 8: 28m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMG-T8-42m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0020967,
					38.97791529,
					2925.34
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMG-T8-42m",
				"name": "Meander G, Banfield Transect 8: 42m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T1-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9514187,
					38.92240419,
					2760.15
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T1-0m",
				"name": "Meander L, Banfield Transect 1: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T1-21m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9512126,
					38.92247307,
					2760.3
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T1-21m",
				"name": "Meander L, Banfield Transect 1: 31m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T1-42m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9509952,
					38.92256114,
					2760.06
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T1-42m",
				"name": "Meander L, Banfield Transect 1: 32m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T1-63m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9507774,
					38.92265306,
					2759.99
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T1-63m",
				"name": "Meander L, Banfield Transect 1: 63m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T2-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9518147,
					38.92241153,
					2760.2
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T2-0m",
				"name": "Meander L, Banfield Transect 2: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T2-31m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9515103,
					38.92253739,
					2759.98
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T2-31m",
				"name": "Meander L, Banfield Transect 2: 31m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T2-62m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9511996,
					38.92267205,
					2760.04
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T2-62m",
				"name": "Meander L, Banfield Transect 2: 62m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T2-93m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9508934,
					38.92280431,
					2759.99
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T2-93m",
				"name": "Meander L, Banfield Transect 2: 93m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T3-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9521814,
					38.92255065,
					2760.18
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T3-0m",
				"name": "Meander L, Banfield Transect 3: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T3-33m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9518593,
					38.92269322,
					2760.08
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T3-33m",
				"name": "Meander L, Banfield Transect 3: 33m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T3-66m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9515113,
					38.92282932,
					2759.76
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T3-66m",
				"name": "Meander L, Banfield Transect 3: 66m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T3-99m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9511746,
					38.92297587,
					2759.75
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T3-99m",
				"name": "Meander L, Banfield Transect 3: 99m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T4-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9523002,
					38.9227381,
					2760.19
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T4-0m",
				"name": "Meander L, Banfield Transect 4: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T4-33m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9519776,
					38.9228743,
					2760.06
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T4-33m",
				"name": "Meander L, Banfield Transect 4: 33m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T4-66m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9516517,
					38.92302234,
					2759.87
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T4-66m",
				"name": "Meander L, Banfield Transect 4: 66m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T4-99m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9513188,
					38.9231868,
					2760.02
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T4-99m",
				"name": "Meander L, Banfield Transect 4: 99m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T5-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9514759,
					38.92342372,
					2760.19
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T5-0m",
				"name": "Meander L, Banfield Transect 5: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T5-30m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9513126,
					38.92318997,
					2759.99
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T5-30m",
				"name": "Meander L, Banfield Transect 5: 30m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T5-60m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9511378,
					38.9229531,
					2759.85
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T5-60m",
				"name": "Meander L, Banfield Transect 5: 60m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T5-90m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9509661,
					38.92271612,
					2760.02
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T5-90m",
				"name": "Meander L, Banfield Transect 5: 90m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T6-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9516224,
					38.92335709,
					2760.19
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T6-0m",
				"name": "Meander L, Banfield Transect 6: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T6-30m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9514495,
					38.92312587,
					2759.9
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T6-30m",
				"name": "Meander L, Banfield Transect 6: 30m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T6-60m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9512875,
					38.92288236,
					2759.84
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T6-60m",
				"name": "Meander L, Banfield Transect 6: 60m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T6-90m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9511332,
					38.92264565,
					2760.08
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T6-90m",
				"name": "Meander L, Banfield Transect 6: 90m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T7-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9519148,
					38.92324636,
					2760.19
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T7-0m",
				"name": "Meander L, Banfield Transect 7: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T7-30m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9517289,
					38.92299299,
					2759.71
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T7-30m",
				"name": "Meander L, Banfield Transect 7: 30m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T7-60m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9515819,
					38.92276159,
					2759.84
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T7-60m",
				"name": "Meander L, Banfield Transect 7: 60m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T7-90m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9514294,
					38.92253775,
					2760.15
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T7-90m",
				"name": "Meander L, Banfield Transect 7: 90m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T8-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9521913,
					38.92311363,
					2760.04
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T8-0m",
				"name": "Meander L, Banfield Transect 8: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T8-30m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9520442,
					38.92287056,
					2759.98
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T8-30m",
				"name": "Meander L, Banfield Transect 8: 30m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T8-60m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9518819,
					38.92264199,
					2759.96
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T8-60m",
				"name": "Meander L, Banfield Transect 8: 60m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERML-T8-90m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9517276,
					38.92239714,
					2760.39
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERML-T8-90m",
				"name": "Meander L, Banfield Transect 8: 90m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T1-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9077099,
					38.8898623,
					2723.69
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T1-0m",
				"name": "Meander Z, Banfield Transect 1: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T1-33m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9080679,
					38.88976922,
					2723.85
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T1-33m",
				"name": "Meander Z, Banfield Transect 1: 33m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T1-66m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9084319,
					38.8896764,
					2723.9
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T1-66m",
				"name": "Meander Z, Banfield Transect 1: 66m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T1-99m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.908791,
					38.88958068,
					2723.99
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T1-99m",
				"name": "Meander Z, Banfield Transect 1: 99m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T2-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9075512,
					38.88979864,
					2723.75
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T2-0m",
				"name": "Meander Z, Banfield Transect 2: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T2-33m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9079111,
					38.88969895,
					2723.82
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T2-33m",
				"name": "Meander Z, Banfield Transect 2: 33m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T2-66m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9082668,
					38.88960357,
					2723.7
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T2-66m",
				"name": "Meander Z, Banfield Transect 2: 66m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T2-99m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9086226,
					38.8895031,
					2723.84
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T2-99m",
				"name": "Meander Z, Banfield Transect 2: 99m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T3-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9073786,
					38.88969705,
					2723.64
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T3-0m",
				"name": "Meander Z, Banfield Transect 3: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T3-33m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9077378,
					38.88959798,
					2723.72
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T3-33m",
				"name": "Meander Z, Banfield Transect 3: 33m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T3-66m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9081093,
					38.88949776,
					2723.6
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T3-66m",
				"name": "Meander Z, Banfield Transect 3: 66m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T3-99m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9084615,
					38.88940349,
					2723.56
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T3-99m",
				"name": "Meander Z, Banfield Transect 3: 99m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T4-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9073083,
					38.88955405,
					2723.53
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T4-0m",
				"name": "Meander Z, Banfield Transect 4: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T4-23m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9075667,
					38.88950122,
					2723.59
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T4-23m",
				"name": "Meander Z, Banfield Transect 4: 23m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T4-46m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9078274,
					38.88945593,
					2723.56
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T4-46m",
				"name": "Meander Z, Banfield Transect 4: 46m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T4-69m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9080823,
					38.88939892,
					2723.61
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T4-69m",
				"name": "Meander Z, Banfield Transect 4: 69m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T5-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9085817,
					38.88967134,
					2723.91
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T5-0m",
				"name": "Meander Z, Banfield Transect 5: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T5-17m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9084602,
					38.88956016,
					2723.74
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T5-17m",
				"name": "Meander Z, Banfield Transect 5:17m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T5-34m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9083345,
					38.88944015,
					2723.5
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T5-34m",
				"name": "Meander Z, Banfield Transect 5: 34m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T5-51m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9082076,
					38.88932277,
					2723.6
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T5-51m",
				"name": "Meander Z, Banfield Transect 5: 51m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T6-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9083451,
					38.88976135,
					2723.93
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T6-0m",
				"name": "Meander Z, Banfield Transect 6: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T6-20m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9081957,
					38.88962425,
					2723.71
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T6-20m",
				"name": "Meander Z, Banfield Transect 6: 20m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T6-40m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9080441,
					38.88948842,
					2723.6
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T6-40m",
				"name": "Meander Z, Banfield Transect 6: 40m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T6-60m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9078949,
					38.8893505,
					2723.56
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T6-60m",
				"name": "Meander Z, Banfield Transect 6: 60m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T7-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9080462,
					38.88978301,
					2723.47
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T7-0m",
				"name": "Meander Z, Banfield Transect 7: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T7-18m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9079104,
					38.88964534,
					2723.69
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T7-18m",
				"name": "Meander Z, Banfield Transect 7: 18m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T7-36m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9077727,
					38.88953387,
					2723.64
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T7-36m",
				"name": "Meander Z, Banfield Transect 7: 36m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T7-54m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9076365,
					38.88941233,
					2723.63
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T7-54m",
				"name": "Meander Z, Banfield Transect 7: 54m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T8-0m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9078348,
					38.8898624,
					2723.55
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T8-0m",
				"name": "Meander Z, Banfield Transect 8: 0m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T8-20m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9076814,
					38.88972594,
					2723.81
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T8-20m",
				"name": "Meander Z, Banfield Transect 8: 20m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T8-40m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9075294,
					38.88958657,
					2723.78
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T8-40m",
				"name": "Meander Z, Banfield Transect 8: 40m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ERMZ-T8-60m",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9073811,
					38.88944698,
					2723.56
				]
			},
			"properties": {
				"contact": {
					"name": "Jill Banfield",
					"email": "jbanfield@berkeley.edu",
					"affiliation": "UC Berkeley"
				},
				"id": "ERMZ-T8-60m",
				"name": "Meander Z, Banfield Transect 8: 60m",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Metagenomics of the East River riparian zone",
				"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
				"variables_measured": "Genome-resolved metagenomics",
				"measurement_categories": [
					"biogeochemistry"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "001-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9861,
					38.957229,
					2908.88
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "001-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"001-ER18_1M8Yf1i2VjaoAa1y0ixG7_VyJBlErqEix"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "002-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9861,
					38.957288,
					2908.88
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "002-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"002-ER18_1VeP3Zc2Wfrkwyrq-eTvKtgIRYnM72emx"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "003-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98616,
					38.957368,
					2908.38
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "003-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"003-ER18_1vEnBHHxEXKC0T8tKdP8MxVdes8GF4TUo"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "004-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98611,
					38.957477,
					2908.43
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "004-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"004-ER18_1kNdzN56MWsD2sXJCLg5Lj9JRvw2L4TiO"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "005-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98623,
					38.957461,
					2907.91
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "005-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "006-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98483,
					38.957868,
					2915.43
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "006-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"006-ER18_1QRFC1u9728Wa4EIruhHuQK3p5ZPxb7yp"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "007-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98475,
					38.957824,
					2916.53
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "007-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "008-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98483,
					38.957823,
					2915.88
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "008-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "009-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9845,
					38.957937,
					2918.16
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "009-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "010-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95189,
					38.921891,
					2767.98
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "010-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"010-ER18_1j165RaP-jDI_mtkUJa47eFZAhD__O0lw"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "011-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95211,
					38.921874,
					2769.54
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "011-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "012-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9522,
					38.921828,
					2771.03
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "012-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "013-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95241,
					38.921662,
					2775.28
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "013-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "014-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95265,
					38.921775,
					2777.12
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "014-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "015-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95262,
					38.921582,
					2779.8
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "015-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "016-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95276,
					38.921584,
					2782.47
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "016-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "017-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95267,
					38.921531,
					2781.63
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "017-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "018-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95302,
					38.921552,
					2790.71
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "018-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"018-ER18_1X3ztxvSxKE7thV3t0etcsA1H7qo7fWaH"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "019-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95282,
					38.92152,
					2785.83
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "019-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "020-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06585,
					38.991241,
					3455.53
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "020-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "021-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98749,
					38.95691,
					2891.08
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "021-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "022-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98741,
					38.956973,
					2891.56
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "022-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "023-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98684,
					38.957091,
					2901.96
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "023-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "024-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98672,
					38.957034,
					2902.78
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "024-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"024-ER18_1Ih_4RpBXse6184d88br1k--hXTBAByl3"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "025-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98629,
					38.956726,
					2909.32
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "025-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "026-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98646,
					38.956511,
					2910.78
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "026-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "027-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98619,
					38.956822,
					2908.25
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "027-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "028-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98611,
					38.956765,
					2909.78
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "028-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"028-ER18_1v9qYVqvffz8qmNWJGyUzishQm2GJHV1y"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "029-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98575,
					38.956699,
					2912.09
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "029-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "030-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98593,
					38.956705,
					2912.76
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "030-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"030-ER18_1wTdaxgQBmOlmxX3Lgd0azD1L83TuJU-F"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "031-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98615,
					38.95712,
					2908.71
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "031-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "032-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9856,
					38.95769,
					2910.92
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "032-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"032-ER18_1YlJDfsBjZbilfH_o1hLUBcy5XfimEQUV"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "033-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95356,
					38.92172,
					2799.83
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "033-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"033-ER18_14yWpkYYa86gdH6puwjSQZYGzrZPB_VAt"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "034-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95376,
					38.921865,
					2797.37
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "034-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "035-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95145,
					38.920659,
					2784.33
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "035-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "036-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95147,
					38.920605,
					2787.03
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "036-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "037-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95134,
					38.920454,
					2788.48
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "037-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "038-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95135,
					38.92037,
					2792.44
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "038-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "039-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95163,
					38.920603,
					2790.73
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "039-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "040-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95154,
					38.920632,
					2787.59
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "040-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "041-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95173,
					38.919704,
					2825.05
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "041-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "042-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95154,
					38.919887,
					2813.41
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "042-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "043-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98046,
					38.927272,
					3173.28
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "043-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "044-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95093,
					38.920993,
					2773.16
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "044-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"044-ER18_1ijgtyLZjTSiYNzg4JQ5IL7bpHySNZizY"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "045-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95081,
					38.920918,
					2774.17
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "045-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "046-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95097,
					38.920866,
					2775.39
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "046-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "047-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9508,
					38.920941,
					2773.81
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "047-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "048-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95091,
					38.920768,
					2777.55
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "048-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "050-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95087,
					38.920598,
					2781.39
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "050-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "051-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95117,
					38.920701,
					2779.61
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "051-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "052-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95086,
					38.920868,
					2775.41
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "052-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "053-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95135,
					38.920851,
					2777.59
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "053-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "054-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95118,
					38.920831,
					2776.69
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "054-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "055-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.94999,
					38.923004,
					2759.56
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "055-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "056-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.94965,
					38.923082,
					2758.92
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "056-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "057-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95009,
					38.92248,
					2760.4
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "057-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "058-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95018,
					38.92201,
					2760.4
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "058-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "059-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95035,
					38.92202,
					2761.2
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "059-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "060-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95052,
					38.921769,
					2762.93
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "060-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "061-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95174,
					38.921533,
					2770.53
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "061-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "062-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95146,
					38.921254,
					2768.63
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "062-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "063-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95165,
					38.921183,
					2771.14
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "063-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "064-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.95114,
					38.920534,
					2784.11
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "064-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "065-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97917,
					38.927266,
					3155.5
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "065-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"065-ER18_1bElv-IgFqW3F_Xjez6lkBCSbrfkpSqb0"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "066-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97933,
					38.927241,
					3157.35
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "066-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"066-ER18_13AEse1W8xze_zsM7i-j-EyrFS3Yy1ZKt"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "067-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97924,
					38.927039,
					3154.69
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "067-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "068-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97936,
					38.927114,
					3156.95
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "068-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"068-ER18_12D3AyzXTjMoLaexasXPJsHv4VDzeeV-M"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "069-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97941,
					38.927235,
					3159.28
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "069-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "070-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9795,
					38.927161,
					3160.01
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "070-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "071-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97352,
					38.926902,
					3062.34
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "071-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "072-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97351,
					38.926992,
					3060.73
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "072-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"072-ER18_1tDNnDXKzpSTxGYTrGwadq-4ReucYKMfp"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "073-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97366,
					38.926899,
					3066.38
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "073-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "074-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97319,
					38.927083,
					3050
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "074-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"074-ER18_1zTM7CQ9kFfEt4ep1JrcDF7LjnxbCR6sp"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "075-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97304,
					38.92705,
					3046.03
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "075-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "076-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97306,
					38.92709,
					3046.08
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "076-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"076-ER18_1nZaNckHtC_OSB_SGCW8YonqWvGCvKfLj"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "077-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97288,
					38.927026,
					3042.32
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "077-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "078-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97277,
					38.927014,
					3040.15
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "078-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"078-ER18_14J9_i2nH92fn2_RATy4D92pM9qSjHsnh"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "079-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97268,
					38.927011,
					3038.42
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "079-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "080-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9723,
					38.927247,
					3030.69
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "080-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"080-ER18_1brO_ZKWrE7Tuj2LR-sJX-shlCNsO4b4e"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "081-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97265,
					38.927043,
					3037.44
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "081-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "082-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97255,
					38.927301,
					3033.8
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "082-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"082-ER18_1L_IP3NhgvxyUgrZEs9S21e8WXCZrN_fH"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "083-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97262,
					38.927066,
					3037.05
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "083-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"083-ER18_1g7d4DwsQJ9050KDa9heHIOSxsLy1oazi"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "084-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97243,
					38.927547,
					3029.2
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "084-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "085-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97866,
					38.92772,
					3152.16
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "085-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "086-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97794,
					38.927832,
					3144.15
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "086-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "087-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97733,
					38.927743,
					3138.24
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "087-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "088-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97787,
					38.926729,
					3139.76
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "088-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "089-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97325,
					38.927379,
					3044.68
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "089-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "090-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97334,
					38.927458,
					3045.26
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "090-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "091-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97306,
					38.927967,
					3032.24
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "091-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "092-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97312,
					38.928202,
					3031.32
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "092-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "093-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9734,
					38.928463,
					3032.95
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "093-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "094-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97371,
					38.928128,
					3048.46
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "094-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"094-ER18_1beMXKMRWRT7P9U2Rm1yoxRCrMIXLLgWh"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "095-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97988,
					38.927578,
					3165.58
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "095-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "096-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98066,
					38.927245,
					3180.45
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "096-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "097-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98023,
					38.927808,
					3170.12
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "097-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "098-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98033,
					38.927711,
					3171.06
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "098-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "099-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97424,
					38.927998,
					3069.28
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "099-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"099-ER18_1T07GTLSlpGq_9RuM0t2Fq1fCC6aCmr_t"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "100-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9742,
					38.927451,
					3077.65
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "100-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "101-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97426,
					38.927544,
					3079.03
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "101-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "102-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97347,
					38.927547,
					3048.63
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "102-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "103-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97291,
					38.927336,
					3038.18
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "103-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "104-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00545,
					38.987082,
					2955.93
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "104-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "105-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00534,
					38.986841,
					2954.84
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "105-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "106-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00494,
					38.986848,
					2953.96
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "106-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "107-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00471,
					38.986554,
					2952.31
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "107-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "108-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0047,
					38.986361,
					2950.58
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "108-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "109-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00489,
					38.98602,
					2947.52
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "109-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "110-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00492,
					38.985411,
					2940.13
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "110-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "111-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00491,
					38.985465,
					2940.9
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "111-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "112-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00547,
					38.986253,
					2955.41
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "112-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"112-ER18_1lsSYF7zkArl5H5sXzYW4et_eX-dzvbt7"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "113-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00538,
					38.986426,
					2955
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "113-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"113-ER18_106_ubACGiTICmmiFgC2Wf5T15sivR1jB"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "114-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00404,
					38.987348,
					2966.63
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "114-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"114-ER18_14g0HTeBKLDAh5yobMIwYArjSpjzBOmAP"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "115-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00394,
					38.9874,
					2967.78
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "115-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "116-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00558,
					38.988511,
					2968.41
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "116-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "117-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00561,
					38.988447,
					2967.81
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "117-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "118-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00654,
					38.989248,
					2970.64
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "118-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "119-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00665,
					38.989288,
					2968.88
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "119-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "120-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00887,
					38.982461,
					2964.56
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "120-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "121-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00933,
					38.982342,
					2979.21
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "121-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "122-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01017,
					38.982675,
					2998.26
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "122-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "123-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01022,
					38.98303,
					2997.76
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "123-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "124-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01162,
					38.939115,
					3022.1
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "124-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "125-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01153,
					38.938981,
					3019.03
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "125-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "126-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0124,
					38.939028,
					3015.09
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "126-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "127-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01264,
					38.938929,
					3011.67
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "127-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "128-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0137,
					38.939784,
					3017.55
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "128-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "129-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01378,
					38.939684,
					3015.03
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "129-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "130-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01349,
					38.937274,
					2973.76
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "130-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "131-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01288,
					38.937385,
					2972.51
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "131-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "132-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0116,
					38.937293,
					2983.35
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "132-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "133-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01195,
					38.936757,
					2974.71
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "133-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "134-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01314,
					38.937038,
					2970.01
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "134-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "135-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01269,
					38.936883,
					2967.18
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "135-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "136-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01241,
					38.936861,
					2967.62
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "136-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "137-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01263,
					38.936339,
					2962.59
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "137-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "138-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01205,
					38.935903,
					2963.7
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "138-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "139-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01223,
					38.935431,
					2957.13
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "139-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "140-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01352,
					38.935454,
					2952.68
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "140-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "141-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01332,
					38.93567,
					2955.36
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "141-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "142-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01307,
					38.936354,
					2962.8
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "142-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "143-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01315,
					38.936866,
					2968.12
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "143-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "144-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00244,
					38.98771,
					2990.99
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "144-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "145-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00247,
					38.987809,
					2991.52
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "145-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "146-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00264,
					38.987631,
					2987.21
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "146-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"146-ER18_1-OwEPmp6sxnw4tLDvz_E5Oqj20MtWKLn"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "147-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00288,
					38.987527,
					2983.41
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "147-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "148-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00309,
					38.987276,
					2979.28
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "148-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"148-ER18_19_T4PMNaRIjxwJ-9NhaKRIJPlqxgdW_i"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "149-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00317,
					38.98745,
					2979.26
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "149-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "150-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00333,
					38.987137,
					2975.75
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "150-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"150-ER18_1fo-POOVIIBgz83gY9u88e__FJxCUYFjL"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "151-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00323,
					38.987337,
					2978.18
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "151-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"151-ER18_1oWMOGNE9z66SO_0HyPtJTaebqcnHT79T"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "152-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00417,
					38.986541,
					2959.64
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "152-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"152-ER18_1W-coBV8w461fGMSKmtyA-2AQsbgHZ3es"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "153-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00337,
					38.987249,
					2976.35
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "153-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "154-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00975,
					38.982841,
					2983.5
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "154-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"154-ER18_18BDXgP_vi0tQDNSobF7QVw4aAlr_4RX1"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "155-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00373,
					38.987252,
					2972.41
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "155-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "156-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00959,
					38.982871,
					2978.63
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "156-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "157-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00945,
					38.982859,
					2973.98
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "157-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"157-ER18_1UezNOcqO3IWrFGZSoCiinPq_oNDi5Mso"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "158-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00941,
					38.982892,
					2972.8
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "158-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"158-ER18_1hEzk4cJ6aY8ogyopTpmg_UeOU-ZtZmR-"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "160-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00926,
					38.982966,
					2968.05
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "160-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"160-ER18_11zK1GzxPFiZJ2fRqI8vfDAcjni1S30IE"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "161-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00921,
					38.982985,
					2966.64
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "161-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "162-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00913,
					38.982996,
					2964.33
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "162-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "163-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.00903,
					38.983061,
					2961.79
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "163-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"163-ER18_1npne8tINalaObkCOJuX9SbG52QV72uoN",
						"163-ER18_1ANhwOSThPRki0Y7xFF7nlAWtEMBmbDBH"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "164-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0124,
					38.93742,
					2976.83
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "164-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "165-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01236,
					38.937357,
					2975.56
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "165-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"165-ER18_1jeSdTKlwP5Lqk_9STR3S1ZYyKg6FhY9C"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "166-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01252,
					38.937319,
					2974.16
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "166-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"166-ER18_17bKLO4Z7YVAFpM7shK0P6gMtPfMsOJ_s"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "167-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01258,
					38.937245,
					2972.16
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "167-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"167-ER18_15_--JO2X8fU-O2RpGYC0qpAtMzQB8duj"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "168-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0126,
					38.93711,
					2970.18
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "168-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "169-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01178,
					38.937476,
					2983.74
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "169-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"169-ER18_1_OgYM3Ksvke6ps7FYUIYqbAb1qwahmto"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "170-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01173,
					38.937422,
					2983.29
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "170-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "171-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01181,
					38.93729,
					2980.32
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "171-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"171-ER18_1-WuTyOd1QbAJK_s29mkn2Vf3zXRBrtx3"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "172-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01193,
					38.937374,
					2979.43
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "172-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "173-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01204,
					38.93721,
					2974.45
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "173-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"173-ER18_12z-ylJQChhpR4V-dq45xQUpd6CzPRwqt"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "174-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01191,
					38.936374,
					2972.36
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "174-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"174-ER18_1vwgJf0uavLajHlhSswqAKU4nbc_jK6BE"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "176-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.01189,
					38.936167,
					2964.84
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "176-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"176-ER18_1zV0CgdojVRhnTWd6zLnzjDO2aHI1ICM0"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "177-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09725,
					38.856311,
					3013.26
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "177-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "178-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09792,
					38.857553,
					3015.61
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "178-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "179-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09817,
					38.857521,
					3020.63
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "179-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "180-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0117,
					38.934887,
					2948.24
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "180-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"180-ER18_1uQwVuezg2cpUhis5iSrhWA1Z-xe_ODEG"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "181-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09871,
					38.856687,
					3040.65
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "181-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "182-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0121,
					38.934645,
					2945.93
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "182-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "183-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09169,
					38.857012,
					3010.53
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "183-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"183-ER18_17uYodbIHB3uiLzcQBeY-yfjDJrkPnp1L"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "184-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09118,
					38.857117,
					3027.74
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "184-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "185-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09113,
					38.858074,
					3071.35
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "185-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "186-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09214,
					38.858369,
					3042.65
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "186-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "187-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09264,
					38.857959,
					3017.84
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "187-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "188-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09175,
					38.856819,
					3006.08
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "188-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "189-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0969,
					38.858264,
					3006.9
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "189-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "190-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09675,
					38.857983,
					3004.74
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "190-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "191-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09682,
					38.857126,
					3007.18
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "191-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "192-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0971,
					38.856731,
					3010.31
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "192-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "193-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09639,
					38.8573,
					3003.35
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "193-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "194-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09508,
					38.857841,
					2999.46
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "194-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "195-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09274,
					38.856785,
					2995.2
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "195-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "196-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09232,
					38.857021,
					3000.07
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "196-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "197-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09209,
					38.856692,
					2998.93
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "197-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "198-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09268,
					38.857258,
					3006.03
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "198-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "199-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09749,
					38.857451,
					3011.82
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "199-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "200-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09735,
					38.857508,
					3010.96
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "200-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"200-ER18_10DcO41RMUoBIuGjs9frEoplr3eOWIJU-"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "201-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09717,
					38.857565,
					3009.63
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "201-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"201-ER18_1tdmVgdBHU74V55Q-l7cHDdof2zxPyizu"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "202-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09716,
					38.857651,
					3009.48
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "202-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "204-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09238,
					38.856574,
					2995.43
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "204-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "205-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09219,
					38.856762,
					2999.01
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "205-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"205-ER18_1w7TqgHxCmIHCMgitBRdfYCnjdHZLHpNH"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "206-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09215,
					38.856826,
					2999.01
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "206-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "207-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0921,
					38.856899,
					3000.87
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "207-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"207-ER18_1jRKZsJ_y9RD-_WvOud5ZffiNy3_VrmSC"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "208-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09785,
					38.857287,
					3016.45
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "208-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"208-ER18_1VGRhSyp_HI71gCtLzZ5wJ8xEpYw4B3Jw"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "211-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09195,
					38.85705,
					3007.93
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "211-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "212-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0919,
					38.857119,
					3009.66
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "212-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"212-ER18_1nKQL7O0kZuVzLf2s-40NfwPfdvbqYHe-"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "213-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09185,
					38.857161,
					3014.48
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "213-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"213-ER18_1AgDi0crTOPD935yS5AsmP8VBCecI0ycz"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "214-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09175,
					38.857266,
					3020.15
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "214-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "215-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0917,
					38.85733,
					3024.08
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "215-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "216-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09163,
					38.857385,
					3025.81
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "216-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"216-ER18_193omF-S7wJaXGlHXc-Pn-HEfaO3NCpC5"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "217-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0917,
					38.857654,
					3036.37
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "217-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "218-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.09158,
					38.857769,
					3043.14
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "218-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "219-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03002,
					38.962247,
					3227.97
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "219-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "220-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03009,
					38.962189,
					3225.46
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "220-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "221-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03015,
					38.962125,
					3222.39
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "221-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "222-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0302,
					38.962079,
					3219.92
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "222-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"222-ER18_1LZQkGW08nb81XDBKajs3Cn9Ck8Nxqqa5"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "223-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03019,
					38.961962,
					3215.12
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "223-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"223-ER18_16vNt1do6cn1CkXeHNuiwql7gVVUKJhoF"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "224-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0303,
					38.961815,
					3206.89
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "224-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"224-ER18_1PWG_WKXNhXwNnFg9L29aW0Cdyvd0RuS7"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "225-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03037,
					38.961778,
					3204.89
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "225-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"225-ER18_1m7RnEjiBQ9UwTFg-kzFGa7-57fC8VWjA"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "226-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03044,
					38.961795,
					3204.77
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "226-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"226-ER18_1sBH0jKo2XU6MKPY_pphbVmyz2uhtXBMA"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "227-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0305,
					38.961713,
					3202.47
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "227-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "228-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03059,
					38.961576,
					3199.78
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "228-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"228-ER18_1k1ybMEpgXdTZF3Nob5eZSdoazA6kv0fu"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "229-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02964,
					38.961823,
					3216.4
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "229-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "232-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02962,
					38.961553,
					3202.35
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "232-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "233-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0296,
					38.961518,
					3200.13
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "233-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"233-ER18_1CQWeohxZLZiteioJY43f-Sa-vOKUl9kh"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "234-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02963,
					38.961494,
					3199.31
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "234-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "235-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02981,
					38.961441,
					3199.84
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "235-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"235-ER18_1g-JwthCseLkOrVNz9lal7OaAU48gsUG4"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "236-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02966,
					38.960791,
					3164.13
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "236-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"236-ER18_1depuYlP4j1cX7yqjkcqORYpF_-iqIkFS"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "237-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02968,
					38.960682,
					3161.38
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "237-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"237-ER18_1urdwji2Ok3pTd32quo8Kx8K6H_uAsjeq",
						"237-ER18_1QxcFX9CO_ucZODzkG4gplksMJudpmmkg"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "238-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02971,
					38.960587,
					3159.32
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "238-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "239-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02957,
					38.962414,
					3233.09
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "239-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"239-ER18_1hCSVs0gvqaeUVrX8Hxre4P9sHliPf4qh"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "240-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02979,
					38.962537,
					3236.89
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "240-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "241-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02954,
					38.961612,
					3204.04
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "241-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "242-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02935,
					38.96149,
					3195.4
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "242-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "243-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03009,
					38.961143,
					3191.89
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "243-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "244-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02954,
					38.960816,
					3161.49
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "244-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "245-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02959,
					38.960684,
					3158.5
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "245-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "246-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02957,
					38.960306,
					3147.9
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "246-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "247-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02961,
					38.960089,
					3145.97
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "247-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "248-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03197,
					38.960647,
					3163.1
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "248-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "249-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0286,
					38.961513,
					3187.64
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "249-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "250-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02901,
					38.961528,
					3195.95
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "250-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "251-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02864,
					38.961855,
					3204.46
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "251-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "252-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02884,
					38.962088,
					3215.69
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "252-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "253-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02937,
					38.962148,
					3229.51
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "253-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "254-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02937,
					38.962183,
					3230.45
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "254-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"254-ER18_1p4XoC_47NIpg3pvJTXj0OOFy9d_nNQ8V"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "255-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02935,
					38.963379,
					3246.54
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "255-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "256-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02836,
					38.963368,
					3248.29
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "256-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "257-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02731,
					38.963425,
					3246.35
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "257-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "258-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02993,
					38.962724,
					3234.95
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "258-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"258-ER18_1fxyBxofnQ1CqWiwB-RirtICzChxm5ynR"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "259-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0402,
					38.979452,
					3480.61
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "259-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "260-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04046,
					38.979704,
					3479.88
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "260-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "261-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04043,
					38.979984,
					3477.72
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "261-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "262-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04003,
					38.980581,
					3473.56
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "262-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "263-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04028,
					38.980202,
					3475.44
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "263-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "264-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04012,
					38.980142,
					3475.39
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "264-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "265-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03998,
					38.98046,
					3473.23
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "265-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "266-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04013,
					38.980912,
					3473.95
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "266-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "267-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04022,
					38.980898,
					3474.2
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "267-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "268-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04031,
					38.981207,
					3476.1
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "268-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "269-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03777,
					38.979832,
					3456.63
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "269-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "270-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0381,
					38.979831,
					3462.01
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "270-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"270-ER18_17iMPPsAkiqIn05H6DYZjtw0w-6vENmp9"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "271-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03836,
					38.979362,
					3464.21
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "271-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "272-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03822,
					38.979392,
					3462.01
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "272-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"272-ER18_1QtgikUX5qUFIJuGNDfAIRaFOiGubt2IA"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "273-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03773,
					38.97945,
					3455.91
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "273-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"273-ER18_1AXILP_ZSU7ijBcOvPkZlo373KX-AO6mp"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "274-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03774,
					38.979414,
					3456.2
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "274-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "275-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03769,
					38.979185,
					3456.65
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "275-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "276-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03751,
					38.979116,
					3455.35
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "276-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "277-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03745,
					38.978788,
					3457.26
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "277-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "278-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03767,
					38.9786,
					3459.62
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "278-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"278-ER18_1CgFWCj3l6d2-ptq7QOXmdGkX_obn3nkc"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "279-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03737,
					38.978592,
					3458.85
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "279-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "280-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03751,
					38.979251,
					3455.57
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "280-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "281-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03778,
					38.979314,
					3457.53
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "281-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "282-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03785,
					38.97966,
					3457.15
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "282-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "283-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0399,
					38.98052,
					3473.67
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "283-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "284-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03988,
					38.981278,
					3478.23
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "284-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"284-ER18_1VTFJGD_YFp1yyh2SZylr32_QwW5csKQb"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "285-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03847,
					38.980509,
					3461.97
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "285-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "286-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03893,
					38.980663,
					3474.22
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "286-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "287-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03893,
					38.980686,
					3474.06
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "287-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"287-ER18_1ieEPa4YmNIw25tb0QYFIQOs-d6lBRfwX"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "288-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03857,
					38.979679,
					3469.84
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "288-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "289-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03665,
					38.979871,
					3450.65
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "289-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "290-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03585,
					38.978912,
					3458.41
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "290-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "291-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03632,
					38.980041,
					3443.7
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "291-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "292-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03926,
					38.978067,
					3492.2
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "292-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "293-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03573,
					38.978463,
					3456.65
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "293-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "294-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03575,
					38.978888,
					3456.92
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "294-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "295-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03639,
					38.979906,
					3445.88
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "295-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "296-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0396,
					38.978468,
					3492.55
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "296-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "297-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.03963,
					38.977129,
					3490.8
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "297-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "298-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04031,
					38.97827,
					3497.88
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "298-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "299-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0274,
					38.907007,
					2733.41
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "299-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "300-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02809,
					38.907654,
					2730.62
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "300-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "301-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02865,
					38.908321,
					2731.5
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "301-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "302-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02874,
					38.90806,
					2733.19
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "302-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "303-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02892,
					38.908083,
					2737.43
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "303-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "304-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0299,
					38.908741,
					2745.76
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "304-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "305-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02978,
					38.908667,
					2746.46
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "305-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "306-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02926,
					38.90706,
					2755.36
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "306-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "307-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02886,
					38.906297,
					2769.56
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "307-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "308-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02896,
					38.90657,
					2760.17
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "308-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "309-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02818,
					38.90939,
					2726.03
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "309-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "310-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02831,
					38.909482,
					2726.17
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "310-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "311-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02835,
					38.909473,
					2726.34
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "311-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "312-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02866,
					38.909423,
					2726.83
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "312-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "313-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02862,
					38.90973,
					2726.87
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "313-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "314-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0286,
					38.909654,
					2726.73
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "314-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "315-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02843,
					38.909576,
					2726.51
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "315-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "316-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02849,
					38.909457,
					2726.5
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "316-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "317-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02858,
					38.909415,
					2726.66
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "317-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"317-ER18_1Rn1MZwEQauRXv4E0tRXmw5Klbdh1v0Aq"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "318-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02831,
					38.909569,
					2726.13
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "318-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "319-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06696,
					38.952952,
					2883.41
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "319-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "320-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06696,
					38.952891,
					2883.41
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "320-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "321-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06674,
					38.95335,
					2890.66
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "321-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "322-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06691,
					38.953516,
					2893.61
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "322-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "323-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06711,
					38.953568,
					2896.35
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "323-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "324-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98549,
					38.957479,
					2916.09
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "324-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "325-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.9861,
					38.957997,
					2908.71
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "325-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "326-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98464,
					38.95805,
					2916.91
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "326-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "327-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.98438,
					38.958101,
					2917.97
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "327-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "328-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06741,
					38.953243,
					2894.86
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "328-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "329-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06733,
					38.953296,
					2894.27
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "329-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "330-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06791,
					38.953702,
					2906.25
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "330-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "331-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06753,
					38.953876,
					2906.18
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "331-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "332-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06807,
					38.953579,
					2905.67
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "332-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "333-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06487,
					38.975674,
					2998.96
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "333-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "334-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06722,
					38.952801,
					2883.82
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "334-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "335-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06711,
					38.952763,
					2881.27
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "335-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "336-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06705,
					38.9528,
					2882.72
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "336-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "337-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06678,
					38.952661,
					2877.43
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "337-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"337-ER18_1lyDUiGxnLJyiwN2rZ5-z4l-ntHZENa0X"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "338-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06667,
					38.952748,
					2877.59
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "338-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "340-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06636,
					38.952785,
					2877.36
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "340-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "341-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06637,
					38.952902,
					2878.61
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "341-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"341-ER18_1O4MSttpj5RtBt6b9lU26o4QgFX5CAsaA"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "342-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06627,
					38.953093,
					2880.84
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "342-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "343-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06613,
					38.953073,
					2879.83
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "343-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"343-ER18_1J_a5z9ckwcvGbHoJIwY3aBB3CxhD84II"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "344-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06632,
					38.952732,
					2876.14
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "344-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "345-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06618,
					38.952445,
					2872.37
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "345-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "346-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0667,
					38.952428,
					2875.62
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "346-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "347-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06704,
					38.952701,
					2881.27
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "347-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "348-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06774,
					38.953783,
					2906.58
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "348-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "349-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06753,
					38.953783,
					2903.89
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "349-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "351-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06403,
					38.989335,
					3437.11
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "351-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "352-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06428,
					38.98921,
					3440.71
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "352-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "353-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06434,
					38.989272,
					3438.84
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "353-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "354-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06911,
					38.953949,
					2924.38
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "354-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "355-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06925,
					38.953869,
					2921.28
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "355-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "356-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06977,
					38.953725,
					2916.91
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "356-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "357-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06974,
					38.953478,
					2908.47
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "357-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "358-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06927,
					38.953445,
					2909.54
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "358-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "359-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06983,
					38.95326,
					2902
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "359-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "360-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06871,
					38.953212,
					2902.16
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "360-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "361-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06758,
					38.953502,
					2898.55
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "361-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "362-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0677,
					38.953618,
					2904.24
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "362-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "363-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06715,
					38.953153,
					2891.36
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "363-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "364-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06541,
					38.991428,
					3453.73
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "364-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "365-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06522,
					38.991519,
					3451.4
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "365-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "366-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0649,
					38.991636,
					3443.54
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "366-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "367-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06479,
					38.991665,
					3440.87
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "367-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "368-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06468,
					38.991559,
					3434.98
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "368-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"368-ER18_1cGl5DXpWPTkXLMNKsrOU-etD_l9eYWZA"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "369-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06465,
					38.991361,
					3429.36
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "369-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"369-ER18_1J6pe2wjx-b3k5ujo_oMpOxSkxqoM7ODP"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "370-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06455,
					38.991227,
					3424.96
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "370-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "371-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06448,
					38.991121,
					3421.34
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "371-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "372-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06427,
					38.991034,
					3415.86
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "372-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "373-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06413,
					38.990856,
					3412.45
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "373-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "374-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06267,
					38.990756,
					3389.68
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "374-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "375-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06228,
					38.990709,
					3387.96
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "375-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "376-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06166,
					38.990558,
					3386.2
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "376-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "377-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06088,
					38.991022,
					3378.62
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "377-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "378-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06046,
					38.990831,
					3383.54
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "378-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "379-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06005,
					38.990865,
					3385
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "379-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "381-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.05987,
					38.990445,
					3389.78
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "381-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "382-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.05975,
					38.990447,
					3390.16
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "382-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "383-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.05959,
					38.990356,
					3392.88
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "383-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "384-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06461,
					38.992046,
					3447.44
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "384-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "385-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06442,
					38.992055,
					3441.27
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "385-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "386-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06408,
					38.992416,
					3441.85
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "386-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "387-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0636,
					38.992294,
					3413.94
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "387-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "388-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06302,
					38.991552,
					3389.74
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "388-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "389-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06242,
					38.991518,
					3382.27
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "389-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "390-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06234,
					38.990631,
					3389.59
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "390-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "391-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06139,
					38.990639,
					3385.49
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "391-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "392-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.05997,
					38.990704,
					3387
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "392-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "393-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.05914,
					38.990715,
					3391.9
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "393-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": [
						"393-ER18_1Z8pd8qK3S4QB2Kjdu9eVihIIw4nzpTL4"
					]
				}
			}
		},
		{
			"type": "Feature",
			"id": "394-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0644,
					38.989216,
					3440.8
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "394-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "395-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06424,
					38.988792,
					3442.72
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "395-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "396-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06388,
					38.9893,
					3435.13
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "396-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "397-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06344,
					38.989602,
					3423.56
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "397-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "398-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06312,
					38.98909,
					3430.72
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "398-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "399-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06325,
					38.989172,
					3431.29
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "399-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "400-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06382,
					38.97594,
					3041.92
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "400-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "401-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06378,
					38.975831,
					3051
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "401-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "402-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06352,
					38.975857,
					3056.3
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "402-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "403-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06331,
					38.975994,
					3064.45
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "403-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "404-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06568,
					38.975692,
					2977.38
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "404-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "405-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06552,
					38.97556,
					2980.43
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "405-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "406-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06564,
					38.975531,
					2978.53
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "406-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "407-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06558,
					38.975221,
					2976.52
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "407-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "408-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06562,
					38.975071,
					2977.02
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "408-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "409-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06551,
					38.974974,
					2979.31
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "409-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "410-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06558,
					38.974878,
					2977.69
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "410-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "411-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06562,
					38.974729,
					2978.05
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "411-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "412-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0652,
					38.97452,
					2985.73
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "412-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "413-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0653,
					38.974396,
					2982.31
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "413-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "414-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06555,
					38.975789,
					2980.27
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "414-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "415-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06535,
					38.975698,
					2984.24
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "415-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "416-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.065,
					38.975754,
					2993.16
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "416-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "417-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0647,
					38.97593,
					3001.66
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "417-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "418-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06644,
					38.97694,
					2977.67
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "418-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "419-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06641,
					38.977012,
					2978.75
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "419-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "420-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06668,
					38.976832,
					2980.35
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "420-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "421-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06676,
					38.976971,
					2984.65
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "421-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "422-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06559,
					38.97591,
					2978.58
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "422-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "423-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06535,
					38.975828,
					2983.84
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "423-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "424-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06658,
					38.974811,
					2964.96
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "424-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "425-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06672,
					38.974758,
					2964.12
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "425-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "426-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06677,
					38.975046,
					2964.2
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "426-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "427-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06602,
					38.97565,
					2972.34
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "427-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "428-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06549,
					38.975754,
					2980.27
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "428-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "429-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06511,
					38.975779,
					2987.5
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "429-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "430-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06518,
					38.975525,
					2989.65
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "430-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "431-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06751,
					38.975574,
					2981.98
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "431-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "432-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06731,
					38.976189,
					2984.54
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "432-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "433-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06686,
					38.976758,
					2982.63
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "433-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "434-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06353,
					38.976855,
					3054.84
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "434-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "435-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06337,
					38.976918,
					3059.27
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "435-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "436-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0641,
					38.976571,
					3023.66
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "436-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "437-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06487,
					38.976806,
					2995.51
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "437-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "438-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06498,
					38.976789,
					2993.02
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "438-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "439-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06691,
					38.975495,
					2966.36
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "439-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "440-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06729,
					38.975447,
					2971.7
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "440-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "441-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0672,
					38.975526,
					2971.76
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "441-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "442-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06711,
					38.975468,
					2969.97
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "442-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "443-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.06702,
					38.97547,
					2967.95
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "443-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "447-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.05535,
					38.895138,
					3265.29
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "447-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "448-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0553,
					38.894959,
					3266.14
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "448-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "449-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.05534,
					38.894922,
					3266.14
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "449-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "450-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.05517,
					38.894319,
					3271.1
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "450-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "451-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.05524,
					38.894302,
					3271.3
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "451-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "452-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.05528,
					38.894333,
					3271.7
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "452-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "453-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.05509,
					38.894282,
					3270.97
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "453-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "458-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04709,
					38.861323,
					2866
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "458-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "459-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04691,
					38.861282,
					2865.42
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "459-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "460-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04667,
					38.861097,
					2865.48
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "460-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "461-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.05529,
					38.894031,
					3276.55
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "461-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "462-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.05315,
					38.894447,
					3280.86
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "462-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "463-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04699,
					38.860938,
					2866.13
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "463-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "464-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.047,
					38.86105,
					2866
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "464-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "465-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04009,
					38.862329,
					2855.44
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "465-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "466-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04016,
					38.862215,
					2854.48
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "466-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "467-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04039,
					38.862218,
					2856.94
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "467-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "468-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04049,
					38.862282,
					2858.77
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "468-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Meadow Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "469-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02304,
					38.867383,
					2807.18
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "469-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "470-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02271,
					38.867429,
					2807.03
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "470-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "471-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.0222,
					38.867677,
					2806.1
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "471-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "472-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.02183,
					38.867855,
					2805.36
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "472-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Shrub Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "474-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04218,
					38.868239,
					3016.57
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "474-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "475-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04175,
					38.867972,
					3010.1
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "475-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "476-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04173,
					38.867825,
					3004.68
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "476-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "477-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04137,
					38.866244,
					2961.75
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "477-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "478-ER18",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-107.04082,
					38.866244,
					2955.75
				]
			},
			"properties": {
				"contact": {
					"name": "Dana Chadwick",
					"email": "kdc@stanford.edu",
					"affiliation": "Stanford University"
				},
				"id": "478-ER18",
				"name": "2018 NEON Hyperspectral Ground Campaign",
				"category": "SFA One-off Sampling",
				"instrumentation": "",
				"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
				"description": "Temporary 2018 Tree Sampling Site",
				"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
				"measurement_categories": [
					"hydrogeology",
					"biogeochemistry",
					"vegetation"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SAI1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.987746,
					38.956192,
					2887.44
				]
			},
			"properties": {
				"contact": {
					"name": "Daniel Feldman",
					"email": "drfeldman@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-SAI1",
				"name": "SAIL Main Site Container",
				"category": "SFA Collaborator",
				"instrumentation": "Radar Wind Profiler (RWP), Ka-band ARM Zenith Radar (KAZR), Doppler Lidar (DL), Micropulse Lidar (MPL), Ceilometer (CEIL), High-spectral-resolution Lidar (HSRL), Marine-Atmosphere Emitted Radiance Interferometer (MAERI), Total Sky Imager (TSI), Microwave radiometer (MWR), Multi-filter Rotating Shadowband Radiometer (MFRSR)",
				"research_theme": "Surface atmosphere interactions",
				"description": "Integrated field observations to study surface atmosphere interactions and their impacts on mountainous water cycles. SAIL container measurements (remote sensing).",
				"variables_measured": "Atmospheric turbulence, wind, aerosol and cloud backscatter profiles, precipitation, downwelling infrared spectral radiation, cloud fraction, precipitable water vapor, liquid water path, narrowband shortwave radiation, aerosol optical depth",
				"measurement_categories": [
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SAI2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.973117,
					38.941398,
					2856.5
				]
			},
			"properties": {
				"contact": {
					"name": "Daniel Feldman",
					"email": "drfeldman@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-SAI2",
				"name": "SAIL Main Site Field",
				"category": "SFA Collaborator",
				"instrumentation": "Eddy correlation flux measurement system (ECOR), Surface energy balance system (SEBS)",
				"research_theme": "Surface atmosphere interactions",
				"description": "Integrated field observations to study surface atmosphere interactions and their impacts on mountainous water cycles. SAIL field measurements.",
				"variables_measured": "Surface turbulent fluxes, upwelling and downwelling radiation",
				"measurement_categories": [
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-SAI3",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.943266,
					38.898356,
					3137.72
				]
			},
			"properties": {
				"contact": {
					"name": "Daniel Feldman",
					"email": "drfeldman@lbl.gov",
					"affiliation": "Lawrence Berkeley National Laboratory"
				},
				"id": "ER-SAI3",
				"name": "SAIL Supplementary Site",
				"category": "SFA Collaborator",
				"instrumentation": "Atmosphere Observing System (AOS), X-band radar",
				"research_theme": "Atmosheric aerosol and precipitation",
				"description": "ARM aerosol observing system for aerosol observations and CSU X-band Radar for precipitation observations. SAIL AOS and X-band radar measurements.",
				"variables_measured": "Aerosol chemical composition, cloud condensation nuclei, CO/H2O/N2O concentration, aerosol concentration, aerosol particle size distribution, ozone concentration, black carbon concentration, aerosol absorption and extinction, precipitation",
				"measurement_categories": [
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-RJY1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.853011,
					38.716829,
					2494.96
				]
			},
			"properties": {
				"contact": {
					"name": "Gijs de Boer",
					"email": "gijs.deboer@colorado.edu",
					"affiliation": "University of Colorado / NOAA PSL"
				},
				"id": "ER-RJY1",
				"name": "SPLASH Roaring Judy",
				"category": "SFA Collaborator",
				"instrumentation": "Instrumentation information to be added soon",
				"research_theme": "Atmospheric science and surface energy exchange",
				"description": "Observing site for the Study of Precipitation, the Lower Atmosphere, and Surface for Hydrometeorology (SPLASH). This entry provides information on the location of the SPLASH observing sites. Individual sensor information is available via the East River Sensor Listing correlated with the Location_ID",
				"variables_measured": "Variable information to be added soon",
				"measurement_categories": [
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-BCK1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.921055,
					38.8589,
					2719.64
				]
			},
			"properties": {
				"contact": {
					"name": "Gijs de Boer",
					"email": "gijs.deboer@colorado.edu",
					"affiliation": "University of Colorado / NOAA PSL"
				},
				"id": "ER-BCK1",
				"name": "SPLASH Brush Creek",
				"category": "SFA Collaborator",
				"instrumentation": "Instrumentation information to be added soon",
				"research_theme": "Atmospheric science and surface energy exchange",
				"description": "Observing site for the Study of Precipitation, the Lower Atmosphere, and Surface for Hydrometeorology (SPLASH). This entry provides information on the location of the SPLASH observing sites. Individual sensor information is available via the East River Sensor Listing correlated with the Location_ID",
				"variables_measured": "Variable information to be added soon",
				"measurement_categories": [
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-KPS2",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.97021,
					38.939909,
					2848.21
				]
			},
			"properties": {
				"contact": {
					"name": "Gijs de Boer",
					"email": "gijs.deboer@colorado.edu",
					"affiliation": "University of Colorado / NOAA PSL"
				},
				"id": "ER-KPS2",
				"name": "SPLASH Kettle Ponds Annex",
				"category": "SFA Collaborator",
				"instrumentation": "Instrumentation information to be added soon",
				"research_theme": "Atmospheric science and surface energy exchange",
				"description": "Observing site for the Study of Precipitation, the Lower Atmosphere, and Surface for Hydrometeorology (SPLASH). This entry provides information on the location of the SPLASH observing sites. Individual sensor information is available via the East River Sensor Listing correlated with the Location_ID",
				"variables_measured": "Variable information to be added soon",
				"measurement_categories": [
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-KPS1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.973021,
					38.941797,
					2858.48
				]
			},
			"properties": {
				"contact": {
					"name": "Gijs de Boer",
					"email": "gijs.deboer@colorado.edu",
					"affiliation": "University of Colorado / NOAA PSL"
				},
				"id": "ER-KPS1",
				"name": "SPLASH Kettle Ponds",
				"category": "SFA Collaborator",
				"instrumentation": "Instrumentation information to be added soon",
				"research_theme": "Atmospheric science and surface energy exchange",
				"description": "Observing site for the Study of Precipitation, the Lower Atmosphere, and Surface for Hydrometeorology (SPLASH). This entry provides information on the location of the SPLASH observing sites. Individual sensor information is available via the East River Sensor Listing correlated with the Location_ID",
				"variables_measured": "Variable information to be added soon",
				"measurement_categories": [
					"climate"
				],
				"links": {
					"images": []
				}
			}
		},
		{
			"type": "Feature",
			"id": "ER-APY1",
			"geometry": {
				"type": "Point",
				"coordinates": [
					-106.996983,
					38.972585,
					2925.07
				]
			},
			"properties": {
				"contact": {
					"name": "Gijs de Boer",
					"email": "gijs.deboer@colorado.edu",
					"affiliation": "University of Colorado / NOAA PSL"
				},
				"id": "ER-APY1",
				"name": "SPLASH Avery Picnic",
				"category": "SFA Collaborator",
				"instrumentation": "Instrumentation information to be added soon",
				"research_theme": "Atmospheric science and surface energy exchange",
				"description": "Observing site for the Study of Precipitation, the Lower Atmosphere, and Surface for Hydrometeorology (SPLASH). This entry provides information on the location of the SPLASH observing sites. Individual sensor information is available via the East River Sensor Listing correlated with the Location_ID",
				"variables_measured": "Variable information to be added soon",
				"measurement_categories": [
					"climate"
				],
				"links": {
					"images": []
				}
			}
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/sites.json
// module id = 156
// module chunks = 0